var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearFromYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HearFromYou_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 649.84 217.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .HearFromYou-1 {\n        fill: #e42a3b;\n      }\n\n      .HearFromYou-2 {\n        font-family: 'nexa-rust-sans-black-2';\n        font-size: 87.28px;\n      }\n\n      .HearFromYou-2, .HearFromYou-3 {\n        fill: #ee3337;\n      }\n\n      .HearFromYou-3 {\n        font-family: RedSoxNationNormal, RedSoxNation;\n        font-size: 52.65px;\n      }\n\n      .HearFromYou-4 {\n        fill: #f0e2cb;\n      }\n\n      .HearFromYou-5 {\n        letter-spacing: -.08em;\n      }\n\n      .HearFromYou-6 {\n        letter-spacing: -.06em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HearFromYou_1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "HearFromYou-3",
    transform: "translate(79.89 167.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "  to Hear from You")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "HearFromYou-2",
    transform: "translate(99.08 94.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "We "), /*#__PURE__*/React.createElement("tspan", {
    className: "HearFromYou-6",
    x: 196.29,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "HearFromYou-5",
    x: 249.01,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 318.22,
    y: 0
  }, "VE")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.71,12.48c-.02-.07-.3.25-.36.29.14,0,.43-.37.36-.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "3.11 12.47 2.98 12.58 3.37 12.37 3.11 12.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M3.79,13.1c.4-.6-.32-.14-.28-.44l.09-.14-.44.38c.21.07.66-.04.63.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M3.18,14.6c.15-.23.24-.11-.04-.14-.01.03-.02.05-.03.07.02,0,.04.03.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M3.11,14.53c-.09-.05-.1.22,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M3.58,14.7l-.26.11c-.08.14-.01.25-.12.31.19-.02.27-.16.38-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.01,14.37l-.12.04c-.03.06-.04.09.12-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M3.64,14.49l.25-.08c.06-.1.2-.28-.1.02.14-.16,0-.02-.15.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M3.64,14.36c.04-.17.03-.3.29-.41-.26-.08-.55.33-.29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.31,12.57l.07-.22-.22.13c.11-.06,0,.27.15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4,15.51c.1-.11.21-.35.33-.51l-.18.08c-.03.11,0,.25-.14.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.33,15l.27-.11c-.08-.11-.18-.02-.27.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "4.53 13.77 4 14.05 4.57 13.8 4.53 13.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "4.43 15.88 4.15 16.11 4.59 15.78 4.43 15.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.77,16.05c-.22.2-.23.44-.39.55.11.02.33-.13.53-.27-.14.05-.19-.03-.14-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.21,16.15c-.07.03-.18.11-.3.19.08-.03.17-.08.3-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.75,15.11c-.05.08-.18.28-.17.42l.22-.38-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.8,15.13h0c.04.06.07.09.08.11,0-.01-.03-.05-.08-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.74,15.09h.01s.03-.04-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.58,14.31c.22-.13.51-.23.6-.62-.23.19-.28.42-.6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.01,14.63l-.06-.17c-.07.09-.15.24-.25.31l.31-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "5.15 14.57 5.01 14.63 5.03 14.69 5.15 14.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.23,15.67c.16-.11.23-.08.32-.06-.02-.12-.07-.21-.14-.26-.09.1-.26.27-.18.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.04,15.38h.03s.02-.06-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M6.2,16.08s.02-.05.03-.07l-.05.06h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.45,15.28c0-.1-.1-.04-.21.04.07,0,.12,0,.17.03.04-.05.07-.08.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.51,16.12c.02-.09.04-.18.05-.26-.05.13-.12.34-.05.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.02,15.48h-.02c-.04.1-.01.06.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.02,15.48c.06-.03.15-.1.23-.16-.05,0-.11.02-.17.05-.01.03-.03.07-.05.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.97,13.98c-.24.32-.58.52-.45.09-.28.16-.97,1.27-1.29,1.94.1-.14.2-.27.45-.37.08-.21.03-.6.33-.82.27-.05.05.21,0,.43.22-.45.61-.44.99-1.07l-.28.11c.06-.09.21-.21.24-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M6.03,15.81h-.08c.02.1-.03.26-.14.57.2-.1.3-.2.38-.31l-.22-.22.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.72,15.65c.29-.32.52-.38.72-.81-.16-.08-.31.22-.51.31.3.08-.21.14-.18.47-.09.02-.15.01-.2,0,.01.07.02.16,0,.25v-.03s0,0,0,0h0c.02-.06.04-.08.03-.05,0,0,.01,0,.01,0,.04-.05.07-.09.11-.12.02.12-.05.1-.11.12l-.04.05h0s.38-.01.38-.01c-.02-.08-.09-.12-.23-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.87,13.06s-.04.06-.05.08c.05-.03.07-.05.05-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.8,13.34c-.05.03-.17.16-.2.08.03-.14.13-.16.21-.28-.1.06-.3.15-.33.4l.05-.03c0,.19-.22.71-.27.74.21-.33.36-.56.53-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.82,14.42l.32-.03.13-.37-.13.18c-.06-.15-.2.09-.32.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "6.1 16.28 5.81 16.63 6.3 16.19 6.1 16.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "6.39 16.42 6.15 16.74 6.36 16.59 6.39 16.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.81,20.69l.12-.06s-.08.04-.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.39,20.42l-.11.16c.07-.08.12-.15.11-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M12.97,20.38c-.09.37-.27.93-.06.53l.18-.4c-.1.03-.12-.03-.12-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.7,20.51s.02-.09.04-.13c-.09.12-.18.23-.25.33.07-.06.14-.13.22-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.6,18.95l-.02.31c.02-.1.03-.2.02-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M26.45,21.7l.3-.33c-.11-.07-.18.15-.3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M9.19,18.05c-.01.19.01.29.05.34.04-.27.16-.63-.05-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.39,24.61c.07-.05.13-.12.18-.2-.07.04-.13.1-.18.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M9.46,18.52s0-.07.01-.11c-.09.03-.18.04-.23-.02-.03.2-.01.34.22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.35,28.14s-.01.03-.02.05c.04-.04.03-.05.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.18,33.35s-.09-.02-.14-.04c0,.04.05.06.14.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.35,17.29c-.07-.01-.04.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M8.03,15.68s.08-.08.14-.16c-.06.08-.11.13-.14.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M11.41,16.54h0c.03-.08.02-.06,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.37,17.07c0,.06,0,.11,0,.15,0-.04,0-.08,0-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.27,17.25s-.02-.05-.03-.07c-.05.06-.07.1.03.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.44,17.32s-.05-.05-.07-.1c0,.03-.01.06-.03.07.02,0,.05.01.09.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M29.54,25.61s0,.02-.01.04c.16-.1.12-.1.01-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "16.59 17.22 16.58 17.23 16.58 17.25 16.59 17.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M16.95,17.04c-.34.43-.36.35-.37.21l-.53,1.14.9-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.93,21.19l.05-.42c.5-.45.51-.19.65-.74-.7,1.16-.64-.21-1.33.96l.05-.3s.06-.04.08-.01c.14-.67-.62.77-.76.47-.03-.14,0-.34.14-.45l-.35.19c-.04-.05.09-.25.13-.2l-.33-.06.02-.03c-.14.16-.39.4-.51.5.02-.21.11-.11.17-.26l-.31.2c.11-.34.4-.57.48-.47.51-1.27-.29.23-.23-.64l.23-.07c.28-.73.03-.55.09-1.06-.08.24-.25,1.25-.58,1.45,0-.12-.04-.19-.26,0,.23-.42.08-.37-.04-.41l.31-.56c-.21.1-.36.39-.56.6-.1-.13.1-.58.27-.96-.17-.2-.23.78-.54.75-.06-.31-.31-.15-.71.07-.02-.26.21-.33.25-.52l-.35.39s.06-.16.1-.23c-.19.12-.31.56-.54.63-.37.6.18-1.07-.37-.46.04-.18.21-.33.31-.56-.5.33-.39.22-.93.74l.02-.46c-.1.49-.53.91-.89,1.24-.06.23-.12.43-.14.53l-.39.18c.02-.11.15-.29.31-.51-.04.04-.08.08-.11.11.03-.25.24-.56.47-.84-.03.13-.07.26-.1.39.24-.31.49-.67.66-1-.05.06-.11.1-.16.11.06-.09.12-.16.14-.22.02-.06-.07.05-.18.17l.28-.66-.15.24-.09-.55c-.55.52-1.23,1.36-1.71,1.44.33-.42.42-.75.71-1.29-.22.63.39-.11.51.1-.06-.11.1-.36.17-.44l-.59.36c.24-.44.11-.37.13-.6-.41.92-.55.47-.82.67.15-.3.34-.59.46-.43.18-.76-.77.92-.64.27.04.01.04.07.13-.07-.23.22-.33-.11-.14-.34h.04c-.19-.22-.76-.4-1.2.33.05-.1.52-.89.61-1.03l-1.8,2.28c.39-.62,1.06-2.23,1.46-2.49-.01-.12-.03-.27-.27-.11,0,.11-.4.98-.49,1.01.23-.8.1-.44.24-1.15-.01.17-.63,1.14-.7,1.06.1-.14.53-1,.62-1.08l-.77.86c.16-.15.47-.83.57-1.14-.08.21-.19-.13-.31-.07l-.03.28c-.18-.29-1.02,1.24-1.26,1.04.14-.19.77-1.21.7-1.41-.34.47-1.62,2.27-2.07,2.53l.11-.31-.37.22c.54-.69,1.74-2.11,2.26-2.64.03-.28.16-.35,0-.41.1-.3.31-.36.36-.36l-.25-.36c-.31.6-.59.44-.85.94l.71-.4c-.31.6-1.15,1.55-1.34,1.3.07-.27.63-1.02.74-1.21-.14.18-.45.25-.39.1l.28-.25c0-.3-.66.65-.5,0-.03-.07.26-.85.06-.51-.29.72-1.45,2.79-1.8,3.25,0-.06.06-.81.19-1.17.21-.57.86-1.16,1.04-1.65-.1.16-.26.32-.32.37.02-.17.31-.48.14-.48-.36.58-.23-.2-.35.46-.22.1-.06-.2-.23-.26-.18.41-.89,1.22-1.12,1.3.1-.14.18-.36.22-.45-.23-.21-.2-.56-.44-.71.06-.15.05-.39.26-.62-.1.08-.25.26-.33.23.17-.59.21.02.47-.65-.22.33-.47.35-.71.5-.29.54.18.25.41.1-.44.72-1.08,1.36-1.55,1.54-.31.05.2-.52.1-.44-.3-.35-1.11,1.04-1.1.33.17-.53.57-.9.76-1.25.27-.07.06.45.18.5v-.3c.15-.12.33-.16.3,0,.16-.47-.57-.48-.61-1.04-.15.12-.34.22-.42.42h.13c-.16.41-.5.38-.5.63-.29.17-.69.48-.73.16l.31-.53c-.1.15-.09.38.06.25-.22.18.2-.86-.33-.25l-.12.43c-.29.17-.82.61-.86.34-.27.55.07-.03-.22.63.4-.79.38.29.75-.57-.35.76,0,.42-.24,1.1.11-.17.16-.36.24-.19.04-.05.09-.1.13-.13v.02s0-.02,0-.02c.02-.02.03-.03,0,0,.02-.09.05-.2.1-.3.32-.34.52-.2.72-.35.02.13-.16.17-.24.38l.3-.23c-.24.38-.2.76-.53.86l.15.13c-.04.28.04.45.23.34.03.13.46-.29.21-.04l.41-.07-.06.1c.23.21.92-.31.79.56.15-.04.31-.11.39.09l-.17.35c.18-.05.14.54.39.22-.41.98.43.51.54.79l.26-.44c.12.1.32.05.59-.03l.21-.4c.33-.24.21.49.47.58-.1.14-.14.07-.13-.05-.22,1.04.94-.32.83.46.14-.11.16-.04.15.09,0,0-.02,0-.03.01,0,0,.01.01.02.02,0,.08-.02.18-.03.26.03-.11.04-.2.04-.25.05.02.15,0,.28-.05l-.2.44s.01,0,.02,0c-.02.19.17-.17.3-.51.07-.05.15-.12.23-.2-.32.71.31-.13,0,.64.24-.33.5-.07.95-.8-.05.1-.05.16-.1.14.03.13.07.26.25.08l-.26.56.56-.63c-.07.38-.13.6-.46.96.6-.5.33-.13.89-.65l-.2.34c.08.03.46-.37.35-.06-.18.75.8.55.91,1.39.46-1.07-.04.57.4-.22-.1.26-.12.43-.3.6.35-.12.13.56.64-.03-.1.26-.24.33-.29.49.05-.04.18-.17.13-.02-.05.16-.14.19-.23.27.25.08.67-.66,1.06-1.35-.06.4.02.38.35-.04-.08.25-.14.53-.33.54.06.08.31.6.61.04-.05.16.09.1.14.05.16.13.15.19.35.23v-.12c.43-.64.23-.07.41-.08l-.04.07c.06.66.27-.16.28.57l.21-.43c.52-.89,0,.69.37.44l.06-.28c.27-.26-.39,1.39-.35,1.55-.02.09-.1.11-.16.15-.03.68.33-.53.6-.55-.13.32-.46.73-.36.86-.07.28.91-.76.77-.09.09-.25.17-.5.36-.62.18,0-.11,1.07.42.42-.02.07-.04.14-.08.19.21-.13.51-.12.8-.47-.72,1.49,1.05-.32.29,1l.36.11-.09.13c.15.21.41-.07.67-.34,0,.12-.11.22-.16.29.14.44.2.4.84-.1l-.23.44c.22-.2.01.92.6.6-.03.05-.09.12-.15.17.64-.29.02,1.63,1.11.19l.45-.23c-.19-.3.47-.63.52-.95.17-.02-.02.64-.21.63l.03-.09c-.57.75.15.5-.21,1.03.56.31.75,1.09,1.18,1.47l.38-.63.14.16c-.06.17-.29.5-.38.39-.19.38.4-.13.5-.26.05.4-.61.61-.55.68l.13.03.03-.08c.26-.18.46-.43.58-.29,0,.18-.23.39-.21.44-.03.04-.04.07.04.06l.15.21.28-.52c.26-.15.17.18.48-.41-.5.9.5.89.38,1.2.4-.22.51-.11.63.06.04-.12.45-.63.53-.45-.94.96-.15.65-.69,1.46.33-.56.48.22.94-.59.04.18-.33.38-.46.69.61-.15.36.78.83.95.12-.13.24-.38.48-.52l-.39.83c.13,0,.72-.72.45-.15.08-.13.19-.32.27-.33.07.62.56.78,1,.99.44.22.82.48.87,1.43.05-.37.15-.35.24-.31-.02-.1.21-.38.32-.59,0,.26.02.52.05.78.37-.55.43.17.74-.39l-.17.05c.46-.61.51-1.59.98-2.43-.54.68.27-1.28-.54-.34.05-.2.2-.24.29-.45-.26.32-.37.35-.39.13l.07-.08c-.38-.13-.3-.56-.48-1.03l-.26.4c-.04-.11.03-.24.07-.36-.52.51.19.19-.36.77.48-.84-.55-.44.07-1.35-.11-.1-.31.45-.43.35l.16-.25-.27.27c-.04-.11.16-.43.32-.62,0,.04.1-.01.13-.01.13-.35-.35-.14-.31-.26v.23c-.51-.06-.64-.7-1.36-.54l-.13.19c-.52.09-.03-.36-.43-.46l.05-.03c-.2.12-.35.13-.41.05.25-.13.2-.5.49-.63-.59.08-.38.14-1.12.6l.2-.32c-.28.2-.4.33-.61.28.33-.14.27-.51.68-.72.21-.88-.98.25-.37-.79-.79.68-.09.67-.31.77-.15.31-.6.5-.63.34-.08-.09.66-1.17.39-1.35.02.02.07-.04.1-.01.06-.28-.41.14-.27-.29-.44.44-.13-.14-.63.47l.35.03c-.26.06-.94.71-.89.19.11-.12.3-.24.42-.3.08-.23-.22.03-.14-.21.49-.62.39.07.9-.3.13-.32-.62.25-.03-.38-.76.79-.18-.3-.85.24l.29-.37c-.07.04-.26.18-.31.13l.46-.43c-.45.32-.01-.58-.32-.45.3.2-.27.51-.35.88-.72.26.52-1.17-.02-1.26.09-.02.05.37-.17.5-.02-.13-.02-.35.07-.59-.33-.1-.24.43-.52.59.24-.54-.27.11-.49.18l.27-.4c-.13-.46-.64.78-.71.29l.49-.48-.24.05.33-.44c-.38.23-.37.11-.44-.12-.15.31-.5.72-.64.64.06-.3.3-.35.07-.42.21-.23.46-.51.3-.08.09-.13.21-.23.3-.35.08-.34-.21-.24-.29-.27.02.03.04.07.02.14l-.64.39c.05-.18.17-.28.28-.38-.09,0-.24.17-.35.15.23-.32.44-.66.66-.75l-.5.2c.07-.16.11-.48.22-.58-.03-.29-.77.42-.81.04-.05.06-.11.11-.18.13-.14-.19-.06-.71-.56-.38l.23-.68c-.26.04-.28.86-.7.92-.32.08.23-.56.25-.77-.28.25-.82.77-.72.16.13-.08.13.04.21.03ZM22.63,20.25c.09-.07.32-.29.22-.03-.31.46-.22.21-.22.03ZM18.82,19.52c.11-.12.12-.03.08.16-.06.01-.09-.02-.08-.16ZM8.18,17.36l.02-.02c-.01.22,0,.13-.02.02ZM8.1,17.06c-.06.04-.09.1-.12.16.08-.09.13-.07.16-.01.06-.12.08-.2-.04-.15ZM28.11,28.59l.05-.12c.16-.06.06.03-.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.5,19.13c-.03.08-.07.16-.11.24.05-.06.1-.15.11-.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "26.4 21.77 26.4 21.77 26.45 21.7 26.4 21.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M13.11,15.33c0,.08-.02.17-.05.26.06-.1.09-.2.05-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M6.64,17.09l.19-.02c-.07-.02-.03-.12-.02-.2-.06.09-.13.25-.17.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.34,13.92c-.05.04-.04-.02-.09.02l-.13.19c.08.04.23-.07.22-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.43,15.69c.22-.34.07-.27-.06-.27,0,0,.01,0,.01.01-.35.45-.15.36.04.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.35,15.41s-.07-.01-.08-.05c-.14.18,0,.06.08.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.71,17.13c.02-.11-.31.42-.24.26-.33.4.61-.35.24-.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "8.12 14.54 7.87 14.97 8.14 14.67 8.12 14.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M8.56,15.27l-.05-.2c-.04.07-.09.1-.13.12.07.07.1.21.18.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M8.37,15.19s-.08-.05-.15,0c.03.01.08.03.15,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "8.38 14.53 8.36 14.65 8.43 14.74 8.38 14.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M9.92,16.26l.22-.03c.11-.14.12-.25.03-.23-.1.08-.19.1-.25.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M10.22,14.83c-.02.11-.08.21-.14.36l.34-.52-.19.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M10.71,14.96c.11-.14.47-.29.27-.37-.1.14-.32.17-.27.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "12.48 16.94 12.44 16.92 11.93 17.81 12.48 16.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M15.61,15.9c-.06-.31-.34.53-.35.18-.16.19,0,.29-.13.45.23-.17.21,0,.49-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M15.12,16.52s-.08.06-.13.11c.06-.04.1-.07.13-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "34.44 34.1 34.5 34.36 34.55 34.01 34.44 34.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.04,33.55l-.23.61.32-.5s-.13.03-.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.93,18.92l-.08.13c-.06.16-.04.18,0,.24l.08-.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "24.27 20.22 24.25 20.19 24.01 20.73 24.27 20.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.97,20.34c-.04-.05-.17.02-.21-.03.17-.02-.14.67.21.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M41.71,24.22c0,.05.29-.25.34-.3-.11.02-.42.38-.34.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "40.62 24.47 40.75 24.35 40.39 24.59 40.62 24.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.23,24.07c-.47.54.22.06.11.31l-.1.13.44-.37c-.15-.02-.53.13-.45-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M41.12,22.77c-.19.21-.22.12-.01.11.02-.03.03-.04.04-.06-.01,0-.02-.02-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M41.15,22.82c.06.03.14-.19,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.85,22.74l.23-.12c.11-.13.08-.2.19-.27-.15.04-.26.17-.42.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.42,23.05l.1-.04c.04-.05.05-.08-.1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.74,22.92l-.22.09c-.07.09-.24.25.08-.03-.16.14,0,.01.13-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.7,23.03c-.08.14-.11.25-.34.37.17.04.52-.33.34-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.68,24.56l-.11.19.21-.13c-.1.07.06-.22-.1-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.78,22.14c-.11.1-.27.3-.41.44l.16-.08c.05-.09.08-.2.24-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.37,22.58l-.25.12c.03.08.13,0,.25-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "39.85 23.6 40.34 23.32 39.82 23.59 39.85 23.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "40.56 21.9 40.85 21.69 40.41 22 40.56 21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.37,21.79c.23-.18.32-.38.47-.48-.08,0-.29.13-.48.26.12-.05.14,0,.01.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.07,21.74c.07-.03.17-.1.29-.17-.07.03-.15.08-.29.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.08,22.55c.06-.07.22-.25.26-.35l-.28.32.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.05,22.53h0s-.03-.07-.03-.08c0,0,.01.03.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.08,22.56h0s-.04.04,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.97,23.17c-.21.13-.46.24-.65.56.23-.18.34-.37.65-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.73,22.96v.13c.07-.08.18-.21.28-.27l-.28.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "39.6 23.02 39.73 22.96 39.73 22.91 39.6 23.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.89,22.13c-.16.1-.2.08-.26.07-.02.1-.02.17.02.2.1-.09.29-.24.24-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.94,22.35h-.02s-.03.05.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.31,21.86s-.03.04-.05.06l.05-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.6,22.46c-.03.09.06.03.17-.05-.05,0-.09,0-.12-.01-.05.04-.07.07-.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.84,21.79c-.05.08-.09.15-.12.21.08-.11.21-.28.12-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.99,22.27s.02,0,.02,0c.06-.07.03-.04-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.99,22.27c-.06.03-.14.09-.22.15.04,0,.09-.02.15-.05.02-.02.05-.06.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.23,23.66c.29-.27.62-.45.38-.09.27-.14,1.17-1.09,1.64-1.65-.13.12-.24.23-.47.33-.13.17-.23.49-.54.69-.23.06.03-.17.14-.35-.32.38-.62.39-1.13.91l.26-.1c-.08.08-.24.18-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.35,22.07h.06c.02-.09.11-.22.3-.47-.18.09-.3.18-.39.27l.09.17-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.52,22.18c-.33.28-.52.34-.82.71.1.06.31-.2.49-.28-.2-.05.21-.13.29-.39.08-.03.11-.02.15-.01.02-.06.04-.13.08-.2l-.02.02h0s0,0,0,0c-.03.04-.06.07-.04.04,0,0,0,0,0,0-.05.04-.08.07-.12.11.03-.1.07-.08.12-.11l.05-.04h0s-.29.04-.29.04c-.02.07.02.09.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.59,24.31s.05-.05.07-.07c-.05.03-.07.05-.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.72,24.08c.05-.03.18-.15.18-.08-.07.12-.15.14-.25.24.1-.06.28-.15.38-.36l-.05.03c.06-.15.38-.59.43-.63-.26.29-.45.49-.69.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.04,23.2l-.25.04-.22.31.16-.16c0,.12.18-.08.31-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "39.45 21.69 39.79 21.39 39.27 21.78 39.45 21.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "39.28 21.6 39.57 21.33 39.36 21.46 39.28 21.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M28.39,16.98l-.11.04s.08-.02.11-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M28.58,17.23l.15-.12c-.09.06-.15.11-.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.07,18.26c.23-.3.6-.74.28-.43l-.31.31c.09-.02.07.04.02.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.01,17.64l-.09.1c.12-.09.23-.17.34-.25-.08.05-.16.09-.25.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.64,18.8l.15-.25c-.06.08-.11.16-.15.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M26.92,15.97l-.37.25c.05.06.2-.11.37-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.83,20.31c.09-.16.11-.24.1-.28-.14.22-.37.51-.1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.95,14.05c-.08.03-.15.08-.22.15.07-.03.15-.07.22-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.82,19.92s-.04.06-.05.09c.08-.02.15-.03.16.02.1-.16.15-.28-.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.19,10.92s.02-.02.03-.04c-.05.04-.05.04-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.48,6.78s.05.02.07.04c.02-.03,0-.04-.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.89,20.92s.04-.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.79,22.25s-.09.07-.16.13c.08-.07.13-.11.16-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.58,21.48h0c-.05.06-.04.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.79,21.1s.05-.09.06-.13c-.02.03-.04.07-.06.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.93,20.95s0,.04,0,.05c.06-.05.09-.08,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.84,20.9s.02.04.01.08c.02-.03.03-.04.04-.05-.01,0-.03,0-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M26.21,12.77s.01-.02.03-.03c-.16.08-.13.08-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.04,20.53s.01,0,.02-.01c0,0,0,0,0-.01l-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.7,20.64c.44-.32.42-.25.36-.13l.89-.88-1.25,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M27.8,16.49l-.23.33c-.57.33-.46.11-.81.54,1.04-.88.37.21,1.4-.66l-.17.24s-.07.03-.07,0c-.4.53.81-.57.77-.31-.04.11-.16.27-.31.35l.34-.12s-.18.19-.18.15l.21.08-.03.03c.18-.12.47-.29.6-.35-.11.17-.13.08-.24.2l.32-.13c-.24.27-.55.42-.57.33-.95.97.32-.15-.13.54l-.2.03c-.53.56-.27.44-.55.84.17-.19.75-.98,1.09-1.11-.05.09-.06.16.19.03-.36.32-.23.29-.16.33l-.48.42c.2-.06.44-.28.69-.43.02.11-.34.46-.64.75.03.18.53-.61.74-.55-.1.26.16.15.55.01-.11.21-.3.25-.42.39l.43-.28s-.12.12-.18.17c.19-.08.48-.42.68-.46.55-.45-.63.85.06.41-.11.14-.3.25-.48.42.51-.22.39-.14,1.01-.5l-.23.37c.3-.39.8-.68,1.22-.92.15-.18.28-.34.34-.41l.36-.11c-.07.08-.24.22-.46.38.05-.03.09-.05.13-.08-.14.2-.43.42-.73.63.08-.1.17-.2.25-.31-.32.23-.66.49-.94.74.06-.04.12-.07.16-.08-.09.06-.16.12-.2.17-.05.05.07-.03.21-.12l-.51.5.22-.18-.19.46c.64-.36,1.51-.97,1.89-.99-.43.31-.64.56-1.11.97.44-.49-.33.05-.32-.14,0,.1-.24.28-.32.34l.59-.23c-.38.34-.25.29-.37.47.71-.7.61-.32.9-.46-.25.23-.52.44-.53.31-.48.6.98-.67.59-.15-.02-.01,0-.06-.13.05.26-.15.19.12-.05.29l-.02-.02c.03.21.37.41,1.01-.14-.08.07-.78.67-.91.78l2.33-1.69c-.56.47-1.77,1.73-2.18,1.89-.05.1-.1.22.15.12.06-.09.73-.77.81-.78-.53.63-.27.35-.69.92.09-.14.96-.88.98-.8-.13.11-.83.77-.93.83l.95-.63c-.18.1-.71.64-.92.88.15-.16.09.12.2.08l.14-.23c0,.26,1.29-.93,1.38-.75-.19.14-1.09.93-1.13,1.1.45-.36,2.17-1.73,2.61-1.91l-.22.25.36-.16c-.69.53-2.18,1.6-2.79,1.99-.14.23-.27.28-.17.34-.2.24-.38.27-.42.26l.03.32c.49-.47.63-.31,1.03-.7l-.7.27c.49-.46,1.51-1.18,1.54-.97-.16.22-.9.79-1.06.94.19-.14.44-.17.33-.05l-.32.19c-.12.25.76-.49.38.04,0,.06-.55.68-.25.42.51-.57,2.24-2.2,2.69-2.56-.03.05-.39.66-.63.95-.39.46-1.12.9-1.46,1.3.14-.12.33-.25.39-.29-.08.14-.43.38-.3.39.51-.45.09.18.45-.36.21-.06-.03.17.06.23.3-.33,1.16-.95,1.36-1.02-.13.11-.28.28-.35.36.08.18-.07.47.05.6-.11.13-.2.32-.43.5.11-.06.29-.21.34-.18-.36.48-.15-.03-.61.52.29-.27.49-.27.73-.39.43-.44-.04-.21-.27-.1.61-.58,1.35-1.09,1.76-1.22.25-.04-.35.42-.25.36.08.3,1.23-.85.94-.26-.33.44-.77.74-1.04,1.02-.23.05.12-.37.05-.41l-.12.25c-.16.1-.31.13-.23,0-.3.39.25.4.08.86.16-.1.34-.18.47-.35h-.1c.27-.34.52-.32.61-.52.28-.15.7-.4.61-.14l-.43.44c.13-.13.21-.31.05-.21.23-.15-.46.71.16.2l.24-.36c.28-.15.83-.52.77-.31.4-.46-.07.03.39-.52-.59.66-.17-.23-.76.49.54-.63.15-.34.59-.9-.14.14-.25.29-.25.16-.05.04-.11.08-.14.11v-.02s0,.02,0,.02c-.02.02-.03.02,0,0-.05.08-.11.16-.19.25-.37.29-.46.17-.67.3.03-.11.18-.14.32-.31l-.31.19c.32-.32.44-.62.72-.71l-.07-.1c.13-.22.14-.36-.04-.27.03-.11-.46.24-.17.03l-.33.06.08-.08c-.08-.17-.8.24-.35-.47-.12.03-.27.08-.25-.08l.27-.28c-.15.04.12-.44-.2-.19.7-.78-.09-.43-.05-.66l-.37.34c-.04-.09-.21-.06-.44,0l-.32.31c-.34.18.05-.41-.09-.5.13-.11.13-.05.07.04.61-.83-.82.2-.39-.43-.15.08-.13.02-.07-.08,0,0,.01,0,.02,0,0,0,0-.01,0-.02.04-.07.09-.14.13-.21-.07.09-.12.16-.14.2-.03-.02-.11-.02-.22.02l.34-.34s0,0-.02,0c.1-.16-.19.13-.44.39-.08.04-.16.08-.26.15.55-.56-.28.08.29-.52-.32.25-.39.02-1.04.58.08-.08.11-.12.13-.11.03-.11.07-.21-.14-.09l.44-.43-.69.47c.23-.31.37-.48.76-.74-.65.36-.3.08-.93.45l.3-.26s-.5.26-.28.02c.48-.6-.33-.51-.02-1.21-.83.82.29-.46-.39.14.19-.2.28-.33.49-.46-.31.06.17-.47-.47-.04.19-.2.32-.24.43-.37-.05.03-.21.12-.1,0,.11-.12.19-.14.29-.2-.14-.09-.79.47-1.39.99.23-.31.16-.31-.27,0,.18-.19.35-.41.48-.4,0-.07.06-.51-.43-.09.11-.12-.02-.09-.08-.05-.06-.12-.02-.17-.15-.22l-.06.1c-.61.48-.2.04-.33.02l.06-.05c.26-.54-.27.1.06-.49l-.35.33c-.79.67.32-.55-.06-.39l-.17.22c-.31.18.92-1.08.97-1.22.06-.07.12-.08.19-.1.33-.54-.49.4-.69.39.24-.24.67-.54.65-.66.18-.22-1.01.52-.61,0-.18.19-.36.39-.55.47-.14-.02.57-.85-.11-.38.05-.06.09-.1.14-.15-.21.08-.43.04-.8.3,1.21-1.14-.92.17.23-.83l-.22-.12.12-.1c-.02-.18-.33.02-.65.22.06-.09.18-.17.24-.22.09-.37.03-.34-.67.01l.36-.34c-.25.15.38-.75-.2-.54.04-.04.12-.09.18-.13-.6.19.67-1.33-.76-.23l-.44.16c.03.25-.62.48-.79.74-.13,0,.28-.51.41-.5l-.06.07c.74-.58.09-.41.58-.82-.3-.28-.16-.92-.37-1.24l-.53.5-.05-.13c.11-.14.41-.4.45-.31.29-.3-.37.1-.49.2.11-.33.7-.49.68-.54l-.09-.02-.05.07c-.27.14-.52.34-.56.23.07-.15.32-.32.33-.36.04-.03.05-.06-.01-.05l-.06-.17-.4.42c-.27.12-.08-.14-.53.34.7-.73-.12-.71.08-.97-.39.19-.45.1-.49-.03-.07.1-.56.53-.57.39,1.06-.82.32-.53,1.01-1.2-.44.47-.32-.14-.95.53.03-.14.39-.32.59-.57-.54.16-.04-.59-.35-.69-.14.11-.32.31-.56.43l.59-.66c-.1.01-.82.6-.41.14-.11.1-.27.26-.33.27.33-.95-1.23-.41-.3-1.83-.22.27-.28.25-.32.22-.04.08-.34.27-.52.42l.38-.59c-.54.38-.19-.16-.7.21h.13c-.65.37-1.22,1.12-1.98,1.7.73-.44-.81,1,.25.39-.13.15-.26.17-.42.32.35-.22.45-.23.37-.04l-.09.05c.25.16.01.51,0,.92l.35-.31c0,.09-.11.2-.19.3.61-.39-.09-.17.57-.61-.7.67.29.38-.53,1.12.06.09.41-.37.47-.28l-.21.21.31-.22c0,.09-.27.35-.47.51.01-.03-.08,0-.11,0-.22.29.25.12.18.22l.08-.19c.4.05.31.57.96.4l.16-.16c.45-.1-.08.29.21.34l-.05.03c.2-.1.33-.13.35-.06-.24.12-.32.41-.6.53.49-.1.34-.13,1.08-.54l-.26.26c.29-.17.43-.28.58-.25-.31.13-.39.42-.78.6-.47.7.86-.24.02.6.86-.57.31-.52.51-.62.23-.25.65-.42.62-.29.03.07-.93.94-.79,1.08,0-.02-.07.03-.08.01-.15.22.36-.12.09.22.51-.36.05.11.66-.38l-.26-.02c.22-.05,1-.57.76-.16-.13.09-.32.19-.44.24-.15.19.18-.03.03.17-.62.5-.27-.06-.81.25-.22.25.57-.21-.12.3.89-.64.02.24.74-.19l-.37.3c.07-.03.27-.14.29-.1l-.52.34c.47-.25-.22.45.07.35-.15-.16.41-.4.61-.7.66-.2-.85.91-.49,1-.08.01.12-.3.33-.39-.04.11-.13.28-.3.47.2.09.35-.34.63-.46-.4.42.24-.08.44-.13l-.37.31c-.09.37.81-.6.65-.21l-.57.37.2-.03-.43.34c.39-.18.33-.08.28.11.24-.24.68-.55.75-.49-.17.24-.37.27-.23.33-.25.17-.56.39-.26.05-.13.09-.25.18-.37.27-.2.27.06.19.1.23,0-.03,0-.06.05-.12l.64-.28c-.12.14-.24.22-.37.29.07,0,.25-.12.33-.1-.31.24-.61.51-.81.56l.46-.13c-.12.12-.29.38-.42.45-.1.23.75-.29.61.01.06-.04.13-.08.19-.09.02.16-.27.56.24.34l-.47.53c.2,0,.59-.67.93-.69.27-.03-.42.43-.53.6.32-.18.95-.55.6-.07-.13.05-.07-.04-.14-.04ZM29.05,17.45c-.1.04-.37.21-.17,0,.44-.34.26-.15.17,0ZM31.47,18.42c-.13.09-.1.01.01-.14.05,0,.06.03-.01.14ZM38.31,20.87h-.02c.09-.16.05-.1.02,0ZM38.25,21.12c.06-.04.11-.08.15-.13-.09.08-.12.06-.12.01-.08.09-.14.17-.03.12ZM28.43,10.37l-.08.1c-.14.04-.04-.02.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.8,18.67c.06-.06.12-.12.19-.18-.07.05-.14.11-.19.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "26.99 15.92 26.99 15.92 26.92 15.97 26.99 15.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M33.82,22.38c.03-.07.08-.14.14-.21-.09.08-.15.16-.14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.34,21.07l-.15.02s-.02.1-.06.17c.08-.08.19-.2.21-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.71,23.68c.05-.03.02.02.08-.02l.16-.16s-.2.07-.23.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.24,22.24c-.29.29-.15.23-.05.22,0,0,0,0,0,0,.42-.38.24-.3.06-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.2,22.46s.05,0,.05.03c.17-.15.02-.05-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.56,21.06c-.06.09.39-.35.28-.22.4-.33-.58.29-.28.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "37.31 23.2 37.65 22.83 37.34 23.09 37.31 23.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.24,22.59l-.03.17c.06-.06.1-.08.14-.1-.03-.06,0-.17-.11-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.35,22.66s.04.04.11,0c-.02,0-.05-.02-.11,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "37.11 23.21 37.16 23.11 37.14 23.04 37.11 23.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.58,21.76l-.18.02c-.13.11-.19.2-.11.19.1-.06.18-.08.29-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.81,22.94c.06-.09.14-.17.24-.3l-.45.43.21-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.49,22.82c-.13.11-.47.23-.34.3.13-.11.31-.13.34-.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "34.95 21.1 34.97 21.11 35.72 20.42 34.95 21.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.19,21.71c-.09.26.48-.4.34-.11.2-.14.12-.24.29-.36-.24.12-.16-.01-.63.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.82,21.24s.08-.04.14-.08c-.06.03-.1.05-.14.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "25.73 6.21 25.85 6.01 25.61 6.27 25.73 6.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.04,6.56l.5-.42-.49.33s.1-.01,0,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M28.22,18.48l.12-.1c.12-.12.12-.14.11-.19l-.23.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "27.85 17.32 27.85 17.34 28.27 16.93 27.85 17.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M26.66,17.09s.14,0,.14.04c-.14,0,.41-.53-.14-.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.85,8.72s-.35.15-.42.18c.1,0,.52-.23.42-.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "35.88 8.65 35.72 8.72 36.12 8.59 35.88 8.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.02,8.98c.63-.34-.16-.07.04-.23l.14-.08-.53.22c.12.03.5-.04.35.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.71,9.81c.25-.13.23-.07.06-.08-.03.02-.04.03-.06.04,0,0,.01.02,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.71,9.77s-.2.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.93,9.86l-.25.06c-.14.08-.16.14-.27.17.14-.01.29-.09.52-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.42,9.68l-.11.02c-.06.03-.08.05.11-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.09,9.74l.22-.05c.1-.06.31-.16-.08.01.19-.09,0,0-.14.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.17,9.67c.13-.09.2-.17.45-.23-.13-.04-.58.18-.45.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.7,8.67l.17-.12-.23.07c.11-.04-.14.15.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.72,10.29c.14-.06.36-.19.53-.28l-.17.04c-.09.06-.16.13-.36.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.26,10.02l.26-.06c0-.06-.11-.01-.26.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "36.14 9.34 35.6 9.5 36.15 9.36 36.14 9.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "34.8 10.49 34.46 10.61 34.97 10.43 34.8 10.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.91,10.59c-.27.1-.43.24-.6.29.06.01.3-.07.52-.14-.13.03-.11-.02.09-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.14,10.65c-.07.02-.19.06-.32.1.07-.01.16-.04.32-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.49,10.07c-.08.04-.29.15-.37.23l.38-.2s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.5,10.09h-.01s0,.05,0,.06c0,0,0-.02.01-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.49,10.07s0,0,0,0c.04-.02.05-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.85,9.64c.23-.07.49-.12.79-.34-.27.1-.45.23-.79.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.96,9.81l.06-.09c-.1.05-.25.13-.36.17l.3-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "36.09 9.78 35.96 9.81 35.93 9.85 36.09 9.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.46,10.39c.18-.06.2-.04.24-.02.06-.07.09-.12.07-.15-.12.05-.35.14-.32.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.51,10.22s.01,0,.02,0c.03-.02.04-.03-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.83,10.64s.05-.03.07-.04c-.02.01-.04.02-.07.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.85,10.18c.06-.06-.04-.03-.16.02.05,0,.08,0,.09.02.06-.02.09-.04.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.36,10.64c.08-.05.14-.1.19-.14-.12.07-.3.18-.19.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.44,10.28s-.01,0-.02,0c-.08.05-.04.03.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.44,10.28c.06-.01.16-.05.25-.08-.04,0-.08,0-.15.02-.03.02-.07.04-.1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.35,9.54c-.36.17-.72.26-.36.03-.29.08-1.45.67-2.09,1.02.16-.07.3-.14.54-.19.19-.11.4-.33.75-.44.22-.02-.1.12-.27.24.43-.24.69-.22,1.34-.55l-.26.05c.1-.05.27-.11.36-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.89,10.48h-.05c-.05.05-.19.14-.45.3.19-.05.33-.1.45-.16v-.13s.06-.02.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.79,10.39c.4-.17.59-.2.99-.43-.06-.05-.35.11-.53.15.14.05-.23.07-.42.25-.08.01-.1,0-.13,0-.04.04-.09.09-.15.14,0,0,.01,0,.02-.01h0s0,0,0,0c.05-.03.08-.04.05-.02,0,0,0,0,0,0,.05-.03.1-.05.15-.07-.07.07-.1.05-.15.07-.02,0-.04.02-.06.03,0,0,0,0,0,0h.26s.02-.07-.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.5,8.96s-.06.03-.09.05c.05-.02.08-.03.09-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.29,9.11c-.06.02-.22.09-.19.04.11-.08.19-.09.31-.15-.11.03-.3.08-.47.22l.06-.02c-.11.1-.58.39-.63.41.34-.18.59-.31.92-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.64,9.71h.23s.32-.21.32-.21l-.2.1c.06-.09-.19.04-.35.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "35.64 10.74 35.23 10.92 35.83 10.7 35.64 10.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "35.74 10.83 35.39 10.99 35.61 10.92 35.74 10.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M43.1,14.87l.11-.02s-.07.01-.11.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M43.04,14.68l-.18.08c.1-.04.17-.07.18-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.06,13.48c-.32.19-.82.48-.42.29l.39-.2c-.08,0-.05-.03.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.27,14.21s.08-.04.11-.07c-.14.05-.27.11-.39.15.09-.03.18-.06.27-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M41.9,13.46l-.23.17c.08-.05.16-.11.23-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M43.98,15.65l.41-.16s-.22.07-.41.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.42,11.87c-.14.1-.19.16-.2.19.21-.14.53-.33.2-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.91,16.78c.08-.02.16-.05.25-.09-.07.02-.15.04-.25.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.26,12.15s.05-.04.08-.06c-.08,0-.14.01-.13-.03-.15.11-.24.19.04.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M45.34,19.34s-.02.02-.04.03c.05-.02.05-.03.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M41.87,22.25s-.04-.02-.05-.03c-.02.02-.01.03.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.78,11.35s-.04.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.28,10.5s.1-.04.2-.08c-.1.04-.16.07-.2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.81,11.22s0,0,0,0c.07-.04.06-.04,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.94,11.23s-.08.06-.1.08c.03-.02.06-.05.1-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.76,11.32s.02-.03.03-.04c-.07.03-.11.05-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.82,11.37s0-.03.02-.06c-.02.02-.05.03-.06.03,0,0,.02,0,.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M43.39,17.95s-.02.01-.03.02c.17-.05.14-.05.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M41.41,12.15s-.01,0-.02,0c0,0,0,0-.01.01l.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M41.74,12.1c-.5.2-.45.15-.36.07l-1.12.56,1.48-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M43.42,15.25l.32-.23c.61-.2.44-.06.91-.35-1.23.57-.23-.17-1.46.41l.24-.16s.07-.02.06,0c.55-.35-.91.37-.78.19.08-.08.25-.19.4-.23l-.34.07s.23-.13.22-.1l-.15-.07.04-.02c-.2.08-.52.18-.65.22.16-.11.14-.05.29-.13l-.33.08c.31-.18.64-.27.61-.21,1.2-.64-.33.09.32-.37h.18c.68-.38.4-.31.81-.58-.22.12-1.03.65-1.37.73.08-.06.12-.11-.15-.03.44-.21.31-.19.27-.23l.58-.27c-.19.03-.48.17-.76.27.03-.08.47-.31.84-.5.05-.13-.69.4-.85.35.19-.18-.07-.12-.46-.04.17-.15.36-.16.51-.26l-.48.17s.15-.08.22-.11c-.2.05-.58.27-.76.29-.64.29.87-.56.11-.29.16-.1.36-.16.58-.27-.52.12-.39.08-1.06.3l.35-.25c-.41.26-.95.44-1.4.58-.2.12-.38.22-.46.27l-.35.05c.09-.06.29-.14.54-.24-.05.02-.1.03-.15.05.2-.13.54-.28.87-.41-.11.07-.22.13-.34.2.36-.14.76-.31,1.1-.47-.07.03-.13.04-.17.04.1-.04.19-.08.24-.11.06-.03-.07.02-.23.07l.63-.33-.26.12.35-.31c-.69.22-1.68.6-2.01.59.49-.19.77-.36,1.34-.62-.57.32.3-.01.22.12.04-.07.32-.19.41-.22l-.6.13c.46-.21.33-.19.5-.31-.89.46-.65.19-.95.27.3-.15.62-.28.58-.18.65-.39-1.11.41-.56.07.01.01-.03.04.13-.02-.29.09-.12-.1.16-.2h.01c.06-.14-.14-.3-.92.05.1-.05.93-.43,1.09-.49l-2.67,1.04c.67-.3,2.21-1.11,2.62-1.2.08-.07.18-.15-.08-.09-.09.06-.93.49-1.01.5.71-.41.37-.23.96-.6-.13.09-1.18.56-1.16.5.16-.07,1.02-.49,1.13-.52l-1.06.38c.19-.06.86-.4,1.14-.56-.19.1-.02-.09-.13-.07l-.22.15c.1-.18-1.48.57-1.48.43.22-.09,1.31-.58,1.41-.7-.53.22-2.56,1.07-3,1.17l.29-.16-.37.09c.81-.33,2.51-.98,3.19-1.21.22-.15.35-.18.29-.23.27-.15.44-.17.46-.16l.11-.23c-.6.29-.66.18-1.17.42l.7-.14c-.6.29-1.77.73-1.71.57.23-.14,1.09-.49,1.29-.59-.22.09-.45.09-.3.01l.35-.11c.2-.17-.85.29-.3-.05.03-.04.75-.44.39-.28-.67.37-2.81,1.39-3.35,1.61.04-.03.6-.44.93-.63.52-.3,1.32-.56,1.77-.81-.17.08-.38.15-.45.18.13-.09.52-.23.42-.25-.62.28,0-.13-.53.22-.2.03.1-.12.04-.17-.39.21-1.38.59-1.58.62.16-.07.36-.18.45-.23,0-.14.26-.33.21-.43.14-.08.3-.21.58-.32-.12.04-.33.12-.36.1.5-.31.12.03.73-.32-.36.17-.53.15-.78.22-.55.28-.06.15.19.09-.76.36-1.6.66-2,.73-.23,0,.48-.27.36-.23.06-.22-1.39.5-.91.11.46-.28.97-.46,1.31-.64.22-.02-.26.25-.22.29l.2-.17c.17-.06.32-.07.19.02.42-.25-.04-.31.3-.62-.17.06-.36.1-.55.21h.09c-.37.23-.58.19-.74.33-.3.08-.76.23-.57.05l.55-.28c-.16.08-.31.2-.13.14-.26.09.7-.47-.04-.16l-.36.23c-.3.08-.92.3-.78.15-.53.29.07-.01-.55.33.78-.42.04.18.85-.28-.72.4-.28.23-.88.59.18-.09.34-.19.27-.09.05-.02.13-.05.17-.06,0,0,0,0-.01.01,0,0,.01,0,.02-.01.03-.01.03-.01,0,0,.07-.05.16-.11.26-.16.43-.17.46-.08.69-.15-.07.07-.22.09-.4.2l.35-.11c-.4.2-.63.41-.91.44v.08c-.19.15-.26.25-.07.2-.07.07.49-.13.16,0h.3s-.1.04-.1.04c0,.13.77-.1.1.37.12-.01.26-.04.17.08l-.35.18c.14-.01-.29.3.09.15-.92.5-.1.32-.23.48l.46-.21c0,.07.16.06.37.04l.4-.2c.36-.1-.22.29-.13.36-.16.07-.13.02-.04-.04-.86.55.78-.08.16.34.16-.04.12,0,.02.06,0,0-.01,0-.02,0,0,0,0,0,0,.01-.06.04-.14.09-.2.14.09-.06.17-.11.2-.13.02.02.08.02.2,0l-.43.22s0,0,.02,0c-.15.1.22-.08.54-.25.08-.02.17-.05.28-.09-.69.36.27-.04-.46.35.37-.15.34.01,1.12-.33-.1.05-.14.08-.16.07-.07.07-.14.15.09.07l-.55.28.78-.28c-.32.2-.5.31-.95.47.7-.21.29-.03.98-.25l-.36.17s.53-.15.24,0c-.65.39.07.39-.48.87,1.04-.53-.43.31.39-.07-.24.13-.37.22-.6.29.29-.02-.33.32.39.06-.25.13-.37.15-.52.23.06-.02.23-.07.09,0-.14.08-.22.09-.33.12.09.07.86-.28,1.58-.62-.32.21-.26.21.23.02-.23.13-.46.27-.57.25-.02.05-.25.36.33.09-.14.08-.02.07.05.04,0,.09-.05.12.04.17l.08-.06c.71-.3.18-.01.29,0l-.07.03c-.44.37.27-.06-.24.35l.43-.21c.94-.43-.49.38-.1.28l.23-.14c.34-.11-1.21.72-1.31.81-.08.05-.14.05-.2.06-.5.37.57-.26.74-.24-.3.16-.79.35-.82.43-.23.15,1.07-.31.52.04.23-.13.46-.26.65-.3.11.02-.82.58-.05.28-.06.04-.12.07-.18.1.21-.05.39,0,.8-.17-1.48.75.86-.07-.52.58l.14.1-.14.06c-.05.13.3,0,.64-.12-.08.06-.22.11-.29.14-.22.26-.15.24.58.02l-.44.22c.27-.09-.61.52-.03.39-.05.02-.14.06-.21.08.59-.11-1.08.93.57.2l.45-.1c.07-.18.72-.32.96-.5.12,0-.43.36-.55.34l.08-.05c-.86.38-.23.29-.81.56.15.22-.21.67-.14.91l.65-.34v.1c-.15.09-.51.27-.5.2-.36.21.36-.06.5-.12-.22.23-.79.32-.79.36l.07.02.07-.05c.29-.09.57-.22.57-.14-.11.1-.4.21-.42.24-.05.02-.07.04,0,.03v.12s.49-.29.49-.29c.28-.08.02.1.59-.22-.88.5-.16.52-.42.69.41-.12.43-.06.42.04.1-.07.68-.36.64-.26-1.22.55-.47.37-1.32.83.56-.32.23.11,1.01-.35-.07.1-.45.22-.72.39.53-.1-.17.42.06.5.16-.07.39-.21.64-.29l-.76.46c.09,0,.93-.41.41-.09.13-.07.33-.18.39-.18-.63.67.93.32-.38,1.32.29-.19.33-.17.36-.15.06-.06.39-.19.61-.29l-.54.41c.61-.26.11.12.68-.14h-.12c.7-.26,1.46-.78,2.33-1.18-.8.3,1.06-.7-.09-.28.17-.11.29-.11.48-.22-.38.15-.47.16-.34.02l.09-.04c-.17-.12.17-.36.32-.66l-.42.22c.04-.07.17-.14.27-.21-.67.26.02.13-.72.43.85-.46-.12-.28.86-.78-.02-.06-.49.25-.51.19l.26-.14-.35.15c.04-.07.36-.25.59-.35-.02.02.08,0,.1,0,.29-.2-.18-.09-.08-.16l-.14.14c-.33-.04-.07-.41-.69-.31l-.2.11c-.43.06.18-.2-.06-.25l.05-.02c-.21.07-.33.08-.33.04.25-.08.43-.28.71-.36-.46.06-.35.09-1.14.36l.33-.18c-.32.11-.48.19-.6.16.31-.08.49-.28.9-.4.67-.49-.84.15.2-.43-.96.38-.46.36-.67.42-.29.17-.72.28-.65.19,0-.05,1.15-.64,1.08-.74,0,.01.07-.02.07,0,.22-.15-.36.07,0-.16-.57.24,0-.08-.72.25l.21.02c-.21.03-1.08.37-.72.09.15-.06.35-.12.47-.15.2-.13-.17.01.04-.12.72-.33.21.05.79-.15.29-.17-.57.13.22-.21-1.01.42.07-.17-.72.11l.43-.2c-.07.02-.29.09-.29.06l.57-.22c-.5.16.36-.31.07-.25.07.12-.5.27-.79.47-.65.12,1.08-.62.79-.69.07,0-.22.21-.43.27.07-.07.22-.19.43-.32-.14-.07-.43.23-.72.3.5-.29-.24.05-.43.08l.44-.21c.22-.26-.92.4-.64.12l.63-.24h-.18s.5-.21.5-.21c-.4.11-.31.04-.2-.09-.3.16-.79.37-.84.32.24-.16.42-.17.32-.23.28-.11.63-.25.25-.03.14-.06.28-.11.42-.18.28-.18.02-.14,0-.16-.01.02-.03.04-.09.08l-.66.17c.16-.1.29-.14.43-.19-.06,0-.27.08-.32.06.36-.16.72-.34.91-.37l-.45.08c.15-.08.4-.26.53-.31.18-.16-.76.18-.52-.04-.07.03-.14.05-.2.06.04-.11.45-.39-.08-.25l.61-.35c-.18,0-.77.45-1.06.45-.24.01.53-.29.69-.4-.34.11-1.03.35-.55.03.13-.03.05.03.11.03ZM42.72,14.51c.1-.03.4-.13.15,0-.51.22-.28.09-.15,0ZM41.05,13.68c.15-.06.09,0-.07.1-.04,0-.04-.02.07-.1ZM36.26,11.43s.01,0,.02,0c-.15.12-.09.07-.02,0ZM36.41,11.26c-.06.02-.12.05-.18.08.11-.05.13-.03.11,0,.11-.06.19-.11.08-.08ZM40.57,19.59l.11-.07c.14-.03.02.02-.11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M41.71,13.55c-.07.04-.15.08-.23.12.08-.03.16-.07.23-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M43.91,15.68s0,0,0,0c.03-.01.05-.02.08-.03l-.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M40.68,10.72c-.06.05-.13.09-.21.14.11-.05.19-.1.21-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.47,11.2h.14s.06-.07.12-.12c-.1.05-.24.13-.26.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.96,9.48c-.06.02-.01-.01-.07,0l-.2.1s.2-.03.27-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.9,10.47c.36-.18.23-.15.14-.15,0,0,0,0,0,0-.52.23-.33.19-.14.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.02,10.31s-.04,0-.02-.03c-.21.09-.04.03.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.12,11.28c.09-.06-.47.21-.33.13-.48.2.62-.16.33-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "38.09 9.86 37.65 10.09 38.02 9.94 38.09 9.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.89,10.3l.1-.12c-.08.04-.12.05-.16.06,0,.04-.07.12.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.83,10.24s-.02-.03-.1,0c0,0,.03.02.1,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "38.26 9.88 38.18 9.94 38.16 9.99 38.26 9.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.09,10.94h.16c.16-.07.25-.13.17-.12-.12.04-.19.04-.33.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.24,10.17c-.09.06-.19.11-.33.19l.56-.26-.23.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M39.46,10.29c.16-.07.49-.12.42-.18-.16.07-.32.07-.42.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "39.19 11.55 39.17 11.53 38.25 11.97 39.19 11.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M41.77,11.31c.19-.18-.58.25-.33.06-.23.09-.2.16-.4.23.25-.06.13.02.73-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M41.05,11.6s-.09.02-.15.04c.06-.01.11-.03.15-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "41.46 22.66 41.29 22.8 41.58 22.62 41.46 22.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M42.18,22.42l-.58.29.54-.22s-.09,0,.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M43.84,13.82l-.14.06c-.15.08-.16.1-.17.13l.31-.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "43.71 14.66 43.71 14.64 43.19 14.92 43.71 14.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.63,14.87s-.12,0-.11-.03c.12,0-.55.35.11.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M33.02,35.86s.16-.35.19-.42c-.08.07-.22.52-.19.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "32.2 36.56 32.27 36.41 32.05 36.77 32.2 36.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.75,36.39c-.21.68.2-.05.19.22l-.04.16.24-.52c-.13.05-.39.36-.39.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.05,34.85c-.08.27-.14.2.03.1,0-.03,0-.05.01-.07-.01,0-.02,0-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.09,34.88c.05,0,.05-.23,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.82,34.95l.15-.21c.04-.16,0-.21.06-.32-.11.1-.16.26-.21.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.58,35.42l.07-.09c.02-.07.02-.09-.07.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.79,35.15l-.15.18c-.03.11-.11.33.06-.06-.08.2,0,.01.09-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.79,35.26c-.02.16,0,.27-.16.48.15-.05.31-.52.16-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.47,37.07l-.03.21.12-.21c-.06.1-.02-.21-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.55,34.46c-.06.14-.12.39-.18.57l.11-.15c.01-.11,0-.21.07-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.37,35.03l-.16.22c.05.05.11-.06.16-.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "31.29 36.15 31.59 35.68 31.27 36.15 31.29 36.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "31.29 34.34 31.45 34.03 31.2 34.5 31.29 34.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.09,34.34c.13-.26.13-.48.22-.63-.07.03-.19.25-.31.45.08-.1.11-.06.09.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.83,34.43c.04-.06.11-.17.17-.28-.04.06-.1.14-.17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.12,35.13c.03-.09.1-.32.09-.43l-.12.41.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.09,35.13h0s-.04-.05-.05-.06c0,0,.02.02.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.13,35.14h0s-.02.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.24,35.73c-.12.21-.3.42-.34.79.13-.26.16-.48.34-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.98,35.65l.04.12c.04-.11.08-.27.14-.37l-.18.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "30.89 35.77 30.98 35.65 30.96 35.61 30.89 35.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.82,34.86c-.1.16-.14.16-.19.18.01.09.04.15.08.17.05-.12.15-.34.1-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.94,35.03l-.02.02s0,.05.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.25,34.89s-.01.05-.02.08l.03-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.7,35.28c0,.09.06,0,.12-.12-.04.03-.07.05-.1.04-.02.06-.04.09-.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.66,34.58c-.01.09-.02.17-.02.24.03-.13.07-.34.02-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.96,34.93s.01-.02.01-.02c.02-.09,0-.05-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.96,34.93c-.04.05-.09.15-.13.23.03-.02.06-.06.1-.11,0-.03.02-.07.03-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M29.21,37.43c.14-.37.35-.69.27-.26.17-.25.57-1.5.75-2.2-.06.16-.12.31-.27.51-.05.21-.01.53-.19.85-.17.16-.03-.16,0-.37-.13.48-.37.63-.59,1.32l.17-.21c-.04.11-.13.27-.14.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.36,35.06l.05-.04c-.01-.08.02-.23.08-.54-.12.16-.18.3-.22.42l.13.1-.03.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.54,35.07c-.17.4-.31.54-.42,1,.1,0,.18-.32.3-.47-.18.05.12-.21.1-.48.05-.06.09-.07.12-.08,0-.06-.01-.13,0-.21v.03s0,0,0,0h0c-.01.06-.02.09-.02.06,0,0,0,0,0,0-.02.06-.04.1-.06.15-.01-.1.03-.11.06-.15l.02-.06h0s-.22.17-.22.17c0,.07.05.07.14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.51,37.36s.02-.07.03-.1c-.03.05-.04.08-.03.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.54,37.09c.03-.05.1-.21.12-.16-.02.13-.07.19-.12.33.06-.1.18-.26.19-.48l-.03.05c0-.16.11-.69.14-.74-.12.37-.2.63-.29,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.5,36.18l-.19.16-.07.37.07-.21c.04.11.12-.16.18-.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "30.31 34.69 30.48 34.26 30.19 34.84 30.31 34.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "30.14 34.68 30.28 34.31 30.16 34.52 30.14 34.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.94,36.52l-.07.1s.05-.06.07-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.18,36.62l.06-.19c-.04.1-.07.17-.06.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M26.31,33.41c.06-.37.19-.93.05-.51l-.12.42c.06-.06.07,0,.07.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.91,35.04s-.02.09-.02.13c.06-.14.11-.27.16-.39-.04.08-.09.17-.13.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.34,36.74l.02-.29c-.01.1-.02.19-.02.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.45,36.57l-.16.41c.06.02.1-.21.16-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M28.5,34.27c.01-.18,0-.25-.02-.29-.03.25-.11.62.02.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.34,32.13c-.04.07-.08.15-.1.24.04-.06.08-.14.1-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M28.35,33.94s0,.07,0,.1c.06-.06.11-.1.14-.06.02-.19.01-.31-.13-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M13.56,34.91s0-.03,0-.05c-.02.06-.01.06,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M13.1,30.3s.05-.02.07-.02c0-.03-.02-.03-.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M29.58,34.28s.02-.04,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M29.16,35.95s-.05.1-.08.19c.04-.1.06-.16.08-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M27.14,36.38h0c-.02.08-.01.07,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M29.56,34.48c0-.05,0-.1,0-.14,0,.03,0,.08,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M29.62,34.29s.01.04.01.05c.03-.07.04-.11-.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M29.52,34.29s.03.03.04.06c0-.03,0-.05.02-.07-.01,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M16.54,34.47s0-.02,0-.04c-.08.17-.06.14,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.06,37.41s0-.01.01-.02c0,0,0-.01,0-.02v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.84,37.68c.21-.5.22-.43.22-.31l.35-1.2-.57,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.31,36.47l-.03.4c-.28.59-.29.35-.36.9.39-1.3.35-.04.74-1.34l-.03.29s-.04.06-.05.04c-.08.65.35-.92.43-.7.02.11,0,.31-.08.46l.2-.29s-.05.26-.07.22l.19-.06v.04c.07-.2.22-.5.28-.63-.01.2-.06.13-.1.3l.18-.29c-.06.35-.23.65-.28.59-.3,1.32.17-.31.12.51l-.13.14c-.17.75-.02.51-.07,1,.05-.25.16-1.22.35-1.51,0,.11.02.16.15-.08-.14.46-.05.36.02.36l-.19.61c.12-.16.21-.47.33-.73.06.08-.07.56-.17.97.09.13.14-.79.32-.86.03.26.18.04.41-.29,0,.23-.13.37-.15.55l.21-.47s-.04.17-.06.24c.11-.17.19-.61.32-.75.23-.67-.13,1.04.21.3-.03.18-.13.37-.19.61.3-.46.23-.33.56-.97l-.02.43c.07-.48.33-1,.55-1.42.04-.23.08-.43.09-.53l.23-.29c-.02.1-.09.31-.19.56.02-.05.05-.1.07-.14-.02.24-.16.59-.3.92.02-.13.05-.26.07-.39-.15.36-.31.76-.41,1.12.03-.07.07-.12.09-.15-.04.1-.07.19-.09.25-.02.07.04-.06.11-.21l-.18.69.09-.27.04.48c.33-.65.76-1.62,1.04-1.84-.21.48-.27.81-.46,1.4.14-.64-.23.22-.29.06.03.08-.07.36-.11.45l.36-.51c-.16.48-.08.37-.09.59.27-.97.33-.59.5-.86-.1.32-.22.64-.28.54-.13.75.48-1.08.38-.44-.02,0-.02-.05-.08.11.14-.27.19,0,.07.27h-.02c.11.16.43.15.72-.66-.04.1-.34.97-.39,1.13l1.14-2.64c-.25.69-.7,2.37-.94,2.73,0,.11,0,.24.16.02,0-.11.27-1.02.32-1.08-.16.8-.07.43-.18,1.13.01-.16.41-1.24.45-1.18-.06.16-.35,1.08-.4,1.18l.49-1.02c-.1.18-.3.9-.37,1.22.05-.21.11.06.18-.04l.02-.27c.1.21.65-1.45.78-1.35-.09.21-.49,1.34-.46,1.5.22-.54,1.03-2.58,1.31-2.95l-.08.32.22-.32c-.34.8-1.1,2.47-1.42,3.11-.02.27-.11.37-.01.37-.07.3-.19.43-.23.44l.14.25c.2-.64.37-.59.54-1.12l-.44.59c.2-.64.73-1.77.84-1.61-.05.27-.41,1.13-.48,1.34.09-.21.28-.37.24-.21l-.17.32c0,.27.41-.8.3-.16.02.05-.18.85-.05.48.19-.75.94-3,1.16-3.53,0,.05-.06.75-.14,1.13-.14.59-.54,1.33-.66,1.83.06-.17.16-.38.2-.44-.02.16-.2.53-.1.48.23-.64.13.11.22-.53.14-.16.03.16.13.16.11-.43.56-1.39.7-1.55-.06.16-.12.38-.14.48.13.11.11.43.25.49-.04.16-.04.37-.16.64.06-.11.15-.32.2-.32-.11.59-.13.05-.29.74.14-.37.29-.48.43-.69.18-.58-.1-.16-.25.05.28-.8.67-1.59.95-1.91.19-.16-.13.53-.07.43.17.22.68-1.33.66-.69-.1.53-.35,1.01-.46,1.38-.16.16-.03-.37-.11-.38v.27c-.09.16-.2.26-.19.1-.1.48.34.22.36.7.09-.16.2-.32.25-.53l-.08.05c.1-.43.3-.53.3-.74.17-.26.42-.68.44-.42l-.19.58c.06-.17.06-.37-.04-.2.13-.24-.12.84.19.1l.07-.43c.18-.26.49-.84.51-.63.16-.58-.04.06.13-.63-.24.85-.22-.12-.44.79.21-.8,0-.37.15-1.06-.06.19-.1.38-.14.25-.03.05-.06.12-.08.16v-.02s0,.02,0,.02c-.01.03-.02.03,0,0-.01.09-.03.2-.06.3-.19.42-.31.37-.43.58-.01-.11.1-.21.14-.42l-.18.32c.14-.43.13-.75.32-.96l-.09-.05c.03-.26-.02-.38-.13-.22-.01-.11-.28.43-.12.11l-.24.21.04-.11c-.13-.11-.55.6-.46-.23-.09.09-.18.2-.23.05l.11-.37c-.11.11-.07-.43-.23-.06.27-1.01-.24-.32-.3-.54l-.17.48c-.07-.05-.19.06-.35.22l-.14.43c-.2.32-.11-.38-.26-.38.06-.16.08-.11.07,0,.16-1.02-.57.59-.48-.16-.09.14-.1.08-.09-.03,0,0,0,0,.02-.02,0,0,0,0-.01-.01,0-.08.02-.17.02-.24-.02.11-.03.2-.03.24-.03,0-.09.04-.17.13l.13-.46s0,0-.01.01c.01-.18-.1.21-.2.56-.05.07-.09.15-.15.26.21-.75-.19.21.02-.59-.15.38-.3.22-.59,1.02.03-.11.04-.16.06-.16-.02-.11-.03-.21-.15,0l.17-.59-.35.75c.05-.37.1-.59.3-1.02-.37.64-.2.22-.55.87l.13-.38s-.28.48-.21.16c.13-.75-.46-.26-.5-1-.3,1.13.04-.54-.24.32.07-.27.08-.43.19-.64-.21.22-.07-.48-.38.22.07-.27.15-.38.18-.54-.03.05-.11.22-.08.05.04-.16.09-.22.14-.32-.15,0-.41.81-.66,1.57.04-.38,0-.34-.21.14.05-.26.1-.53.21-.59-.04-.05-.17-.45-.37.16.03-.16-.05-.07-.09,0-.09-.07-.09-.13-.21-.1v.11c-.27.72-.14.14-.25.2l.03-.07c-.03-.59-.16.23-.16-.43l-.13.46c-.32.98.01-.63-.21-.29l-.04.27c-.16.32.24-1.39.21-1.54.01-.09.06-.13.1-.19.02-.63-.2.6-.36.7.08-.33.27-.82.21-.9.04-.27-.54.99-.47.33-.05.26-.1.51-.21.69-.11.07.05-1.01-.25-.24,0-.07.02-.14.04-.2-.12.19-.31.28-.47.7.4-1.61-.62.66-.19-.81l-.22.02.05-.15c-.1-.13-.24.21-.39.55,0-.11.06-.24.08-.32-.1-.35-.14-.29-.5.4l.12-.48c-.12.27-.05-.82-.39-.32.02-.05.05-.15.08-.21-.36.5-.12-1.46-.67.26l-.25.39c.14.18-.23.75-.24,1.06-.1.08-.03-.57.08-.64v.09c.27-.9-.14-.38.04-1-.35-.05-.55-.64-.86-.77l-.15.72-.1-.07c.01-.17.11-.56.18-.51.06-.41-.22.3-.27.45-.08-.33.28-.81.24-.84l-.08.04v.09c-.14.28-.22.58-.31.52-.02-.16.08-.44.07-.48.01-.05.01-.08-.03-.03l-.13-.1-.09.57c-.13.26-.12-.06-.22.59.16-1-.43-.49-.41-.8-.19.39-.28.36-.37.28,0,.12-.15.76-.22.66.36-1.29-.02-.61.14-1.56-.09.64-.3.09-.42.99-.05-.12.12-.49.14-.81-.31.46-.32-.43-.59-.31-.05.17-.07.44-.18.68l.09-.88c-.07.07-.28.98-.22.36-.02.15-.06.37-.1.42-.24-.94-1.07.46-1.15-1.21-.02.35-.07.37-.11.37.01.09-.1.42-.15.66l-.04-.69c-.18.64-.21,0-.38.61l.09-.1c-.25.71-.26,1.64-.49,2.57.28-.81-.06,1.28.37.13-.01.2-.1.29-.13.51.13-.39.19-.46.23-.27l-.03.1c.25-.04.26.37.45.7l.09-.47c.04.08.02.22.01.34.23-.68-.14-.08.1-.83-.15.96.39.11.18,1.19.08.03.11-.54.19-.51l-.05.29.11-.37c.04.08-.02.44-.08.69,0-.03-.05.06-.07.08-.01.36.23-.07.23.05l-.04-.2c.3-.21.48.23.85-.29l.04-.22c.27-.36.08.27.31.13l-.02.05c.09-.21.17-.3.21-.26-.11.24-.04.52-.17.78.29-.38.18-.31.51-1.09l-.06.37c.12-.31.17-.48.29-.55-.16.29-.08.56-.27.95,0,.83.5-.72.29.45.35-.97-.03-.6.08-.8.04-.34.27-.72.3-.61.06.04-.22,1.3-.06,1.32-.01,0-.04.07-.05.06,0,.27.21-.31.17.12.2-.59.08.06.3-.7l-.19.14c.13-.18.45-1.05.47-.58-.05.15-.15.34-.2.45-.02.24.12-.13.09.11-.21.76-.22.12-.46.68-.04.33.31-.51.05.31.34-1.04.12.17.44-.6l-.13.46c.04-.07.13-.27.16-.26l-.21.58c.22-.48.05.49.2.23-.18-.03.11-.56.13-.92.38-.56-.2,1.23.1,1.08-.05.06-.05-.31.06-.51.02.11.03.3,0,.55.18-.05.1-.48.25-.74-.1.57.14-.21.26-.37l-.13.47c.1.35.31-.96.38-.55l-.24.63.13-.14-.16.52c.2-.37.2-.26.25-.09.07-.33.24-.84.33-.83-.02.29-.15.43-.02.4-.11.28-.23.64-.17.2-.05.15-.1.29-.15.43-.03.33.13.11.17.12-.01-.02-.02-.05-.01-.12l.34-.6c-.02.18-.08.32-.14.45.05-.04.13-.25.19-.27-.12.37-.22.76-.34.92l.27-.38c-.04.17-.05.47-.11.61.02.25.42-.67.45-.35.03-.07.06-.14.1-.19.08.12.05.6.32.12l-.12.7c.14-.13.15-.88.38-1.09.18-.18-.12.59-.13.79.16-.32.46-.99.4-.41-.07.12-.07,0-.12.05ZM20.62,36.53c-.05.09-.19.38-.12.1.18-.52.13-.26.12-.1ZM22.81,35.98c-.07.15-.07.06-.05-.12.03-.03.05,0,.05.12ZM29.09,34.52s0,.01-.01.02c0-.2,0-.12.01-.02ZM29.13,34.76c.03-.06.05-.12.07-.19-.05.11-.08.11-.09.07-.03.12-.05.21.02.12ZM17.01,31.24v.13c-.1.12-.05,0,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.41,36.55c.02-.08.04-.17.07-.25-.03.07-.06.16-.07.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "18.48 36.5 18.48 36.49 18.45 36.57 18.48 36.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M26.09,38.04c0-.07.02-.16.04-.25-.04.11-.06.21-.04.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M29.99,34.2l-.11.09s.02.09.01.17c.04-.11.08-.27.1-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M29.59,37.23c.03-.05.02,0,.05-.05l.07-.21s-.14.16-.13.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M29.52,35.73c-.13.38-.04.27.03.22,0,0,0,0,0,0,.21-.53.09-.37-.03-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M29.57,35.94s.04-.02.05,0c.08-.21,0-.05-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M29.36,34.56c-.01.11.19-.48.15-.32.2-.48-.37.53-.15.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "29.11 37 29.26 36.52 29.09 36.9 29.11 37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M28.84,36.52l.03.16c.03-.08.05-.12.08-.15-.04-.03-.06-.15-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M28.95,36.52s.05.02.09-.06c-.02,0-.05,0-.09.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "28.95 37.11 28.96 37 28.92 36.94 28.95 37.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M28.03,36.13l-.13.11c-.07.16-.08.27-.02.21.06-.11.11-.16.16-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M27.84,37.52c.01-.11.05-.21.09-.37l-.21.59.12-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M27.54,37.57c-.07.16-.29.42-.17.42.06-.16.2-.26.17-.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "26.51 36.38 26.53 36.38 26.85 35.41 26.51 36.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.6,38.31c.02.26.22-.59.22-.27.1-.22,0-.26.09-.45-.14.22-.13.07-.31.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.91,37.59s.05-.08.08-.14c-.04.05-.06.1-.08.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "12.98 29.71 12.96 29.49 12.92 29.83 12.98 29.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M12.67,30.41l.13-.64-.17.56s.06-.07.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.42,37.83l.05-.15c.04-.17.03-.18,0-.22l-.05.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "19.68 37.11 19.69 37.13 19.83 36.55 19.68 37.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.74,37.61s.09-.08.12-.05c-.09.08.08-.65-.12.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M27.03,43.67s.04-.38.05-.46c-.06.09-.05.56-.05.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "26.48 44.59 26.5 44.42 26.4 44.83 26.48 44.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M26.01,44.55c0,.72.18-.11.25.15v.16s.07-.57.07-.57c-.11.08-.26.46-.32.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.85,43c0,.28-.07.24.05.09,0-.03,0-.05,0-.07-.01,0-.02,0-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.89,43.02c.05-.02-.02-.23,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.66,43.16l.08-.24c0-.16-.06-.2-.03-.32-.07.13-.07.3-.05.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.57,43.68l.04-.1c0-.07,0-.09-.04.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.69,43.36l-.08.22c0,.12,0,.35.04-.08-.02.21,0,0,.05-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.72,43.47c.03.16.07.26,0,.5.13-.09.14-.59,0-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.95,45.29l.04.21.06-.24c-.03.12-.08-.2-.09.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.27,42.77c-.01.15,0,.41,0,.6l.06-.17c-.02-.1-.06-.2-.05-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.27,43.37l-.09.26c.06.03.08-.09.09-.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "25.51 44.47 25.66 43.93 25.49 44.48 25.51 44.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "25 42.74 25.06 42.39 24.96 42.92 25 42.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.81,42.79c.05-.29-.01-.49.03-.67-.05.05-.11.3-.16.52.05-.12.09-.09.13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.6,42.96c.02-.07.05-.19.08-.32-.03.07-.05.16-.08.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.06,43.55c0-.09,0-.33-.03-.44v.43s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.03,43.55h0s-.05-.04-.06-.04c0,0,.03.02.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.07,43.55s0,0,0,0c0,.04,0,.06,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.34,44.08c-.06.24-.16.49-.09.86.05-.29,0-.5.09-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.07,44.09l.07.1c0-.11,0-.28.03-.4l-.1.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "25.03 44.22 25.07 44.09 25.05 44.05 25.03 44.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.71,43.37c-.04.18-.08.2-.12.23.04.09.08.13.12.14.01-.13.05-.37,0-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.87,43.5s0,.01,0,.02c0,.04,0,.05,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.19,43.57s0,.05,0,.08c0-.02,0-.05,0-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.72,43.81c.03.08.05-.02.08-.15-.03.04-.05.07-.08.07,0,.06,0,.1,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.48,43.16c.01.09.03.17.04.24,0-.14-.03-.35-.04-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.85,43.4s0-.01,0-.02c0-.09,0-.05,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.85,43.4c-.02.06-.04.17-.06.26.02-.03.04-.08.06-.14,0-.03,0-.08,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.92,46.3c.03-.4.13-.76.18-.33.09-.29.11-1.6.09-2.33-.01.17-.02.33-.11.56.01.22.14.51.06.87-.11.2-.07-.14-.11-.36.01.5-.17.71-.18,1.44l.1-.25c0,.11-.05.29-.03.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.33,43.7l.03-.05c-.03-.07-.05-.23-.08-.54-.06.19-.08.34-.09.47l.15.06v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.5,43.65c-.05.43-.13.61-.11,1.08.09-.02.08-.36.15-.54-.15.1.06-.24-.04-.49.03-.07.06-.09.09-.11-.02-.05-.05-.12-.07-.2,0,0,0,.02,0,.03h0s0,0,0,0c0,.05,0,.09,0,.06,0,0,0,0,0,0,0,.06,0,.11-.02.16-.04-.09,0-.11.02-.16,0-.02,0-.04,0-.06,0,0,0,0,0,0l-.16.23c.03.06.07.05.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.12,45.85s0-.07,0-.1c-.01.05-.02.09,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M25.08,45.59c.01-.06.03-.23.06-.18.02.13-.01.21-.02.35.03-.11.09-.3.04-.52v.06c-.06-.15-.11-.69-.1-.75,0,.39,0,.67.02,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.78,44.73l-.13.2.04.38v-.22c.07.09.07-.18.09-.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "24.18 43.35 24.23 42.9 24.12 43.54 24.18 43.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "24.02 43.4 24.05 43.01 24 43.24 24.02 43.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M14.78,47.81l-.04.11s.03-.07.04-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M15.04,47.86l.02-.19c-.02.11-.03.19-.02.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.11,43.23c-.03-.37-.06-.95-.08-.5v.43c.03-.08.06-.03.08.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M17.3,45.67s0,.09,0,.13c.02-.15.04-.28.06-.41-.02.09-.04.18-.07.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M17.16,47.46l-.05-.28c.01.1.03.19.05.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M13.33,48.2l-.07.44c.07,0,.05-.22.07-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.38,43.47c-.04-.17-.07-.25-.1-.27.04.25.06.63.1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M15.13,43.22c-.03.08-.04.17-.05.26.03-.07.04-.16.05-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.16,43.2s.01.07.02.1c.04-.07.07-.13.11-.1-.03-.19-.07-.3-.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M8.19,47.56s0-.03,0-.05c0,.06,0,.06,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M6.92,43.1s.04-.03.06-.03c0-.03-.03-.03-.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.39,43.18s0-.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.46,44.9s-.02.11-.02.21c0-.1.02-.17.02-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.67,45.88s0,0,0,0c0,.09,0,.07,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.43,43.38c0-.05-.02-.1-.04-.13,0,.03.02.08.04.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.44,43.17s.02.03.03.04c0-.07,0-.12-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.34,43.2s.04.02.05.05c0-.03,0-.05,0-.07-.01,0-.02.01-.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M11.02,46.55s0-.02,0-.04c-.04.18-.03.15,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.99,47.68s0-.02,0-.02c0,0,0-.01,0-.02v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.85,48c.08-.54.11-.47.14-.35l.03-1.25-.17,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M14.15,47.91l.06.39c-.14.64-.2.41-.15.96.09-1.36.34-.12.42-1.48l.04.29s-.02.07-.04.05c.07.66.13-.98.26-.77.04.11.07.31.02.46l.13-.33s0,.26-.02.24l.17-.1v.04c.03-.21.1-.54.14-.68.03.2-.03.14-.03.31l.11-.32c.02.35-.08.69-.14.64.01,1.36.1-.34.24.46l-.1.17c.01.77.1.5.17.98,0-.25-.13-1.22-.01-1.55.02.1.06.15.13-.12-.03.48.03.37.1.34l-.04.64c.08-.18.09-.51.15-.79.08.07.07.56.06.98.12.11-.04-.8.11-.91.09.25.18,0,.33-.38.06.22-.03.39-.02.57l.09-.51s0,.17,0,.25c.07-.19.04-.64.14-.81.06-.7.12,1.04.27.25.02.18-.03.39-.04.64.18-.52.15-.37.31-1.07l.08.42c-.05-.48.08-1.05.19-1.51-.01-.23-.03-.44-.04-.53l.15-.34c.01.11-.01.32-.05.59.01-.05.02-.1.03-.15.04.24,0,.61-.06.96,0-.13-.02-.26-.03-.4-.05.39-.11.81-.12,1.19.01-.07.03-.14.05-.17-.01.1-.03.2-.02.26,0,.07.02-.07.05-.23v.71s.01-.28.01-.28l.15.46c.17-.71.33-1.76.55-2.04-.08.52-.06.85-.09,1.47-.02-.66-.17.27-.27.13.05.07.02.37,0,.47l.22-.59c-.03.51.02.38.06.59.02-1,.18-.66.27-.96-.01.34-.05.68-.14.59.06.76.2-1.17.26-.52-.02,0-.03-.05-.05.12.07-.3.18-.05.14.24h-.02c.14.13.46.04.52-.81,0,.11-.08,1.02-.09,1.19l.42-2.84c-.06.73-.07,2.47-.21,2.88.03.11.07.23.16-.02-.02-.1,0-1.06.03-1.12.05.82.04.44.11,1.14-.03-.16.07-1.3.13-1.26-.02.17-.06,1.13-.08,1.25l.2-1.12c-.05.2-.06.95-.04,1.27,0-.22.12.03.17-.08l-.05-.26c.15.18.25-1.57.4-1.5-.03.23-.13,1.42-.05,1.57.07-.57.32-2.76.48-3.19v.33s.14-.37.14-.37c-.12.86-.4,2.67-.55,3.38.05.26,0,.39.09.36.02.31-.07.46-.1.48l.2.21c.03-.67.2-.66.22-1.22l-.27.68c.03-.67.24-1.9.38-1.77.02.27-.09,1.19-.1,1.42.03-.23.17-.43.17-.27l-.08.36c.07.26.18-.88.25-.24.03.04.06.87.08.47-.01-.77.1-3.14.17-3.71,0,.05.14.74.16,1.12.02.6-.16,1.43-.14,1.95.01-.18.06-.41.07-.48.03.16-.05.57.04.49.05-.68.16.07.07-.57.09-.19.07.14.17.12,0-.44.16-1.49.25-1.68-.01.17,0,.4,0,.5.15.07.22.38.37.4,0,.17.07.37.02.66.03-.12.06-.35.11-.36.06.59-.11.09-.08.8.03-.4.15-.54.23-.78.01-.61-.14-.12-.22.12.05-.84.21-1.72.38-2.1.13-.2.02.55.05.43.22.16.28-1.46.43-.84.05.54-.05,1.07-.06,1.46-.11.2-.13-.35-.2-.33l.07.26c-.04.18-.12.31-.14.15.04.49.38.11.54.57.04-.18.11-.36.09-.58l-.06.07c-.03-.44.14-.59.08-.8.09-.3.2-.77.3-.52v.61c0-.18-.06-.37-.1-.18.06-.27.12.84.21.04l-.05-.43c.09-.3.22-.95.31-.75,0-.61-.03.07-.05-.64.01.88-.24-.05-.2.88-.02-.82-.1-.35-.15-1.06,0,.2.01.39-.06.28,0,.06-.02.13-.03.18,0,0,0,0,0-.02,0,0,0,.02,0,.02,0,.03,0,.04,0,0,.01.09.02.2.02.31-.06.46-.19.44-.24.68-.04-.1.03-.23.02-.45l-.08.36c.02-.45-.08-.75.04-1.01l-.1-.03c-.04-.25-.12-.36-.18-.17-.04-.1-.15.49-.09.14l-.17.27v-.11c-.15-.06-.35.73-.48-.09-.06.11-.12.25-.2.11v-.39c-.07.13-.17-.4-.22,0-.01-1.05-.31-.25-.42-.44l-.03.51c-.08-.03-.16.11-.27.3l-.02.45c-.11.36-.2-.33-.34-.29.02-.17.05-.12.07-.02-.11-1.02-.38.72-.49-.03-.05.16-.07.1-.09,0,0,0,0,0,.01-.02,0,0,0,0-.01,0-.01-.08-.02-.17-.04-.24,0,.11.02.2.03.24-.03,0-.07.06-.12.17v-.48s0,0,0,.01c-.03-.18-.05.23-.04.59-.03.08-.05.17-.07.29,0-.78-.12.26-.13-.58-.05.4-.23.29-.3,1.14,0-.11,0-.16.02-.17-.04-.1-.08-.2-.14.04v-.61s-.13.82-.13.82c-.04-.38-.06-.59.03-1.06-.19.72-.14.27-.3.98l.03-.4s-.15.54-.16.21c-.06-.76-.5-.13-.72-.84-.01,1.17-.09-.53-.15.37,0-.28-.03-.43.03-.67-.15.26-.18-.45-.31.31,0-.28.05-.4.05-.57-.01.06-.06.24-.06.07,0-.16.03-.23.06-.35-.14.04-.2.89-.25,1.68-.05-.38-.09-.33-.16.19,0-.26-.04-.54.05-.63-.05-.04-.27-.4-.31.24,0-.16-.06-.05-.08.02-.1-.04-.11-.1-.22-.05l.02.11c-.08.77-.1.17-.19.25v-.08c-.16-.57-.09.26-.25-.38l-.02.48c-.07,1.03-.14-.62-.27-.23l.03.28c-.08.35-.09-1.41-.15-1.54,0-.09.03-.14.05-.21-.13-.62-.05.63-.18.77,0-.34.08-.86,0-.93-.02-.28-.29,1.09-.37.43,0,.26.02.52-.05.72-.09.09-.17-1-.3-.18,0-.07,0-.14,0-.21-.08.21-.23.34-.29.78.03-1.66-.45.78-.36-.74l-.2.07v-.16c-.11-.11-.17.26-.24.62-.02-.11,0-.25.01-.33-.17-.32-.19-.25-.39.5v-.5c-.05.29-.22-.79-.43-.22,0-.06.01-.15.03-.22-.24.57-.42-1.4-.59.4l-.16.44c.17.15-.07.78-.01,1.08-.07.1-.15-.55-.06-.64v.09c.09-.94-.19-.34-.15-.98-.35.03-.65-.51-.97-.57v.73s-.11-.05-.11-.05c-.02-.17,0-.57.07-.54-.02-.42-.15.34-.16.5-.14-.3.11-.85.06-.87l-.07.05v.09c-.06.3-.08.61-.18.57-.05-.15,0-.45-.03-.48,0-.05,0-.08-.04-.02l-.14-.07.03.58c-.08.28-.13-.04-.1.62-.04-1.01-.51-.39-.55-.71-.11.42-.2.4-.3.35.02.12,0,.77-.09.69.11-1.34-.14-.59-.16-1.56.03.64-.27.14-.22,1.06-.07-.11.02-.5-.02-.82-.21.51-.39-.36-.62-.2-.01.18.01.45-.05.71l-.07-.88c-.05.08-.1,1.01-.15.4,0,.15,0,.37-.02.43-.4-.88-.95.65-1.31-.98.04.34,0,.38-.05.39.03.08-.02.43-.03.67l-.15-.67c-.07.66-.21.03-.26.66l.07-.11c-.12.74.02,1.66-.04,2.62.14-.84.17,1.27.38.06.02.2-.04.31-.04.53.06-.41.11-.49.18-.3v.1c.22-.09.3.32.55.61v-.47c.06.07.06.22.08.33.1-.71-.16-.05-.05-.84.02.97.4.04.39,1.13.09.01,0-.55.09-.54v.3s.05-.38.05-.38c.05.07.06.44.05.69-.01-.03-.04.07-.06.09.05.35.21-.11.23,0l-.07-.19c.25-.26.52.14.78-.45v-.22c.19-.4.12.25.32.07v.05c.04-.22.1-.33.15-.3-.06.26.06.51-.02.8.21-.43.11-.34.28-1.17v.37c.07-.33.08-.51.18-.6-.1.31.03.57-.08.98.16.82.34-.8.37.39.15-1.02-.14-.58-.08-.8-.03-.34.12-.76.18-.66.06.03.04,1.32.2,1.31-.02,0-.02.07-.04.07.05.26.14-.35.19.08.08-.62.09.04.15-.75l-.16.17c.1-.2.22-1.12.34-.67-.02.16-.07.37-.11.48.03.24.09-.15.12.09-.06.79-.19.16-.31.76.03.34.2-.56.11.29.12-1.09.15.15.31-.68l-.03.47c.02-.07.07-.3.1-.28l-.09.61c.12-.52.15.47.25.19-.18,0,0-.57-.07-.92.25-.62.06,1.25.32,1.03-.04.06-.11-.29-.05-.51.04.1.09.29.11.54.17-.09,0-.49.09-.78.02.58.09-.23.17-.41l-.03.48c.17.32.1-1,.25-.62l-.11.66.1-.17-.05.55c.12-.4.14-.29.23-.14,0-.34.06-.87.14-.88.04.29-.06.46.06.39-.04.3-.09.68-.12.23-.01.16-.04.3-.06.46.04.33.15.08.19.08-.02-.02-.03-.05-.04-.12l.21-.66c.02.18-.01.33-.04.47.04-.05.07-.27.13-.31-.03.39-.05.8-.13.98l.18-.43c0,.17.06.47.03.62.08.24.26-.75.36-.44.01-.08.03-.15.05-.2.11.09.18.58.34.05l.04.71c.11-.15-.05-.89.13-1.15.13-.22.01.6.04.8.08-.35.22-1.06.3-.49-.04.13-.07.02-.1.08ZM15.44,47.66c-.03.1-.1.41-.1.12.06-.55.07-.29.1-.12ZM17.43,46.61c-.03.16-.05.08-.07-.11.03-.04.05-.02.07.11ZM23,43.55s0,.01,0,.02c-.04-.19-.03-.12,0-.02ZM23.1,43.76c.02-.07.02-.13.02-.2-.01.12-.04.13-.07.09,0,.13.01.21.05.11ZM10.83,43.29l.02.13c-.06.14-.04.01-.02-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M17.18,47.26c0-.08,0-.17,0-.26-.01.08-.02.17,0,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M13.34,48.12s0,0,0,0c0,.03,0,.06,0,.09v-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.11,47.75c-.02-.07-.03-.16-.03-.25,0,.12,0,.22.03.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.75,42.98l-.08.12s.04.08.06.16c0-.11,0-.28.02-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.23,45.99c.01-.06.02,0,.04-.06v-.22s-.08.19-.04.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.73,44.58c-.02.41.04.27.09.2,0,0,0,0,0,0,.05-.57-.02-.38-.08-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.84,44.77s.03-.03.05,0c.02-.23-.02-.05-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.26,43.5c.02.11.04-.52.05-.35.06-.51-.2.62-.05.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "23.7 45.92 23.71 45.42 23.66 45.82 23.7 45.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.32,45.53l.07.14c0-.08.02-.13.03-.17-.05-.02-.1-.12-.11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.42,45.5s.05,0,.07-.08c-.01,0-.05.02-.07.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "23.58 46.06 23.56 45.96 23.51 45.92 23.58 46.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.44,45.39l-.1.14c-.02.17,0,.28.04.21.03-.12.06-.18.06-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.64,46.77c-.02-.1-.01-.22-.02-.38l-.04.62.06-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.37,46.9c-.02.17-.16.49-.04.45.02-.17.12-.31.04-.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "21.07 46.04 21.09 46.04 21.14 45.02 21.07 46.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.75,48.41c.09.25.06-.63.14-.32.04-.24-.06-.25-.03-.46-.08.25-.1.1-.11.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.86,47.64s.03-.09.04-.15c-.02.06-.03.11-.04.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "6.71 42.54 6.65 42.33 6.67 42.67 6.71 42.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M6.53,43.29l.02-.65-.07.58s.05-.08.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M15.55,48.98v-.16c.01-.17,0-.18-.03-.21l.03.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "14.66 48.44 14.67 48.46 14.67 47.87 14.66 48.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M13.84,49.15s.07-.1.11-.08c-.07.1-.07-.66-.11.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.64,7.52s-.38.06-.45.07c.09,0,.56-.09.45-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "45.61 7.55 45.44 7.58 45.86 7.54 45.61 7.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M45.64,7.74c.7-.14-.13-.05.12-.12l.16-.03-.57.08c.1.02.48.01.29.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.13,8.1c.27-.05.24-.02.08-.04-.03,0-.05.01-.07.02,0,0,0,0-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.15,8.08s-.23.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.32,8.14l-.25.02c-.16.03-.19.06-.31.07.14,0,.3-.03.56-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.84,8.08h-.11c-.07.02-.09.03.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.51,8.09h.22c.11-.03.34-.07-.08,0,.21-.03,0,0-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.61,8.06c.15-.04.24-.08.49-.09-.11-.03-.6.06-.49.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M46.37,7.62l.2-.06-.24.02c.12-.01-.18.07.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M43.98,8.37c.15-.02.4-.08.59-.11h-.18c-.1.04-.19.07-.41.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.57,8.26l.26-.02s-.1-.01-.26.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "45.62 7.95 45.07 8 45.63 7.96 45.62 7.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "43.98 8.48 43.63 8.52 44.16 8.46 43.98 8.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.06,8.54c-.29.04-.48.1-.66.12.05.01.3-.02.53-.04-.13,0-.1-.02.13-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.25,8.59c-.07,0-.19.02-.33.03.07,0,.16-.01.33-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.77,8.3c-.09.02-.33.06-.42.1l.42-.08s0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.78,8.31h-.01s-.02.03-.02.03c0,0,.01-.01.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.77,8.3s0,0,0,0c.04,0,.05-.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M45.25,8.09c.24-.02.5-.03.85-.13-.29.04-.49.09-.85.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M45.29,8.19l.09-.05c-.11.02-.27.05-.39.07l.3-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "45.43 8.18 45.29 8.19 45.26 8.21 45.43 8.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.63,8.47c.19-.02.2,0,.24,0,.08-.03.12-.06.12-.07-.13.02-.37.05-.35.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.74,8.39s.01,0,.02,0c.04,0,.05-.01-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.9,8.63s.05-.01.08-.02c-.02,0-.05,0-.07.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M45.07,8.38c.08-.03-.03-.02-.16,0,.04,0,.07,0,.08.02.06,0,.1-.02.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.45,8.6c.09-.02.16-.04.23-.06-.13.03-.34.08-.23.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.65,8.41s-.01,0-.02,0c-.09.02-.05.01.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.65,8.41c.06,0,.17-.02.26-.03-.03,0-.08,0-.14,0-.03,0-.07.02-.12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M47.61,8.21c-.39.07-.76.09-.34,0-.3.02-1.58.26-2.29.41.17-.03.33-.06.56-.07.21-.05.49-.15.84-.19.21,0-.13.06-.34.11.48-.1.72-.07,1.43-.21h-.26c.11-.01.29-.03.39-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M45,8.55h-.05c-.07.02-.22.06-.52.13.19-.01.34-.03.47-.05l.04-.07h.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.94,8.5c.43-.06.61-.07,1.07-.16-.04-.03-.36.04-.55.05.12.04-.24.02-.47.11-.07,0-.1,0-.12-.01-.05.02-.11.04-.19.06,0,0,.02,0,.03,0h0s0,0,0,0c.05-.01.08-.02.05-.01,0,0,0,0,0,0,.06-.01.11-.02.16-.03-.08.03-.11.02-.16.03-.02,0-.04,0-.06.01,0,0,0,0,0,0l.24.02c.06-.02.04-.04-.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M47.02,7.83s-.07.01-.1.02c.05,0,.09,0,.1-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M46.77,7.9c-.06,0-.23.03-.19.01.13-.03.2-.04.34-.06-.11.01-.31.02-.51.09h.06c-.14.04-.67.17-.73.17.38-.07.65-.13,1.02-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M45.96,8.18h.22s.36-.08.36-.08l-.22.04c.08-.04-.19.01-.36.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "44.68 8.68 44.24 8.75 44.87 8.67 44.68 8.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "44.75 8.73 44.36 8.8 44.6 8.77 44.75 8.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M50.21,11.45h.11s-.07,0-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M50.21,11.34l-.19.03c.11-.01.18-.03.19-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M45.06,10.27c-.36.08-.92.21-.48.13l.43-.08c-.08,0-.03-.02.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M47.8,10.89s.09-.02.13-.03c-.15.02-.28.04-.41.06.09,0,.18-.02.28-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M49.57,10.6l-.27.08c.1-.02.19-.05.27-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M50.76,11.93l.44-.06s-.22.02-.44.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M45.02,9.35c-.16.05-.23.07-.25.09.24-.06.61-.15.25-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M45.66,12.2c.08,0,.17-.02.26-.03-.07,0-.16.01-.26.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.78,9.49s.06-.02.1-.03c-.07,0-.13,0-.11-.02-.18.05-.29.09.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M50.76,14.04s-.03,0-.05.01c.06,0,.06-.01.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M46.55,15.38s-.03-.01-.04-.02c-.03,0-.02.02.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.61,9.02s-.05,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M46.29,8.66s.11-.01.21-.03c-.1.02-.17.03-.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M47.46,9.16s0,0,0,0c.08-.02.07-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.8,8.96c-.05.01-.09.03-.12.04.03,0,.07-.02.12-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.6,9s.03-.01.04-.02c-.07.01-.12.02-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.63,9.03s.01-.02.04-.03c-.03,0-.05.01-.07.01,0,0,.02,0,.03.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M49.42,13.14s-.02,0-.04,0c.18-.02.15-.02.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M49.56,9.85s-.02,0-.02,0c0,0,0,0-.01,0h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M49.89,9.84c-.54.07-.47.05-.36.01l-1.23.23,1.59-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M50.37,11.67l.38-.1c.64-.07.43,0,.96-.13-1.34.23-.16-.11-1.5.12l.28-.07s.07,0,.05,0c.63-.15-.97.14-.79.05.1-.04.29-.08.45-.1h-.34s.26-.04.23-.02l-.12-.05h.04c-.21.02-.54.06-.68.07.19-.05.14-.02.31-.05l-.33.02c.34-.08.69-.1.64-.07,1.33-.27-.34.03.43-.18h.18c.76-.15.48-.13.94-.25-.25.05-1.18.29-1.52.3.1-.03.14-.05-.13-.03.48-.08.36-.08.32-.1l.63-.11c-.19,0-.51.06-.79.09.06-.04.54-.13.95-.21.09-.07-.78.17-.91.13.23-.08-.03-.07-.41-.05.21-.07.39-.06.56-.1l-.51.06s.17-.03.24-.05c-.2.01-.63.11-.81.1-.7.11,1-.25.21-.15.18-.04.39-.06.63-.11-.53.03-.38.02-1.09.09l.41-.11c-.47.11-1.03.17-1.5.22-.23.05-.43.09-.52.12h-.35c.1-.02.32-.05.58-.09-.05,0-.1.01-.15.02.23-.06.59-.11.95-.16-.12.03-.25.06-.39.09.39-.05.81-.11,1.18-.18-.07,0-.14.01-.17.01.1-.01.2-.03.26-.04.07-.01-.07,0-.24.02l.7-.13-.28.05.43-.15c-.72.07-1.76.21-2.07.18.52-.07.84-.14,1.45-.25-.64.13.29.01.16.08.06-.03.36-.08.46-.09l-.6.03c.5-.08.37-.08.57-.14-.98.19-.67.06-.97.08.33-.06.67-.11.6-.06.74-.17-1.17.15-.54,0,0,0-.04.02.13,0-.3.03-.07-.06.22-.1h0c.11-.07-.02-.17-.86-.04.11-.02,1.01-.17,1.18-.19l-2.84.38c.72-.12,2.43-.45,2.84-.47.1-.03.22-.07-.04-.06-.1.03-1.04.2-1.1.2.8-.18.42-.1,1.1-.26-.15.04-1.28.22-1.25.19.17-.03,1.11-.2,1.23-.21l-1.12.14c.2-.02.94-.16,1.25-.23-.22.04.01-.05-.1-.05l-.25.07c.16-.09-1.57.21-1.52.13.23-.03,1.41-.23,1.55-.28-.57.08-2.74.41-3.19.43l.32-.07-.38.02c.86-.12,2.67-.36,3.37-.44.25-.07.38-.07.35-.1.3-.07.46-.06.48-.05l.18-.12c-.66.12-.68.05-1.23.15l.7-.03c-.66.12-1.89.27-1.78.19.26-.06,1.18-.19,1.4-.23-.23.03-.45.02-.28-.01l.36-.04c.24-.08-.89.1-.26-.05.04-.02.85-.19.45-.12-.75.15-3.09.56-3.66.65.05-.01.71-.2,1.08-.28.59-.13,1.42-.21,1.92-.32-.18.03-.41.06-.48.06.15-.04.56-.09.47-.11-.67.11.05-.07-.57.08-.2,0,.13-.06.1-.09-.43.09-1.48.22-1.68.23.17-.03.39-.07.49-.09.05-.07.35-.16.34-.22.16-.03.35-.1.64-.13-.12.01-.35.04-.37.03.57-.14.1.02.79-.12-.39.07-.55.05-.79.06-.6.11-.11.08.14.06-.83.14-1.71.25-2.1.26-.21-.01.53-.11.41-.1.13-.12-1.47.17-.88,0,.52-.12,1.05-.18,1.43-.26.21,0-.33.12-.3.14l.24-.08c.18-.02.32-.01.17.03.47-.11.06-.17.49-.32-.18.02-.37.03-.58.08h.08c-.42.1-.6.07-.79.13-.31.02-.78.07-.55-.01l.6-.11c-.18.03-.36.09-.17.07-.27.03.81-.21.01-.09l-.41.1c-.31.02-.96.1-.77.03-.59.12.07,0-.62.14.86-.17-.02.1.89-.09-.81.17-.34.11-1.02.26.2-.04.38-.08.29-.03.06,0,.13-.02.18-.02,0,0,0,0-.01,0,0,0,.02,0,.02,0,.03,0,.04,0,0,0,.09-.02.19-.05.3-.07.46-.06.45-.01.69-.04-.09.03-.23.03-.44.08l.36-.04c-.44.08-.73.18-.99.18v.04c-.26.07-.35.12-.16.1-.09.04.5-.04.15,0h.28s-.11.03-.11.03c-.05.07.75,0-.03.21.12,0,.26,0,.14.05l-.38.07c.14,0-.37.15.03.09-1.03.21-.2.17-.38.25l.5-.08s.12.04.33.05l.44-.08c.37-.03-.3.14-.24.19-.17.03-.13,0-.03-.02-.99.24.75.01.03.19.16-.01.11,0,0,.04,0,0,0,0-.02,0,0,0,0,0,0,0-.07.02-.16.04-.23.06.11-.02.19-.05.23-.06.01,0,.07.02.18.01l-.47.09s0,0,.01,0c-.17.05.23-.03.58-.1.08,0,.17-.01.29-.03-.76.15.27,0-.55.16.4-.06.31.03,1.15-.1-.11.02-.16.03-.17.03-.09.04-.18.07.05.05l-.6.11.82-.1c-.36.09-.58.14-1.04.19.72-.06.28,0,.99-.07l-.39.07s.55-.05.22.02c-.73.17-.07.22-.74.44,1.14-.22-.51.14.38-.01-.27.05-.42.09-.66.12.28,0-.42.15.34.06-.27.05-.4.06-.56.09.06,0,.24-.02.08,0-.16.03-.23.03-.35.04.06.05.89-.09,1.68-.23-.37.09-.31.1.21.03-.26.05-.52.12-.62.1-.03.03-.36.18.27.07-.16.03-.04.03.03.03-.03.05-.09.06-.02.09l.1-.03c.76-.12.18,0,.27.02h-.08c-.53.18.27,0-.34.18l.47-.09c1.02-.17-.59.17-.19.15l.27-.06c.35-.04-1.37.31-1.49.35-.09.02-.14.02-.21.02-.59.17.62-.1.77-.08-.33.07-.85.14-.91.18-.27.06,1.1-.1.47.06.26-.05.51-.11.71-.12.1.02-.96.26-.14.15-.07.02-.14.03-.2.04.21-.01.36.02.8-.04-1.63.31.82.02-.68.28l.09.06-.15.02c-.09.07.27.02.64-.02-.1.03-.24.05-.32.06-.29.13-.23.12.54.05l-.49.09c.29-.03-.75.24-.17.21-.06,0-.15.02-.22.03.59-.02-1.32.43.46.15l.45-.02c.13-.09.77-.12,1.06-.2.11,0-.52.16-.62.15l.09-.02c-.93.15-.31.14-.95.25.07.13-.42.35-.44.48l.72-.14-.03.05c-.17.04-.56.11-.54.08-.41.09.35,0,.51-.03-.28.11-.84.12-.86.14l.06.02.08-.02c.3-.03.61-.08.58-.04-.14.05-.44.09-.47.1-.05,0-.07.02-.02.02l-.05.07.57-.12c.28-.02-.02.06.62-.08-.99.21-.32.27-.62.35.42-.04.42,0,.38.05.12-.03.76-.15.68-.1-1.32.22-.56.17-1.51.36.63-.14.17.08,1.06-.12-.1.05-.49.09-.8.17.52-.02-.3.22-.12.28.17-.03.44-.09.7-.12l-.86.2c.09,0,1-.16.41-.02.15-.03.36-.07.42-.07-.81.32.75.24-.8.7.33-.08.37-.07.38-.06.08-.03.43-.07.66-.12l-.64.19c.65-.1.06.07.68-.03h-.12c.74-.1,1.63-.33,2.57-.49-.84.11,1.22-.31.02-.16.19-.05.31-.04.52-.09-.41.06-.49.05-.32-.01h.1c-.11-.09.28-.2.52-.35l-.47.09c.06-.03.2-.06.32-.09-.71.1-.03.07-.81.18.94-.19-.01-.16,1.06-.37,0-.04-.54.1-.54.07l.29-.06-.38.06c.06-.03.42-.11.67-.15-.03.01.07,0,.09,0,.34-.09-.13-.06-.02-.09l-.17.06c-.29-.05.07-.23-.54-.22l-.22.05c-.42,0,.23-.1.03-.14h.05c-.22.02-.34.02-.31,0,.26-.03.5-.12.78-.15-.45,0-.35.02-1.18.12l.36-.08c-.33.04-.51.07-.61.05.32-.02.55-.12.97-.16.79-.22-.83.02.33-.22-1.02.14-.55.17-.77.18-.33.07-.76.1-.66.06.02-.03,1.29-.27,1.26-.33,0,0,.07,0,.07,0,.25-.07-.36.01.06-.09-.61.09.03-.04-.75.09l.19.03c-.21,0-1.13.13-.69,0,.16-.02.37-.04.49-.05.23-.06-.16,0,.08-.06.78-.13.18.04.78-.03.33-.07-.58.03.27-.1-1.08.16.12-.09-.7.01l.47-.08c-.07,0-.3.03-.29.02l.61-.08c-.52.05.44-.15.15-.13.03.07-.56.11-.9.2-.64.02,1.21-.26.97-.32.07,0-.27.1-.49.12.09-.04.27-.09.51-.14-.11-.05-.48.09-.77.12.57-.12-.24,0-.42.01l.48-.08c.29-.13-.99.15-.64.02l.66-.09h-.18s.54-.09.54-.09c-.41.03-.31,0-.16-.06-.33.07-.86.15-.88.11.28-.07.45-.07.38-.1.3-.04.67-.09.24,0,.16-.02.3-.04.45-.07.32-.08.06-.07.06-.09-.02,0-.04.02-.11.04l-.67.05c.18-.04.32-.06.46-.07-.05,0-.27.02-.32.01.39-.06.79-.13.97-.14h-.44c.17-.02.46-.1.6-.12.22-.07-.76.04-.47-.06-.08.01-.15.02-.2.02.08-.06.55-.18,0-.14l.69-.15c-.16-.01-.87.19-1.14.17-.23-.01.59-.12.78-.17-.35.04-1.07.12-.52-.02.13,0,.03.02.09.03ZM49.98,11.22c.1,0,.41-.04.13.01-.55.08-.29.03-.13-.01ZM48.7,10.66c.16-.02.08,0-.1.05-.04,0-.02-.02.1-.05ZM45.02,9.1s.01,0,.02,0c-.18.05-.11.03-.02,0ZM45.22,9.01c-.07,0-.13.02-.2.03.12-.02.13,0,.1,0,.12-.02.21-.05.1-.04ZM46.25,13.84l.12-.03c.14,0,.02.01-.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M49.37,10.63c-.08.02-.17.03-.26.05.08,0,.17-.03.26-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M50.68,11.94s0,0,0,0c.03,0,.06,0,.09-.01h-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M49.37,9.02c-.07.02-.15.04-.24.06.12-.02.21-.04.24-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.37,8.91h.13s.08-.03.15-.05c-.11.02-.27.05-.28.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M47.27,8.15c-.06,0,0,0-.07,0l-.22.04s.2,0,.29-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M45.94,8.61c.4-.07.26-.07.18-.07,0,0,0,0,0,0-.56.09-.37.08-.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M46.11,8.54s-.03,0-.01-.02c-.22.04-.05.02.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M44.94,9c.1-.03-.51.08-.35.05-.51.08.63-.04.35-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "47.26 8.37 46.77 8.46 47.17 8.4 47.26 8.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M46.92,8.59l.13-.06c-.08.01-.13.02-.17.02-.01.02-.11.06.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M46.88,8.56s0-.02-.09-.01c0,0,.02.01.09.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "47.41 8.39 47.31 8.41 47.28 8.44 47.41 8.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M46.89,8.96h.15c.17-.01.27-.04.2-.04-.12.01-.19.01-.35.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M48.22,8.61c-.1.03-.21.05-.37.08l.61-.11-.24.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M48.38,8.69c.17-.03.5-.03.45-.07-.17.03-.32.01-.45.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "47.7 9.36 47.69 9.35 46.69 9.53 47.7 9.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M50.18,9.41c.23-.08-.62.1-.33,0-.24.03-.24.07-.45.1.25-.02.12.02.77-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M49.41,9.52s-.09,0-.15.01c.06,0,.11,0,.15-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "46.03 15.58 45.82 15.64 46.16 15.56 46.03 15.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M46.78,15.5l-.64.12.58-.08s-.09,0,.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M51.25,10.92l-.15.02c-.17.03-.18.04-.2.06l.36-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "50.84 11.37 50.85 11.36 50.27 11.48 50.84 11.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M51.63,11.55s-.11,0-.09-.03c.11,0-.63.15.09.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.96,50.66s-.2-.32-.24-.39c.03.09.3.48.24.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "21.32 51.56 21.23 51.42 21.43 51.79 21.32 51.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.16,51.66c.4.59,0-.13.16.06l.09.13-.3-.49c.02.1.18.45.05.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.25,50.4c.15.23.11.21.06.06-.02-.02-.03-.04-.04-.06,0,0,0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.27,50.41s-.14-.19,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.29,50.59l-.11-.22c-.09-.14-.13-.16-.19-.26.05.13.14.26.3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.54,51.04l-.04-.1c-.04-.06-.05-.08.04.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.4,50.75l.09.2c.06.1.19.29-.03-.07.11.18,0,0-.06-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.48,50.83c.09.12.16.2.27.42-.01-.11-.29-.53-.27-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.55,52.28l.13.17-.11-.21c.06.1-.14-.14-.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.96,50.36c.08.13.22.34.33.5l-.08-.16c-.06-.08-.13-.16-.25-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.29,50.86l.11.24s-.02-.09-.11-.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "20.96 51.72 20.71 51.23 20.96 51.73 20.96 51.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "19.87 50.39 19.69 50.09 19.95 50.55 19.87 50.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.84,50.48c-.14-.25-.27-.41-.35-.57.01.05.13.28.23.47-.05-.11-.02-.1.12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.87,50.68c-.03-.06-.09-.17-.15-.29.03.06.08.15.15.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.32,51.06c-.05-.08-.18-.28-.25-.36l.23.36h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.32,51.07h0s-.03-.02-.03-.02c0,0,.02,0,.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.33,51.06h0s.03.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.69,51.43c.11.21.22.45.44.74-.14-.25-.27-.42-.44-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.62,51.5l.08.07c-.06-.1-.15-.23-.21-.34l.13.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "20.68 51.63 20.62 51.5 20.59 51.48 20.68 51.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.12,50.99c.09.17.08.19.09.22.06.06.1.09.11.08-.07-.12-.19-.32-.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.24,51.06v.02s.04.04,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.07,51.29s.03.04.04.07l-.04-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.36,51.36c.05.06,0-.03-.06-.15.01.04.02.07.01.08.03.05.05.09.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.94,50.87c.05.07.1.13.14.19-.08-.11-.2-.29-.14-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.18,50.99s0-.02,0-.02c-.05-.08-.03-.04,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.18,50.99c.03.05.08.15.12.23-.01-.03-.03-.08-.06-.13-.02-.03-.04-.06-.07-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.45,53.66c-.2-.34-.36-.67-.11-.32-.13-.27-.82-1.37-1.22-1.98.09.15.17.29.27.5.12.18.32.4.48.72.07.2-.1-.1-.23-.27.27.41.33.64.71,1.26l-.1-.24c.06.1.14.26.2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.18,51.36l-.02-.05c-.05-.05-.14-.18-.31-.44.08.18.16.3.22.42l.08.02.03.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.21,51.28c.22.37.29.54.54.93.02-.04-.17-.32-.24-.49,0,.12-.11-.21-.27-.4-.03-.07-.03-.09-.03-.11-.03-.04-.08-.09-.13-.15l.02.02h0s0,0,0,0c.03.04.05.07.03.05,0,0,0,0,0,0,.03.05.06.1.08.14-.06-.07-.06-.09-.08-.14l-.03-.06h0s.07.23.07.23c.04.04.05.03.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.6,52.97s-.04-.06-.05-.08c.02.05.04.08.05.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.44,52.76c-.03-.05-.12-.2-.08-.17.08.1.11.18.18.29-.05-.1-.14-.28-.27-.44l.03.05c-.1-.11-.41-.55-.44-.61.21.32.37.55.58.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.88,52.12l.07.21.22.3-.12-.19c.07.06-.08-.17-.17-.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "19.96 51.11 19.73 50.72 20.04 51.28 19.96 51.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "19.93 51.19 19.73 50.85 19.84 51.06 19.93 51.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.93,57.25l.03.11s-.02-.07-.03-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.05,57.23l-.08-.18c.04.1.07.17.08.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.66,51.96c-.19-.32-.48-.81-.27-.42l.21.38c-.02-.08,0-.04.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.89,54.75s.04.08.06.12c-.06-.14-.12-.26-.17-.38.03.08.07.17.11.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.67,56.37l-.15-.24c.05.08.1.16.15.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.54,57.93l.16.41s-.07-.21-.16-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.48,51.64c-.1-.14-.15-.19-.17-.21.14.21.34.52.17.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M17.06,53.04c.02.08.06.16.1.25-.02-.07-.05-.15-.1-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.27,51.46s.04.05.06.08c-.03-.07-.04-.13-.02-.11-.11-.15-.18-.24-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M16.25,58.44s-.01-.03-.02-.05c.02.06.02.06.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M14.23,54.51s0-.03.01-.04c-.01-.03-.02-.02-.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.63,51.15s-.02-.04,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.56,52.59s.05.1.1.18c-.05-.09-.08-.15-.1-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.48,53.88h0c.05.07.04.06,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.75,51.31s-.06-.08-.08-.1c.02.03.05.06.08.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.64,51.13s.02.02.03.03c-.04-.06-.06-.1-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.63,51.18s.02,0,.04.03c-.02-.02-.03-.04-.04-.06,0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M16.98,56.93s0-.02-.02-.04c.05.17.05.14.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.44,56.12s0-.01,0-.02h0s.02.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.54,56.43c-.23-.49-.19-.44-.12-.34l-.59-1.1.71,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.73,57.48l.19.34c.22.6.1.42.35.9-.55-1.24.08-.19-.47-1.43l.14.25s.02.06,0,.05c.31.57-.37-.91-.23-.76.06.09.16.26.21.41l-.1-.33s.12.23.09.22l.02-.13.02.04c-.08-.2-.19-.51-.24-.64.1.17.05.13.13.29l-.1-.32c.16.31.27.64.23.6.6,1.22-.11-.32.29.36l.04.17c.35.69.26.42.5.84-.12-.22-.59-1.06-.69-1.39.05.09.09.12,0-.13.2.44.18.32.19.28l.27.58c-.05-.18-.19-.48-.3-.74.06.04.28.49.46.86.1.07-.37-.7-.36-.84.15.2.07-.05-.05-.42.12.19.16.36.25.52l-.19-.47s.08.15.11.22c-.06-.19-.27-.58-.32-.75-.3-.64.52.89.21.15.09.16.17.35.28.58-.17-.5-.12-.37-.38-1.03l.22.36c-.24-.42-.45-.95-.63-1.38-.11-.2-.21-.38-.26-.47l-.1-.33c.05.09.14.29.25.53-.02-.05-.04-.1-.06-.14.12.2.28.54.42.87-.06-.11-.13-.23-.19-.35.16.35.34.75.5,1.08-.03-.07-.05-.13-.06-.16.04.1.09.18.11.24.03.06-.03-.07-.09-.22l.33.63-.12-.26.27.37c-.27-.67-.7-1.63-.76-1.93.22.48.38.77.66,1.32-.32-.58.06.28-.04.18.05.05.18.32.22.41l-.19-.57c.23.45.19.33.3.51-.46-.89-.25-.62-.36-.91.15.3.3.61.23.56.38.65-.48-1.08-.15-.52,0,.01-.03-.03.04.12-.12-.28.04-.09.16.18h0c.11.09.18-.07-.2-.83.05.1.46.92.54,1.07l-1.22-2.59c.33.65,1.17,2.18,1.31,2.57.06.08.14.18.05-.06-.06-.09-.51-.92-.53-.99.41.7.23.37.59.96-.09-.13-.6-1.15-.57-1.13.08.15.52,1,.58,1.11l-.47-1.02c.08.19.44.84.6,1.12-.11-.19.06,0,.02-.11l-.15-.22c.14.12-.68-1.43-.6-1.41.1.21.66,1.27.76,1.38-.26-.52-1.25-2.47-1.41-2.89l.17.28-.14-.35c.39.77,1.19,2.41,1.48,3.06.15.22.19.34.21.29.16.26.2.42.2.44l.18.13c-.32-.59-.26-.63-.53-1.12l.24.66c-.32-.59-.86-1.7-.75-1.63.14.23.56,1.06.67,1.25-.1-.21-.16-.42-.07-.28l.15.33c.15.2-.38-.81-.03-.27.03.03.46.74.27.39-.39-.66-1.54-2.74-1.81-3.25.03.04.42.61.62.93.31.51.66,1.27.93,1.71-.09-.16-.19-.37-.22-.43.09.13.27.5.26.41-.33-.6.09.02-.27-.51-.07-.19.1.11.12.06-.23-.38-.7-1.32-.77-1.51.09.15.2.34.25.43.09.02.27.27.33.25.09.14.21.3.35.56-.05-.11-.16-.31-.15-.34.33.49,0,.1.38.7-.19-.34-.23-.5-.33-.73-.31-.53-.11-.07-.01.16-.42-.73-.82-1.52-.96-1.89-.06-.21.29.46.24.35.16.08-.67-1.31-.3-.83.3.45.54.92.74,1.25.07.2-.23-.26-.24-.23l.16.2c.08.16.12.29.03.17.27.4.19,0,.48.35-.08-.16-.16-.33-.27-.52l.02.08c-.24-.36-.27-.54-.4-.7-.13-.28-.34-.71-.18-.52l.32.52c-.09-.15-.21-.3-.13-.13-.12-.24.48.68.09-.02l-.24-.35c-.13-.28-.43-.86-.3-.71-.33-.51.03.06-.36-.53.47.75-.1.02.41.79-.44-.69-.22-.28-.6-.86.1.17.21.33.13.26.03.05.06.12.09.16h0s.01,0,.01,0c.01.03.02.03,0,0,.05.07.11.16.17.26.22.41.17.42.28.64-.06-.07-.11-.2-.23-.38l.16.32c-.23-.39-.42-.62-.52-.87h-.04c-.15-.2-.22-.28-.14-.1-.06-.08.21.45.05.14l.09.27-.06-.1c-.08-.02.26.71-.2.04.04.11.09.24,0,.15l-.2-.33c.04.13-.26-.3-.07.06-.54-.9-.22-.14-.35-.28l.24.44s0,.13.07.33l.22.39c.15.34-.23-.24-.25-.17-.08-.15-.05-.12.01-.03-.54-.86.23.71-.17.09.06.15.03.11-.03.01,0,0,0,0,0-.02,0,0,0,0,0,0-.04-.06-.09-.14-.13-.2.06.09.11.17.13.2,0,.01,0,.07.04.18l-.23-.42s0,0,0,.01c-.1-.15.1.21.27.52.03.07.07.16.12.27-.38-.68.08.25-.32-.47.18.36.07.31.46,1.06-.05-.1-.08-.14-.08-.15-.06-.08-.12-.15-.03.07l-.29-.54.35.75c-.19-.32-.3-.51-.5-.94.28.67.08.26.37.92l-.18-.35s.21.51.05.22c-.38-.65-.23,0-.63-.58.54,1.03-.28-.45.12.36-.13-.24-.21-.38-.3-.6.07.27-.26-.36.04.34-.12-.25-.18-.36-.25-.51.02.06.09.22.01.08-.08-.15-.1-.21-.14-.32-.03.06.35.83.69,1.55-.19-.33-.18-.27.03.21-.12-.23-.26-.47-.27-.57-.03-.03-.27-.29,0,.28-.08-.14-.04-.03-.02.04-.05-.02-.08-.07-.09,0l.06.09c.32.7.04.17.05.27l-.03-.07c-.31-.47.08.26-.26-.29l.21.43c.44.94-.32-.52-.19-.15l.13.24c.13.33-.66-1.24-.73-1.35-.04-.08-.05-.13-.08-.2-.31-.52.26.57.28.72-.15-.3-.35-.79-.41-.83-.13-.24.38,1.04.07.46.12.23.24.47.3.65,0,.1-.49-.86-.18-.1-.03-.06-.06-.13-.09-.18.07.2.07.35.24.77-.7-1.5.18.8-.44-.59l-.04.11-.06-.14c-.09-.07.05.27.18.61-.05-.09-.1-.22-.13-.3-.19-.25-.17-.19.08.53l-.2-.45c.1.27-.4-.67-.24-.11-.02-.05-.05-.14-.08-.21.15.57-.71-1.19-.04.48l.12.43c.12.1.29.73.43.99.01.11-.28-.48-.28-.57l.04.08c-.35-.87-.21-.27-.45-.87-.11.09-.42-.34-.56-.33l.28.67-.06-.02c-.07-.15-.22-.53-.18-.51-.17-.38.08.34.14.49-.17-.25-.29-.8-.31-.81v.06s.03.08.03.08c.09.29.2.58.16.56-.08-.13-.18-.42-.19-.44-.02-.05-.03-.07-.02-.01l-.07-.04.23.53c.08.27-.06,0,.2.59-.4-.93-.33-.26-.46-.55.12.41.08.41.02.38.05.11.29.71.22.65-.46-1.26-.27-.52-.63-1.41.25.59-.04.18.31,1.02-.07-.09-.18-.47-.31-.76.11.51-.26-.26-.29-.07.06.17.16.41.23.67l-.34-.81c.01.09.33.96.09.4.05.14.13.35.14.4-.45-.75-.12.78-.8-.68.13.32.13.35.11.37.04.07.14.41.22.64l-.28-.6c.2.63-.06.07.13.67v-.12c.19.72.55,1.56.85,2.47-.23-.82.49,1.16.17-.01.08.18.09.3.17.5-.12-.39-.12-.48-.03-.32l.03.1c.06-.13.24.24.43.46l-.16-.44c.04.05.1.19.15.3-.21-.69-.08-.02-.31-.77.35.9.17-.04.55.98.04,0-.19-.51-.16-.52l.11.28-.12-.36c.04.05.18.4.27.63-.02-.03,0,.07,0,.09.15.32.05-.14.1-.04l-.1-.16c0-.3.26.03.15-.57l-.08-.21c-.07-.41.14.21.15,0l.02.05c-.06-.21-.08-.33-.05-.31.07.25.22.46.29.74-.08-.44-.08-.34-.33-1.14l.14.34c-.1-.32-.16-.49-.16-.59.08.31.23.52.34.93.37.73-.17-.81.29.28-.33-.97-.28-.5-.33-.72-.14-.31-.25-.73-.18-.64.03.01.52,1.21.58,1.16,0,0,.02.07.01.07.12.23-.08-.35.1.03-.21-.58.05.02-.23-.72v.19c-.03-.21-.34-1.08-.12-.68.05.15.12.35.15.46.1.21-.03-.16.08.06.29.74,0,.19.18.77.14.3-.14-.56.16.24-.38-1.02.12.1-.15-.69l.17.44c-.02-.07-.09-.29-.07-.28l.21.58c-.16-.5.24.4.17.12-.07.04-.23-.52-.39-.83-.15-.62.52,1.13.53.88.01.07-.16-.24-.22-.46.06.08.15.24.26.47.03-.12-.2-.45-.28-.73.24.53-.06-.23-.1-.41l.18.45c.19.25-.36-.94-.15-.62l.23.63-.03-.17.2.51c-.12-.39-.07-.3.03-.17-.14-.31-.33-.81-.31-.84.13.25.16.43.19.34.11.28.24.64.05.24.06.15.11.28.16.43.15.29.09.04.11.03-.01-.01-.03-.03-.06-.1l-.19-.65c.08.16.13.3.18.43,0-.05-.08-.26-.08-.31.15.36.31.73.35.92l-.1-.43c.07.15.22.42.27.55.13.2-.21-.74-.04-.48-.03-.07-.05-.14-.06-.2.08.06.31.49.15-.03l.31.63c-.02-.16-.4-.79-.43-1.07-.04-.23.26.54.36.71-.12-.34-.37-1.01-.09-.51.04.13-.02.04,0,.09ZM19.11,56.96c.03.1.14.39.02.13-.22-.51-.1-.27-.02-.13ZM19.37,55.55c.06.15.02.08-.08-.08,0-.04,0-.03.08.08ZM19.71,51.56s0,.01.01.02c-.11-.15-.07-.09-.01-.02ZM19.85,51.72c-.03-.06-.06-.12-.1-.18.06.11.05.12.03.1.07.11.12.18.07.08ZM15.65,53.96l.05.11c.03.14,0,.02-.05-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.58,56.18c-.04-.07-.08-.15-.12-.23.03.07.07.16.12.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "18.51 57.85 18.5 57.85 18.54 57.93 18.51 57.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.24,55.63c-.04-.06-.09-.13-.14-.21.06.1.11.19.14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.63,50.89l.04.12s.06.06.1.12c-.06-.1-.15-.23-.14-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.39,53.32c-.03-.05,0-.01-.02-.06l-.12-.19s.07.18.14.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.47,52.26c.21.35.16.22.13.14,0,0,0,0,0,0-.29-.49-.21-.32-.13-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.61,52.39s0-.03.01-.02c-.11-.2-.03-.04-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.76,51.46c.06.08-.26-.45-.17-.31-.25-.45.26.57.17.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "21.17 53.4 20.91 52.97 21.11 53.32 21.17 53.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.84,53.17l.1.1c-.04-.07-.06-.12-.08-.15-.03,0-.1-.08-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.86,53.12s.02-.01-.02-.08c0,0,0,.03.02.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "21.21 53.55 21.15 53.46 21.11 53.44 21.21 53.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.48,53.26l.04.14c.08.15.14.24.12.17-.05-.11-.07-.17-.16-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.27,54.39c-.06-.08-.12-.18-.21-.32l.31.54-.1-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.24,54.58c.08.15.2.46.22.4-.08-.15-.12-.29-.22-.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "20.36 54.17 20.37 54.16 19.87 53.27 20.36 54.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.07,56.56c.16.19-.29-.56-.1-.31-.1-.22-.15-.2-.24-.39.09.24.01.12.34.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.73,55.85s-.03-.08-.06-.14c.02.06.04.1.06.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "13.97 54.02 13.88 53.83 14 54.15 13.97 54.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M14.16,54.75l-.21-.61.17.56s0-.09.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.74,58.11l-.06-.14c-.08-.15-.09-.16-.11-.18l.18.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "19.16 57.85 19.17 57.85 18.92 57.32 19.16 57.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.14,58.67s-.01-.11,0-.09c.01.11-.31-.57,0,.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.12,30.09s-.1.37-.12.44c.04-.08.14-.55.12-.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: ".56 29.22 .52 29.38 .65 28.99 .56 29.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.76,29.28c.15-.7-.1.09-.08-.16l.03-.16-.15.55c.06-.08.21-.43.2-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.49,30.8c.06-.27.08-.23,0-.09,0,.03,0,.05-.01.07,0,0,.01,0,.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.48,30.78s-.04.23,0,0H.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.61,30.65l-.09.23c-.03.16-.02.2-.06.32.06-.12.09-.28.14-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.76,30.15l-.04.1c-.01.07-.02.09.04-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.64,30.46l.08-.21c.02-.11.08-.34-.03.07.05-.2,0,0-.05.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.65,30.35c.02-.15.03-.25.11-.49-.08.08-.19.57-.11.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.95,28.56l.03-.21-.08.23c.04-.11,0,.2.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.69,31.05c.03-.15.09-.39.14-.58l-.06.16c-.02.1-.02.2-.07.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.82,30.47l.09-.25s-.05.08-.09.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: ".96 29.38 .78 29.9 .97 29.38 .96 29.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: ".79 31.1 .69 31.43 .85 30.92 .79 31.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.88,31.05c-.08.28-.11.48-.16.65.03-.05.11-.28.18-.5-.05.12-.06.08-.02-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1,30.9c-.02.07-.06.18-.11.31.03-.06.06-.15.11-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.95,30.31c-.02.09-.08.32-.08.43l.09-.42h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.96,30.3h0s.02.04.02.04c0,0,0-.02-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.94,30.3h0s.01-.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M.94,29.78c.08-.23.18-.47.23-.83-.08.28-.11.49-.23.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.06,29.78v-.1c-.03.11-.07.27-.11.38l.11-.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "1.11 29.65 1.06 29.78 1.06 29.82 1.11 29.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.05,30.5c.06-.18.08-.19.1-.21,0-.09,0-.13-.02-.14-.04.13-.1.36-.08.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.02,30.37v-.02s.02-.05,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.31,30.33s.01-.05.02-.08l-.02.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.15,30.07c0-.08-.03.02-.07.14.02-.04.04-.06.05-.06.02-.06.03-.1.02-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.1,30.72c.01-.09.03-.16.04-.23-.03.13-.07.34-.04.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1,30.46s0,.02,0,.02c-.02.09,0,.05,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1,30.46c.02-.06.05-.16.08-.25-.02.03-.04.07-.06.13,0,.03-.02.07-.03.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M2.08,27.69c-.11.38-.24.73-.16.31-.11.28-.42,1.54-.58,2.25.05-.17.09-.32.18-.54.05-.21.06-.51.18-.85.09-.19,0,.14-.04.35.11-.48.24-.68.42-1.38l-.1.24c.03-.11.09-.28.11-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.29,30.2l-.02.04c0,.07-.03.23-.1.53.07-.18.11-.32.15-.45l-.05-.07.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.2,30.23c.12-.41.2-.58.3-1.04-.05.02-.12.34-.19.52.09-.09-.08.23-.1.48-.03.07-.05.09-.06.1,0,.05-.01.12-.02.2v-.03s0,0,0,0h0c.01-.06.02-.09.01-.06,0,0,0,0,0,0,.02-.06.03-.11.04-.16,0,.09-.03.11-.04.16l-.02.06h0s.12-.21.12-.21c0-.06-.02-.05-.06-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.43,28.06s-.02.07-.02.1c.02-.05.03-.08.02-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.4,28.32c-.02.06-.07.22-.07.18.02-.13.05-.2.08-.34-.04.11-.11.29-.13.5l.02-.06c-.01.15-.11.68-.13.74.08-.38.14-.65.23-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.33,29.17l.1-.19.07-.37-.05.22c0-.09-.07.18-.12.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "1.27 30.54 1.14 30.98 1.34 30.36 1.27 30.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "1.34 30.5 1.24 30.88 1.32 30.66 1.34 30.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M6.81,27.48l.06-.09s-.04.06-.06.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M6.72,27.41l-.09.17c.05-.09.09-.16.09-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M2.76,30.91c-.12.35-.31.89-.15.48l.15-.4c-.04.07-.03.02,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.81,29s.04-.08.05-.12c-.07.13-.14.25-.2.36.05-.08.1-.16.15-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.65,27.41l-.1.26c.04-.09.07-.18.1-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.48,27.3l.2-.4s-.1.2-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M2.01,30.53c-.03.17-.04.24-.04.26.05-.24.15-.61.04-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.65,31.55c.05-.06.09-.14.13-.23-.04.06-.09.13-.13.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M2.02,30.8s.01-.06.02-.1c-.03.07-.06.12-.07.09-.04.18-.06.3.05.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M8.49,27.96s0,.03,0,.05c0-.06,0-.06,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M9.53,32.22s-.02.03-.03.04c.01.03.02.02.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.54,30.75s-.02.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.94,29.08s.03-.11.06-.2c-.03.1-.05.16-.06.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M2.97,28.28h0c.02-.08.02-.06,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.57,30.56c0,.05-.01.1-.02.13,0-.03.01-.08.02-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.52,30.76s0-.03,0-.04c-.02.07-.03.11,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.56,30.74s-.01-.02,0-.05c0,.03-.01.05-.02.07,0,0,.01-.01.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.65,28.99s0,.02,0,.04c.06-.17.05-.14,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.84,26.9s0,.01-.01.02v.02s.01-.03.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.03,26.63c-.24.48-.23.42-.2.3l-.48,1.16.68-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.08,27.48l.15-.36c.32-.56.24-.35.46-.85-.61,1.21-.16.07-.78,1.28l.11-.26s.04-.06.04-.04c.26-.6-.48.86-.44.66.03-.1.11-.28.19-.42l-.19.28s.11-.24.11-.21l-.11.06.02-.04c-.11.18-.28.46-.36.58.07-.18.08-.12.15-.28l-.19.27c.15-.32.34-.61.34-.55.6-1.22-.19.29.11-.45l.11-.14c.34-.69.18-.46.37-.9-.11.23-.49,1.11-.69,1.39.04-.1.05-.15-.1.08.23-.43.15-.33.11-.32l.3-.56c-.11.15-.26.44-.42.68,0-.07.22-.51.41-.89,0-.12-.34.72-.45.79.07-.24-.08-.02-.31.29.07-.21.19-.34.26-.51l-.27.44s.07-.15.11-.22c-.12.16-.3.56-.42.7-.34.62.41-.95-.01-.27.07-.17.19-.34.3-.57-.31.43-.23.31-.61.91l.15-.4c-.19.44-.49.93-.74,1.32-.09.21-.18.4-.22.49l-.21.28c.04-.1.15-.29.28-.52-.03.04-.05.09-.08.13.09-.22.27-.54.44-.85-.05.12-.11.24-.16.36.19-.34.4-.71.57-1.05-.04.06-.07.12-.1.14.05-.09.09-.18.12-.23.03-.06-.04.06-.13.2l.31-.64-.13.25.12-.44c-.38.61-.9,1.53-1.11,1.76.25-.46.38-.76.65-1.32-.27.6.19-.22.18-.07,0-.07.14-.33.2-.42l-.35.49c.23-.45.15-.35.22-.55-.42.91-.36.57-.52.83.14-.3.3-.61.31-.52.28-.7-.57,1.03-.34.43.01,0,0,.05.07-.11-.15.26-.11.02.03-.24h.01c-.02-.14-.21-.11-.57.67.05-.1.43-.93.5-1.09-.43.85-.85,1.71-1.26,2.57.3-.67.95-2.28,1.17-2.64.02-.1.05-.22-.09,0-.03.1-.39.98-.43,1.04.28-.77.14-.41.36-1.07-.04.15-.51,1.2-.52,1.16.07-.16.44-1.04.49-1.15l-.5,1.01c.09-.18.37-.88.47-1.18-.08.21-.05-.04-.11.05l-.07.25c-.02-.19-.66,1.44-.71,1.36.09-.21.54-1.32.55-1.47-.23.53-1.07,2.56-1.27,2.95l.1-.31-.17.34c.32-.81,1.04-2.48,1.35-3.12.06-.26.13-.37.07-.36.09-.29.19-.43.21-.44l-.04-.23c-.23.63-.32.6-.51,1.13l.36-.61c-.23.63-.73,1.76-.76,1.63.07-.26.42-1.12.5-1.33-.09.21-.22.39-.17.23l.15-.33c.04-.25-.37.81-.2.19,0-.05.24-.83.1-.46-.22.73-1.01,2.97-1.21,3.51.01-.05.17-.72.28-1.08.17-.58.5-1.34.65-1.84-.06.17-.15.38-.18.45.03-.15.19-.54.13-.47-.23.64-.06-.08-.2.54-.1.17,0-.15-.04-.13-.13.42-.51,1.41-.6,1.59.05-.17.12-.38.15-.48-.05-.08,0-.39-.05-.41.04-.16.07-.36.17-.64-.05.11-.12.33-.15.34.13-.58.07-.07.25-.76-.12.38-.22.5-.32.73-.17.59.03.13.13-.09-.25.81-.56,1.63-.74,1.99-.11.19.14-.53.09-.42-.05-.17-.5,1.39-.4.78.12-.52.3-1.03.4-1.4.1-.18-.03.35,0,.33l.04-.25c.06-.17.13-.29.1-.13.11-.47-.14-.14-.09-.59-.06.17-.14.34-.19.55l.04-.07c-.1.42-.21.56-.23.77-.11.28-.28.74-.25.49l.16-.59c-.05.17-.07.36,0,.18-.09.26.15-.82-.08-.05l-.08.42c-.11.29-.32.91-.31.71-.14.59.03-.06-.13.63.21-.86.08.06.29-.84-.19.8-.05.35-.2,1.03.05-.19.09-.38.1-.27.02-.06.04-.13.05-.17v.02s0-.02,0-.02c0-.03.01-.03,0,0,.02-.09.04-.19.07-.3.14-.44.19-.41.27-.64,0,.1-.07.22-.12.43l.12-.34c-.12.43-.16.73-.27.97l.03.03c-.05.25-.05.35.02.18-.01.1.18-.46.07-.13l.14-.25-.03.11c.04.07.34-.67.16.12.05-.1.11-.23.11-.1l-.11.37c.07-.12-.05.39.08.01-.3,1,.04.25.02.44l.17-.48s.09-.09.19-.27l.15-.42c.16-.34-.03.33.03.3-.06.16-.06.11-.03.01-.3.97.38-.65.17.06.07-.15.06-.09.03.02,0,0,0,0-.01.02,0,0,0,0,0,0-.02.07-.05.16-.07.23.03-.1.06-.19.07-.23.01,0,.05-.05.1-.15l-.17.45s0,0,0-.01c-.05.17.1-.21.22-.55.03-.07.08-.16.13-.26-.28.73.14-.23-.16.55.16-.37.19-.25.52-1.03-.04.1-.06.15-.07.16-.02.1-.04.19.07-.02l-.23.57.36-.74c-.12.35-.2.56-.41.98.34-.64.15-.23.48-.87l-.16.36s.27-.48.14-.18c-.28.7.14.18-.08.85.5-1.06-.19.49.21-.32-.12.25-.17.4-.29.6.17-.22-.13.42.25-.24-.13.25-.19.36-.26.5.03-.05.12-.21.05-.06s-.11.2-.17.31c.07-.02.46-.77.82-1.48-.15.35-.11.31.15-.15-.11.24-.22.49-.29.55,0,.04-.07.4.23-.17-.07.15,0,.06.04,0,.02.05,0,.11.07.08l.04-.1c.38-.67.11-.13.19-.2l-.04.07c-.19.53.16-.22-.07.38l.22-.43c.49-.91-.22.57.01.25l.11-.25c.19-.3-.59,1.27-.63,1.4-.04.08-.08.12-.11.18-.22.57.3-.55.42-.65-.15.3-.42.76-.41.83-.11.25.61-.92.35-.32.11-.24.22-.47.34-.63.08-.06-.36.93.05.21-.03.06-.06.13-.09.19.12-.17.25-.27.47-.66-.73,1.49.53-.63-.15.73l.13-.03-.07.14c.01.12.2-.2.38-.52-.03.1-.1.22-.14.29-.05.32,0,.27.39-.39l-.2.45c.14-.25-.19.77.13.28-.02.05-.06.14-.1.2.32-.49-.27,1.38.45-.27l.23-.39c-.03-.16.3-.72.38-1.02.07-.09-.12.54-.19.61l.03-.09c-.36.87-.02.35-.24.95.19.02.21.58.4.67l.18-.71.05.06c-.03.17-.13.56-.17.51-.09.41.17-.31.21-.46.01.31-.26.81-.24.84l.06-.04v-.08c.12-.28.21-.59.25-.54,0,.15-.09.44-.09.47-.01.05-.01.08.02.03l.07.08.1-.57c.1-.27.07.05.18-.6-.18,1,.22.42.19.73.13-.4.17-.39.23-.33,0-.12.09-.76.13-.68-.21,1.32.01.59-.05,1.55.03-.64.19-.14.21-1.05.03.11-.05.5-.04.82.16-.51.25.36.42.18,0-.18-.01-.44.02-.71l.07.88c.03-.09.02-1.01.08-.4-.01-.15-.02-.37,0-.43.15.42.3.24.43.14.14-.1.26-.1.56.66-.1-.33-.08-.37-.05-.39-.03-.08-.08-.43-.12-.66l.24.62c-.11-.65.12-.08,0-.7v.12c-.13-.74-.42-1.61-.6-2.54.13.84-.29-1.21-.12-.02-.04-.19-.04-.31-.08-.52.06.41.06.49,0,.32v-.1c-.06.11-.14-.29-.21-.55l.04.47c-.02-.06-.03-.21-.05-.33.03.72.04.04.09.83-.09-.96-.12,0-.17-1.1-.02,0,.02.55,0,.54v-.3s0,.38,0,.38c-.02-.06-.02-.43-.02-.69,0,.03,0-.07,0-.09-.01-.35-.03.12-.04,0v.18c-.05.28-.06-.11-.17.48l-.02.22c-.09.41-.01-.25-.08-.06v-.05c-.03.22-.06.33-.07.3.05-.26.05-.51.11-.79-.11.43-.07.34-.25,1.15l.05-.37c-.07.33-.1.5-.16.59.09-.31.09-.56.19-.97.11-.8-.26.78-.03-.38-.25,1-.07.57-.14.78-.05.33-.19.74-.19.64-.02-.03.26-1.29.22-1.28,0,0,.02-.07.03-.06.05-.26-.12.33-.03-.08-.17.6-.02-.04-.23.72l.09-.16c-.08.19-.36,1.08-.29.63.05-.15.12-.35.16-.46.05-.23-.07.14-.02-.09.23-.76.11-.15.29-.72.08-.32-.2.54.05-.28-.32,1.04,0-.14-.27.65l.14-.45c-.03.07-.1.28-.11.27l.2-.58c-.18.49.1-.45,0-.18.05,0-.17.55-.25.88-.26.58.35-1.19.23-.99.03-.06-.06.28-.15.48.02-.1.06-.27.14-.51-.07.08-.16.46-.27.73.18-.55-.1.21-.19.38l.17-.45c.06-.31-.37.93-.29.56l.26-.62-.09.15.2-.51c-.17.37-.14.27-.11.12-.12.32-.33.81-.37.81.09-.27.19-.42.12-.37.13-.27.28-.62.12-.2.06-.14.12-.28.18-.42.11-.31-.01-.09-.03-.09,0,.02,0,.04-.03.11l-.31.59c.06-.17.13-.3.19-.43-.03.04-.13.24-.16.27.16-.36.32-.73.41-.89l-.22.38c.07-.16.17-.44.23-.57.07-.22-.37.67-.28.37-.03.07-.07.13-.1.18,0-.1.18-.54-.09-.08l.28-.64c-.1.13-.35.81-.53,1.02-.14.18.25-.55.32-.73-.18.31-.53.94-.32.4.07-.11.03-.01.07-.06ZM6.48,27.52c.06-.08.22-.35.09-.1-.27.48-.15.24-.09.1ZM5.15,28.14c.08-.14.06-.06-.01.11-.03.03-.03,0,.01-.11ZM1.79,30.42s0-.01,0-.02c-.03.19-.02.11,0,.02ZM1.8,30.2c-.02.06-.04.13-.06.19.04-.12.05-.12.05-.09.03-.12.05-.21,0-.11ZM6.97,32.17l.02-.13c.06-.13.02,0-.02.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M5.55,27.6c-.04.07-.08.15-.12.24.04-.07.08-.15.12-.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "7.44 27.37 7.44 27.38 7.48 27.3 7.44 27.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M3.78,26.54c-.01.07-.03.16-.06.24.04-.11.07-.21.06-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.35,30.93l.06-.11s0-.08.02-.16c-.03.11-.07.27-.08.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.87,27.97c-.02.06-.01,0-.03.06l-.06.22s.08-.18.09-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.75,29.37c.11-.39.05-.26,0-.2,0,0,0,0,0,0-.16.55-.08.37-.01.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.75,29.19s-.02.02-.02,0c-.06.22,0,.05.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M1.67,30.45c.02-.1-.15.5-.11.34-.15.49.23-.58.11-.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "2.08 28.08 1.96 28.57 2.08 28.18 2.08 28.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M2.16,28.48v-.14c-.02.08-.04.13-.05.16.02.02.01.12.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M2.1,28.5s-.02,0-.05.07c0,0,.02-.02.05-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "2.17 27.95 2.15 28.05 2.17 28.09 2.17 27.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M2.5,28.68l.08-.13c.05-.16.07-.27.04-.21-.04.11-.08.17-.12.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M2.78,27.33c-.02.1-.05.21-.09.37l.18-.59-.09.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M2.94,27.23c.05-.16.2-.46.14-.43-.05.16-.14.29-.14.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "3.29 28.17 3.28 28.18 2.95 29.14 3.29 28.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.7,26.09c.03-.25-.24.58-.18.28-.1.22-.05.25-.14.44.12-.22.09-.08.32-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M4.38,26.81s-.04.08-.07.14c.03-.06.05-.1.07-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "9.81 32.72 9.9 32.91 9.8 32.59 9.81 32.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M9.73,31.96l.16.63-.11-.58s0,.09-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.02,26.33l-.08.14c-.08.15-.07.17-.07.2l.15-.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "7.13 26.93 7.13 26.92 6.87 27.45 7.13 26.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M7.71,26.39s-.07.09-.07.06c.07-.08-.25.6.07-.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.24,4.63s-.27.27-.32.32c.06-.06.25-.25.32-.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "18.97 4.02 18.85 4.14 19.15 3.85 18.97 4.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.02,4.08c.5-.51-.1.06.07-.13l.11-.12-.41.4c.08-.05.36-.31.23-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M17.96,5.2c.19-.2.18-.16.05-.07-.02.02-.03.03-.05.05,0,0,0,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M17.97,5.18s-.16.17,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.11,5.1l-.18.17c-.11.12-.13.15-.22.23.1-.09.22-.2.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.49,4.74l-.08.07s-.06.07.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.24,4.96l.17-.15c.08-.08.24-.25-.06.05.15-.15,0,0-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.31,4.87c.11-.11.17-.19.35-.36-.08.05-.44.41-.35.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.55,3.56l.14-.15-.17.16c.09-.08-.12.15.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M17.89,5.41c.11-.11.29-.29.42-.42l-.13.12c-.07.08-.14.15-.29.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.32,4.98l.19-.18s-.08.06-.19.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "19.05 4.18 18.65 4.55 19.06 4.18 19.05 4.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "17.91 5.45 17.66 5.69 18.04 5.33 17.91 5.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M17.97,5.43c-.21.2-.35.35-.48.47.04-.03.23-.2.39-.35-.09.08-.08.06.09-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.13,5.32c-.05.05-.14.13-.24.22.05-.05.12-.11.24-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.47,4.87c-.06.07-.23.24-.3.31l.3-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.48,4.87h0s0,.03,0,.03c0,0,0-.01.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.47,4.87h0s.04-.04,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.8,4.48c.17-.16.37-.33.62-.6-.21.2-.36.35-.62.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.85,4.49l.06-.08c-.08.08-.2.19-.28.28l.22-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "18.95 4.4 18.85 4.49 18.82 4.52 18.95 4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.4,5.03c.14-.13.15-.13.18-.15.05-.06.08-.1.08-.11-.1.09-.27.26-.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.46,4.93l.02-.02s.03-.03-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.62,4.93s.04-.04.05-.05l-.05.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.71,4.72c.05-.06-.02,0-.12.1.03-.03.06-.04.06-.04.04-.04.07-.07.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.28,5.2c.06-.06.11-.12.16-.17-.09.1-.24.25-.16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.4,4.99s-.01.01-.01.01c-.06.07-.03.03.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.4,4.99s.12-.11.19-.18c-.03.02-.06.05-.11.09-.02.02-.05.05-.08.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.6,3.03c-.28.27-.56.52-.26.21-.22.2-1.15,1.11-1.66,1.63.12-.12.24-.23.42-.39.15-.15.34-.37.61-.62.16-.13-.09.11-.23.26.36-.34.52-.49,1.05-.99l-.19.17c.08-.08.21-.2.28-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.69,4.83l-.04.03c-.05.05-.16.16-.37.39.14-.13.25-.23.35-.32l.02-.06.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.63,4.84c.31-.3.45-.42.78-.75-.03,0-.27.24-.41.37.09-.06-.18.16-.34.35-.06.05-.07.06-.09.07-.03.04-.08.09-.13.15l.02-.02h0s0,0,0,0c.04-.04.06-.06.04-.04,0,0,0,0,0,0,.04-.04.08-.08.12-.11-.06.07-.08.08-.12.11l-.05.04h0s.19-.14.19-.14c.04-.05.03-.04-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.08,3.23s-.05.05-.07.07c.04-.04.06-.06.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.9,3.43s-.17.16-.14.12c.09-.09.15-.15.25-.25-.08.08-.23.21-.37.36l.04-.04c-.1.11-.47.5-.51.54.27-.28.47-.47.73-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.35,4.06l.17-.13.26-.27-.16.16c.05-.07-.14.12-.26.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "18.47 5.08 18.14 5.4 18.61 4.96 18.47 5.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "18.53 5.06 18.24 5.34 18.42 5.18 18.53 5.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.29,3.01l.09-.07s-.06.04-.09.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.28,2.96l-.15.12c.08-.07.14-.12.15-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.01,5.51c-.27.26-.68.65-.36.35l.32-.29c-.06.05-.03.01.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.25,4.14l.1-.09c-.11.1-.22.19-.32.27.07-.06.14-.12.22-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.61,2.96l-.2.19c.07-.07.14-.13.2-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.83,2.95l.35-.27s-.18.14-.35.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.83,5.15c-.12.12-.17.18-.18.19.17-.18.44-.44.18-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.75,5.96c.06-.05.13-.1.21-.17-.06.05-.12.1-.21.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.67,5.36s.05-.05.07-.07c-.06.05-.1.08-.09.06-.13.13-.21.22.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.21,4.01s-.02.02-.04.03c.05-.03.05-.04.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.87,6.86s-.03.01-.03.01c-.02.02-.02.02.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.46,5.27s-.04.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.68,4.06s.08-.08.15-.15c-.08.07-.12.12-.15.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.68,3.55h0c.06-.06.05-.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.6,5.13s-.07.07-.09.09c.02-.02.05-.06.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.45,5.27s.02-.02.03-.03c-.05.05-.08.08-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.49,5.26s0-.01.03-.04c-.02.02-.04.04-.05.05h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.95,4.28s-.02.01-.03.03c.15-.11.12-.09.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.46,2.6s-.01,0-.02.01h-.01s.03-.01.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.71,2.41c-.41.35-.36.3-.28.22l-.93.84,1.21-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M23.47,3.03l.29-.26c.51-.39.35-.24.76-.6-1.05.87-.15.03-1.2.9l.21-.19s.05-.04.05-.03c.48-.44-.76.62-.63.47.07-.07.22-.21.35-.31l-.27.2s.2-.17.18-.15l-.1.04.03-.03c-.17.13-.43.34-.54.42.14-.13.11-.09.24-.2l-.26.2c.26-.23.53-.44.5-.4,1.02-.89-.27.21.31-.33l.14-.1c.58-.51.36-.34.71-.66-.19.17-.9.81-1.17,1.02.07-.07.11-.11-.11.06.37-.31.27-.24.24-.24l.49-.41c-.15.11-.4.32-.62.5.04-.05.41-.38.73-.65.06-.09-.59.53-.7.58.17-.18-.04-.02-.34.21.16-.16.3-.25.43-.38l-.4.32s.13-.11.19-.16c-.16.12-.48.42-.63.52-.54.46.76-.7.14-.19.14-.12.3-.26.48-.42-.42.32-.31.23-.85.68l.3-.29c-.35.33-.79.69-1.16.98-.17.16-.32.29-.39.36l-.27.21c.08-.07.25-.21.45-.39-.04.03-.08.07-.12.1.17-.16.45-.4.73-.63-.09.09-.19.18-.29.27.3-.25.62-.53.91-.78-.06.05-.11.08-.14.11.08-.07.15-.13.2-.17.05-.04-.06.05-.18.15l.53-.47-.21.19.31-.32c-.56.45-1.36,1.13-1.61,1.3.39-.35.64-.56,1.11-.97-.48.44.23-.16.14-.06.04-.05.27-.25.35-.31l-.47.37c.38-.33.28-.26.43-.4-.75.67-.52.42-.76.61.25-.22.51-.45.46-.38.55-.52-.9.76-.43.32,0,0-.03.03.1-.08-.23.19-.07.01.15-.18h0c.07-.1-.06-.07-.69.49.08-.07.77-.68.9-.79l-2.16,1.87c.55-.48,1.83-1.66,2.15-1.92.07-.07.16-.16-.04,0-.08.07-.78.71-.83.76.59-.56.31-.3.81-.78-.11.11-.97.87-.95.84.13-.11.84-.76.93-.84l-.85.73c.15-.14.7-.64.94-.86-.16.15,0-.03-.09.04l-.18.18c.1-.14-1.19,1.04-1.17.98.17-.15,1.06-.96,1.16-1.06-.43.38-2.08,1.83-2.41,2.13l.24-.23-.29.24c.65-.57,2.02-1.78,2.55-2.25.18-.19.28-.26.25-.26.22-.21.35-.31.37-.32l.12-.17c-.49.46-.52.43-.93.81l.54-.44c-.49.45-1.42,1.27-1.36,1.17.2-.18.88-.81,1.05-.96-.17.15-.34.28-.23.17l.27-.23c.17-.18-.67.58-.22.13.03-.03.62-.6.33-.33-.56.52-2.3,2.14-2.72,2.53.04-.04.52-.52.79-.79.44-.41,1.05-.97,1.43-1.32-.14.12-.31.27-.36.32.11-.11.42-.39.35-.34-.5.46.02-.06-.43.39-.15.12.09-.11.06-.1-.32.3-1.11,1.01-1.26,1.13.13-.12.29-.27.36-.35.02-.06.24-.29.22-.31.12-.12.25-.26.47-.46-.09.08-.26.24-.28.24.42-.42.08-.05.59-.54-.29.27-.41.36-.6.52-.44.42-.07.1.12-.06-.61.58-1.27,1.17-1.57,1.42-.17.13.39-.38.3-.3.08-.13-1.09.99-.67.55.39-.37.77-.74,1.05-1.01.16-.13-.23.26-.2.25l.17-.19c.13-.12.24-.2.13-.09.34-.34.02-.12.32-.45-.13.12-.28.24-.43.4l.06-.04c-.31.31-.45.4-.58.55-.23.2-.58.52-.42.34l.44-.43c-.13.12-.25.26-.12.14-.2.18.58-.6,0-.05l-.3.3c-.23.2-.71.65-.58.5-.42.43.05-.05-.45.46.63-.62,0,.05.66-.6-.58.58-.24.26-.73.75.15-.14.27-.27.21-.19.04-.04.1-.09.13-.12h-.01s.02,0,.02,0c.02-.02.03-.02,0,0,.06-.06.14-.14.22-.22.34-.32.34-.29.52-.45-.06.07-.17.16-.32.31l.27-.24c-.32.31-.52.53-.73.7v.03c-.18.18-.24.26-.1.14-.07.07.37-.33.11-.09l.22-.17-.08.08c-.02.06.58-.47,0,.11.09-.07.2-.16.11-.06l-.28.27c.11-.08-.26.29.04.02-.76.72-.13.19-.25.33l.37-.34s.1-.06.26-.19l.33-.31c.28-.24-.21.24-.16.23-.13.11-.1.08-.02,0-.73.71.58-.46.06.06.12-.11.09-.06,0,.01,0,0,0,0-.02.01,0,0,0,0,0,0-.06.05-.12.12-.17.17.08-.08.14-.14.17-.17.01,0,.06-.04.14-.11l-.35.33s0,0,.01,0c-.13.12.17-.15.44-.4.06-.05.13-.11.22-.19-.57.53.21-.16-.4.4.3-.27.25-.18.88-.74-.08.07-.12.11-.13.11-.07.07-.13.14.05-.01l-.45.41.62-.54c-.27.26-.43.41-.79.71.56-.46.21-.17.77-.63l-.3.26s.42-.35.18-.13c-.55.51-.02.14-.51.63.87-.78-.38.36.3-.23-.21.18-.32.29-.5.44.22-.16-.31.31.28-.18-.21.18-.31.27-.43.37.05-.04.18-.15.06-.04-.13.11-.18.15-.27.23.05-.01.69-.57,1.29-1.09-.28.26-.23.23.17-.11-.19.17-.39.36-.48.41-.02.03-.26.29.23-.13-.12.11-.03.04.03,0-.02.04-.06.08,0,.05l.08-.07c.59-.5.14-.1.22-.15l-.06.05c-.4.39.21-.16-.25.28l.36-.31c.79-.67-.44.42-.13.18l.2-.18c.28-.22-1.05.93-1.14,1.02-.07.06-.11.09-.16.13-.45.41.48-.41.6-.48-.26.22-.66.55-.7.61-.21.18.86-.68.38-.25.2-.17.39-.34.55-.46.08-.05-.73.67-.09.15-.05.05-.11.09-.15.13.17-.13.29-.2.64-.48-1.26,1.07.66-.46-.51.52l.09-.03-.12.1c-.06.08.22-.15.51-.37-.08.07-.19.16-.25.21-.22.22-.17.18.44-.28l-.38.32c.23-.18-.57.53-.1.19-.04.03-.12.09-.17.14.47-.34-1.02.93.4-.2l.36-.26c.09-.11.61-.49.84-.69.09-.06-.4.37-.49.41l.07-.06c-.74.59-.24.24-.74.64.07.02-.3.39-.3.46l.57-.46-.02.04c-.13.11-.45.36-.43.33-.32.26.29-.2.41-.29-.22.2-.68.52-.69.54l.05-.03.07-.05c.24-.18.49-.37.47-.34-.11.09-.35.29-.37.3-.04.03-.06.05-.01.02l-.03.06.45-.36c.23-.17,0,.04.5-.38-.78.63-.23.3-.47.5.34-.25.35-.23.32-.18.09-.08.6-.48.55-.41-1.07.81-.44.38-1.2.98.5-.4.15-.06.86-.63-.08.08-.4.31-.64.5.43-.29-.23.26-.06.18.14-.11.36-.27.57-.42l-.69.55c.07-.05.82-.6.34-.23.12-.09.29-.23.34-.26-.64.57.66-.29-.59.73.27-.21.3-.22.31-.23.07-.05.35-.26.54-.4l-.51.42c.54-.39.06,0,.57-.37l-.1.06c.61-.43,1.33-1,2.1-1.56-.69.49.99-.78-.01-.09.16-.12.25-.18.43-.31-.34.24-.41.28-.27.16l.08-.06c-.11.02.21-.23.39-.44l-.38.29s.16-.14.25-.21c-.58.42-.01.05-.66.51.76-.59-.04-.07.83-.74,0-.02-.44.33-.44.32l.23-.18-.31.23s.34-.27.54-.43c-.02.02.06-.04.08-.05.27-.22-.12.04-.03-.04l-.14.12c-.25.13.02-.15-.48.17l-.18.14c-.35.22.18-.17,0-.09l.04-.03c-.18.13-.28.19-.26.17.21-.15.39-.33.63-.49-.37.24-.29.2-.96.69l.29-.23c-.27.2-.41.31-.5.35.25-.19.45-.34.78-.6.62-.53-.68.46.24-.29-.82.62-.43.38-.61.5-.26.21-.61.46-.54.39,0,0,.07-.06.16-.14.1-.08.22-.18.35-.28.25-.2.49-.41.48-.42,0,0,.06-.04.06-.04.2-.17-.29.2.03-.07-.49.38.02-.04-.61.45l.16-.09c-.17.11-.91.68-.57.38.13-.09.3-.22.39-.29.18-.15-.13.08.05-.07.62-.49.16-.08.64-.44.26-.21-.47.33.21-.2-.86.67.09-.11-.58.39l.37-.29c-.06.04-.24.18-.24.16l.49-.37c-.42.31.34-.31.1-.15.03.02-.44.36-.7.59-.52.36.96-.79.75-.69.06-.04-.21.2-.39.33.07-.07.2-.19.4-.35-.1.03-.38.31-.61.48.44-.37-.19.13-.35.24l.38-.3c.22-.22-.79.62-.52.36l.53-.41-.15.09.43-.34c-.33.24-.25.17-.14.06-.26.22-.68.55-.7.54.22-.19.36-.28.29-.26.24-.19.54-.42.2-.13.12-.1.24-.19.36-.28.25-.22.04-.07.03-.08-.01.01-.03.03-.08.08l-.54.39c.14-.12.25-.21.37-.29-.04.03-.22.16-.26.18.31-.25.62-.5.77-.61l-.36.25c.13-.11.36-.3.47-.4.17-.16-.62.45-.4.23-.06.05-.12.09-.16.12.05-.07.41-.4-.02-.08l.53-.46c-.14.08-.67.58-.9.72-.19.12.46-.39.6-.52-.28.22-.85.66-.42.28.11-.08.03,0,.08-.04ZM23.06,3.03c.08-.06.33-.26.11-.07-.43.35-.23.18-.11.07ZM21.93,3.5c.12-.1.07-.05-.07.08-.03.02-.02,0,.07-.08ZM18.79,5.04l.02-.02c-.13.14-.08.08-.02.02ZM18.93,4.88l-.15.14c.09-.08.1-.09.08-.06.09-.09.15-.15.07-.08ZM20.44,6.34l.1-.08c.11-.08.01,0-.1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.45,3.1c-.06.05-.13.11-.2.17.06-.05.13-.12.2-.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "23.77 3 23.76 3 23.83 2.95 23.77 3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.13,2.32s-.11.11-.18.18c.09-.08.16-.15.18-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.27,5.38l.1-.08s.05-.06.11-.12c-.08.08-.2.19-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.33,3.22s0,0-.05.04l-.16.16s.15-.13.21-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.41,4.26c.29-.28.19-.19.13-.15h0c-.41.39-.27.27-.13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M19.53,4.12s-.03.02-.01,0c-.16.16-.03.04.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M18.72,5.05c.07-.08-.38.36-.26.24-.38.35.47-.41.26-.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "20.37 3.32 20.01 3.67 20.3 3.4 20.37 3.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.16,3.63l.09-.11c-.06.06-.1.09-.13.12,0,.02-.07.09.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.12,3.64s0,0-.07.05c0,0,.02,0,.07-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "20.49 3.23 20.42 3.31 20.4 3.34 20.49 3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M20.2,3.81l.12-.09c.13-.12.2-.19.15-.15-.09.08-.14.12-.26.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.16,2.83c-.07.07-.15.15-.27.27l.45-.43-.18.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.3,2.77c.13-.12.38-.32.33-.31-.13.12-.24.2-.33.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "20.9 3.5 20.89 3.5 20.15 4.19 20.9 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.85,2.02c.17-.18-.47.42-.26.2-.17.17-.18.17-.33.32.2-.16.09-.06.59-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M22.27,2.54s-.07.06-.12.1c.05-.04.09-.07.12-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "20.45 7.21 20.29 7.35 20.56 7.14 20.45 7.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M21.08,6.78l-.52.38.48-.34s-.07.04.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.03,2.16l-.12.1c-.13.11-.13.12-.15.14l.27-.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "23.79 2.62 23.8 2.61 23.35 2.99 23.79 2.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M24.47,2.27s-.09.06-.08.04c.09-.06-.49.43.08-.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.43,1.22s-.35.15-.42.18c.09-.02.52-.23.42-.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "32.35 .96 32.19 1.02 32.58 .87 32.35 .96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.4,1.08c.65-.3-.12,0,.1-.12l.15-.07-.53.23c.09-.01.46-.13.28-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.02,1.78c.25-.12.22-.08.07-.05-.03.01-.04.02-.06.03,0,0,0,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.03,1.76s-.21.1,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.2,1.75l-.23.08c-.15.07-.18.1-.29.14.13-.04.28-.11.52-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.68,1.56l-.1.03c-.06.03-.08.04.1-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.37,1.66l.21-.07c.1-.05.32-.15-.08.02.19-.08,0,0-.13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.46,1.61c.14-.07.22-.13.45-.21-.1,0-.56.22-.45.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M33.07.78l.18-.1-.22.09c.11-.04-.17.1.04.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.91,2.01c.14-.06.37-.17.54-.25l-.16.06c-.09.05-.17.1-.38.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.45,1.76l.25-.09s-.09.02-.25.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "32.4 1.23 31.89 1.43 32.41 1.24 32.4 1.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "30.92 2.09 30.59 2.22 31.09 2.03 30.92 2.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M30.99,2.11c-.27.12-.45.2-.61.28.05,0,.29-.1.5-.18-.12.04-.09.02.12-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.18,2.09c-.07.02-.18.07-.31.12.06-.02.15-.06.31-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.64,1.73c-.08.04-.3.14-.39.19l.39-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.65,1.74h-.01s-.01.03-.01.03c0,0,.01-.01.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.64,1.73h0s.05-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.07,1.44c.22-.09.47-.17.79-.34-.27.11-.45.21-.79.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.12,1.5l.08-.06c-.1.05-.25.11-.36.16l.28-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "32.25 1.46 32.12 1.5 32.09 1.53 32.25 1.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.53,1.89c.17-.07.19-.06.22-.07.07-.05.11-.08.1-.09-.12.05-.35.15-.33.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.62,1.8h.02s.04-.03-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.8,1.93s.05-.02.07-.03l-.07.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.93,1.71c.07-.04-.03,0-.15.04.04-.01.07-.02.08,0,.06-.02.09-.04.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.38,2.04c.08-.04.15-.08.21-.11-.12.06-.31.15-.21.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.54,1.84s-.02,0-.02,0c-.08.04-.04.02.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.54,1.84c.06-.02.16-.06.24-.1-.03.01-.08.02-.14.04-.03.01-.07.03-.11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.32.84c-.36.16-.71.29-.33.09-.28.1-1.46.65-2.12.96.16-.07.3-.13.53-.21.19-.09.44-.25.78-.38.2-.06-.12.08-.3.18.45-.21.67-.26,1.33-.56l-.24.08c.1-.05.27-.11.36-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.89,1.84h-.05c-.06.05-.2.12-.48.26.18-.07.32-.12.44-.18l.03-.06.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.83,1.82c.4-.17.57-.23.99-.43-.04-.01-.34.13-.51.19.11,0-.22.09-.43.21-.07.02-.09.02-.11.03-.05.03-.1.06-.17.1h.02s0-.01,0-.01h0s.08-.04.05-.03c0,0,0,0,0,0,.06-.02.1-.04.15-.06-.08.05-.1.05-.15.06l-.06.03h0s.23-.06.23-.06c.05-.03.04-.04-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M33.71.74s-.06.03-.09.04c.05-.02.08-.03.09-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M33.48.87c-.06.02-.21.09-.18.06.11-.06.19-.08.32-.14-.11.04-.29.11-.47.21l.05-.02c-.13.08-.61.32-.67.34.35-.17.6-.28.94-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.76,1.3l.21-.05.33-.17-.2.09c.07-.05-.18.06-.34.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "31.61 2.02 31.19 2.2 31.78 1.96 31.61 2.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "31.67 2.04 31.31 2.2 31.53 2.12 31.67 2.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.2,2.44l.11-.03s-.07.02-.11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.19,2.36l-.18.08c.1-.04.17-.07.18-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.16,3.04c-.33.16-.85.41-.44.23l.4-.18c-.08.02-.03,0,.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.83,2.71s.08-.04.12-.06c-.14.06-.27.11-.38.16.08-.03.17-.06.27-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.48,2l-.25.13c.09-.05.17-.09.25-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.79,2.64l.41-.16s-.21.08-.41.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32,2.4c-.15.08-.21.12-.23.14.22-.12.56-.28.23-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.96,4.23c.07-.03.16-.06.25-.1-.07.02-.15.05-.25.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.79,2.57s.06-.03.09-.05c-.07.02-.13.04-.11.01-.17.09-.26.14.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.05,4.16s-.03.01-.05.02c.05-.02.06-.02.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.18,6.24s-.03,0-.04,0c-.03.01-.02.02.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.57,2.29s-.04.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M33.12,1.54s.1-.04.19-.08c-.1.04-.16.07-.19.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.3,1.57h0c.08-.04.06-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.75,2.19s-.09.05-.11.06c.03-.02.07-.04.11-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.56,2.28s.03-.02.04-.02c-.07.03-.11.05-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.6,2.29s0-.02.03-.03c-.03.01-.05.02-.06.03,0,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.66,3.88s-.02,0-.04.02c.17-.06.14-.05.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.38,1.46s-.01,0-.02,0h-.01s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.69,1.37c-.5.2-.44.17-.34.11l-1.14.51,1.48-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M37.38,2.56l.35-.18c.6-.23.41-.12.9-.36-1.25.53-.17-.03-1.41.5l.26-.13s.06-.02.05-.01c.58-.29-.91.37-.75.25.09-.05.27-.14.42-.2l-.32.1s.24-.11.22-.09h-.12s.04-.02.04-.02c-.2.08-.51.19-.64.24.17-.09.13-.05.29-.12l-.31.11c.32-.15.64-.26.6-.23,1.24-.56-.32.11.38-.25l.17-.04c.7-.32.44-.23.87-.44-.23.11-1.09.53-1.41.64.09-.05.13-.08-.13.02.44-.19.33-.16.3-.17l.59-.25c-.18.05-.48.18-.75.29.05-.05.5-.25.88-.42.08-.07-.72.34-.85.35.21-.13-.04-.04-.4.08.19-.11.36-.15.53-.23l-.48.19s.15-.07.23-.1c-.19.06-.59.25-.76.3-.65.27.92-.46.18-.17.17-.07.36-.16.59-.25-.5.17-.36.12-1.03.37l.37-.19c-.43.21-.96.41-1.4.58-.21.1-.39.19-.48.23l-.33.1c.09-.05.3-.13.55-.23-.05.02-.1.04-.14.05.21-.11.55-.25.88-.38-.11.05-.24.11-.36.17.36-.15.76-.32,1.1-.46-.07.03-.13.05-.16.06.1-.04.18-.08.24-.1.06-.03-.07.02-.22.08l.65-.29-.26.11.39-.23c-.67.25-1.65.64-1.95.71.49-.2.78-.34,1.35-.58-.59.28.27-.07.16.01.06-.04.33-.16.43-.19l-.57.19c.47-.2.34-.16.53-.26-.91.41-.63.23-.92.33.31-.14.62-.27.56-.21.68-.33-1.09.44-.52.15.01,0-.04.03.12-.04-.28.11-.08-.02.19-.13h0c.09-.08-.05-.12-.83.21.1-.04.94-.4,1.1-.47l-2.65,1.08c.67-.29,2.26-1.01,2.65-1.14.09-.05.2-.11-.05-.03-.09.05-.96.44-1.03.46.73-.36.39-.19,1.01-.5-.14.07-1.19.52-1.17.49.16-.07,1.04-.45,1.15-.5l-1.05.41c.19-.07.87-.38,1.16-.52-.2.09,0-.04-.1,0l-.23.12c.14-.11-1.47.59-1.43.53.22-.09,1.31-.56,1.43-.64-.53.22-2.56,1.07-2.98,1.21l.3-.14-.36.12c.8-.32,2.5-1.01,3.15-1.27.23-.12.35-.16.32-.17.28-.13.43-.18.45-.18l.16-.14c-.61.27-.64.23-1.15.46l.66-.22c-.61.27-1.76.73-1.67.65.24-.12,1.1-.47,1.3-.57-.21.09-.42.14-.27.07l.34-.13c.22-.12-.83.32-.26.04.04-.03.78-.38.42-.22-.7.32-2.87,1.29-3.4,1.51.05-.02.65-.33.99-.51.55-.24,1.31-.57,1.79-.78-.17.07-.38.16-.45.18.14-.07.52-.23.44-.21-.63.27.03-.07-.53.22-.19.06.12-.08.08-.09-.4.19-1.38.58-1.57.64.16-.07.36-.17.46-.21.04-.07.31-.21.3-.26.15-.07.32-.17.6-.28-.11.04-.33.13-.35.13.53-.26.1-.01.74-.31-.36.16-.51.19-.75.27-.56.25-.09.09.14,0-.77.34-1.59.67-1.97.79-.21.05.49-.23.38-.19.11-.12-1.37.55-.83.25.48-.24.98-.44,1.33-.6.2-.06-.29.18-.27.19l.22-.12c.17-.06.3-.1.16-.03.43-.21.04-.14.43-.37-.17.06-.34.13-.54.22l.08-.02c-.39.19-.56.22-.74.32-.29.1-.73.28-.52.15l.56-.26c-.16.07-.33.17-.15.1-.25.1.74-.38,0-.07l-.38.19c-.29.11-.89.35-.73.24-.54.27.06-.03-.57.28.8-.37,0,.08.83-.32-.74.35-.3.17-.94.48.18-.08.35-.17.27-.1.05-.02.12-.05.16-.07h-.01s.02,0,.02,0c.03-.01.03-.01,0,0,.08-.04.18-.09.28-.14.43-.18.43-.14.65-.23-.08.05-.21.09-.41.18l.34-.13c-.41.18-.67.34-.92.41v.03c-.23.12-.31.18-.13.12-.08.05.47-.17.14-.04l.27-.07-.1.05c-.03.06.72-.22,0,.16.11-.03.24-.07.14,0l-.35.16c.13-.04-.33.21.04.05-.95.44-.17.18-.33.28l.46-.2s.12,0,.32-.06l.41-.18c.35-.13-.27.19-.21.2-.16.07-.12.04-.03,0-.91.45.71-.21.05.13.15-.06.11-.03,0,.03,0,0,0,0-.02,0,0,0,0,0,0,0-.07.04-.15.08-.21.11.1-.05.18-.09.22-.11.01,0,.07,0,.18-.04l-.44.2s0,0,.01,0c-.16.08.21-.08.54-.23.07-.03.16-.06.27-.1-.71.32.25-.08-.5.27.37-.15.3-.07,1.08-.4-.1.04-.15.07-.16.07-.08.05-.17.1.06.02l-.56.25.77-.3c-.33.17-.53.26-.97.43.68-.25.26-.08.94-.33l-.36.16s.51-.19.22-.05c-.68.33-.04.17-.65.52,1.06-.48-.47.24.36-.12-.25.11-.39.19-.61.27.26-.07-.38.23.33-.05-.25.11-.37.16-.52.22.06-.02.22-.08.08-.02-.15.07-.21.09-.33.13.06.02.84-.32,1.57-.63-.34.17-.29.16.2-.04-.24.11-.48.23-.58.24-.03.03-.32.23.27-.02-.15.07-.04.04.03.01-.02.04-.07.07,0,.07l.09-.05c.71-.3.17-.05.26-.06l-.07.03c-.49.27.25-.08-.31.22l.44-.19c.95-.4-.54.29-.16.16l.25-.12c.33-.12-1.27.6-1.38.67-.08.04-.13.05-.2.07-.54.28.58-.24.73-.27-.31.14-.79.33-.84.38-.25.12,1.04-.38.45-.09.24-.11.47-.22.66-.28.1-.01-.88.45-.12.14-.07.03-.13.06-.19.08.2-.07.35-.08.76-.25-1.52.67.79-.21-.62.39l.1.02-.14.06c-.08.07.26-.06.61-.19-.09.05-.23.1-.3.13-.26.17-.2.15.52-.11l-.45.2c.27-.1-.68.38-.13.2-.05.02-.14.06-.21.08.56-.17-1.21.67.46-.02l.42-.14c.11-.1.72-.3.99-.44.11-.02-.48.26-.58.27l.08-.04c-.87.36-.28.19-.87.44.08.07-.36.36-.36.46l.67-.29-.03.05c-.15.07-.52.23-.5.2-.38.17.33-.1.48-.16-.26.16-.79.32-.8.33h.06s.08-.04.08-.04c.28-.1.57-.22.55-.19-.13.07-.41.18-.44.2-.05.02-.07.03-.02.02l-.04.06.53-.24c.27-.09-.01.05.58-.22-.92.42-.27.28-.56.42.4-.14.4-.11.37-.07.11-.05.7-.31.64-.25-1.24.51-.52.27-1.4.66.58-.26.18,0,1-.37-.09.06-.46.19-.75.33.5-.15-.27.24-.08.23.16-.07.41-.18.65-.27l-.8.37c.08-.02.94-.38.39-.12.14-.06.34-.15.39-.16-.74.45.75-.03-.68.71.31-.15.34-.15.36-.14.07-.04.4-.17.62-.26l-.59.3c.62-.24.06.04.65-.2l-.11.03c.7-.26,1.52-.66,2.41-1.03-.79.3,1.13-.54,0-.12.18-.08.29-.11.49-.2-.38.15-.47.17-.31.08l.09-.04c-.12-.02.24-.21.46-.38l-.43.19c.05-.04.19-.1.29-.15-.67.26-.02.06-.76.35.88-.39-.03-.11.97-.55,0-.03-.5.22-.51.19l.27-.12-.35.14c.05-.04.39-.19.62-.29-.03.02.07-.02.09-.02.31-.15-.13,0-.03-.06l-.16.09c-.28.04.04-.18-.54-.01l-.2.09c-.4.11.21-.13.01-.11l.05-.02c-.21.08-.32.11-.3.08.25-.09.46-.22.73-.32-.43.12-.33.11-1.11.4l.34-.15c-.31.12-.48.19-.58.2.3-.1.51-.24.91-.38.72-.37-.79.24.29-.25-.96.37-.51.27-.71.34-.3.14-.72.28-.63.22.01-.03,1.2-.54,1.16-.57,0,0,.07-.02.07-.02.23-.12-.34.11.04-.08-.58.23.02-.04-.71.27l.19-.03c-.2.06-1.06.4-.66.19.15-.06.35-.13.46-.17.21-.1-.15.04.06-.06.73-.31.18-.02.75-.23.3-.14-.55.18.25-.14-1.01.41.11-.1-.67.2l.44-.18c-.07.02-.28.1-.27.09l.57-.22c-.49.18.4-.23.13-.14.03.04-.52.23-.83.39-.61.19,1.13-.52.89-.5.07-.02-.25.15-.46.22.08-.05.24-.14.47-.24-.11,0-.45.2-.72.29.53-.24-.23.07-.4.12l.44-.19c.26-.17-.93.38-.61.19l.62-.24-.17.04.51-.21c-.39.13-.29.08-.16,0-.31.14-.81.34-.83.32.26-.13.43-.17.35-.18.28-.11.63-.25.23-.06.15-.06.28-.11.43-.17.3-.15.05-.07.04-.08-.01.01-.04.03-.1.06l-.63.22c.16-.08.3-.13.43-.18-.05.01-.26.09-.3.09.36-.15.73-.31.91-.36l-.42.13c.16-.07.42-.21.56-.26.2-.11-.73.24-.46.09-.07.03-.14.05-.19.07.07-.06.5-.28,0-.1l.64-.3c-.16.04-.8.38-1.07.43-.22.06.55-.25.72-.34-.33.12-1.01.38-.49.12.13-.04.03,0,.09,0ZM36.95,2.34c.1-.03.39-.14.13-.03-.51.21-.27.1-.13.03ZM35.66,2.29c.15-.06.08-.02-.08.06-.04,0-.03,0,.08-.06ZM31.97,2.22s.01,0,.02,0c-.17.09-.1.06-.02,0ZM32.15,2.11l-.18.08c.11-.05.12-.04.09-.02.11-.05.19-.09.09-.06ZM33.71,5.23l.11-.05c.13-.04.02,0-.11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.29,2.08c-.07.03-.16.07-.24.11.08-.03.16-.07.24-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "37.71 2.67 37.71 2.67 37.79 2.64 37.71 2.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.09.92c-.06.03-.14.07-.22.11.11-.05.2-.09.22-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.34,2.28l.12-.03s.07-.05.14-.08c-.1.05-.25.12-.26.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M33.99.9c-.06.02,0,0-.06.02l-.2.09s.19-.06.27-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.79,1.61c.37-.17.24-.12.16-.11h0c-.52.23-.34.17-.17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M32.94,1.51s-.03,0-.01,0c-.21.09-.04.02.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M31.89,2.18c.09-.05-.48.21-.33.14-.47.2.59-.21.33-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "34.01 1.06 33.55 1.27 33.92 1.11 34.01 1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M33.72,1.31l.12-.08c-.08.03-.12.05-.16.06,0,.02-.09.08.04.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M33.68,1.3s0-.01-.08.02c0,0,.03,0,.08-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "34.16 1.03 34.07 1.07 34.04 1.1 34.16 1.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M33.73,1.58l.14-.03c.16-.07.25-.12.19-.1-.11.04-.18.06-.33.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.95.96c-.09.05-.19.09-.34.17l.57-.25-.22.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M35.12.97c.16-.07.47-.17.42-.18-.16.07-.3.1-.42.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "34.55 1.64 34.54 1.64 33.61 2.05 34.55 1.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.92.98c.21-.13-.58.25-.31.1-.22.09-.22.12-.41.2.24-.09.11-.02.72-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M36.2,1.27s-.08.03-.15.05c.06-.02.11-.04.15-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "33.71 6.52 33.52 6.62 33.83 6.47 33.71 6.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M34.42,6.26l-.6.25.55-.21s-.08.02.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.13,1.77l-.14.06c-.15.07-.16.08-.18.1l.33-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "37.79 2.21 37.8 2.2 37.27 2.44 37.79 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M38.57,2.13s-.11.02-.09,0c.11-.02-.59.29.09,0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M649.02,14.36c.07.02-.06-.38-.07-.46-.08.12.11.56.07.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "648.32 15.57 648.28 15.4 648.27 15.85 648.32 15.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.42,15.84c.31.65.28-.21.52-.02l.08.15-.1-.57c-.17.15-.3.59-.5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.44,14.56c.12.25-.02.26.14.04-.02-.03-.03-.04-.04-.06-.02.01-.05.02-.1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.53,14.54c.09-.06-.14-.2,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.15,14.85l.04-.28c-.08-.14-.21-.14-.21-.26-.08.18,0,.32.17.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.21,15.39l.03-.12c-.04-.06-.06-.08-.03.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.3,15l-.06.26c.06.1.14.32.03-.1.06.2.02,0,.02-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.42,15.08c.12.12.24.18.21.46.2-.18,0-.64-.21-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.62,16.55l.16.17v-.25c0,.12-.24-.13-.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M645.24,14.8c.05.14.19.36.27.54l.03-.2c-.08-.08-.21-.13-.3-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M645.51,15.34l-.04.29c.13-.02.11-.14.04-.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "646.47 16.14 646.5 15.54 646.43 16.16 646.47 16.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "644.7 14.99 644.65 14.63 644.71 15.18 644.7 14.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.38,15.19c-.06-.29-.27-.42-.28-.61-.07.09-.06.35-.04.59.03-.15.12-.15.32.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.08,15.53c0-.08,0-.21-.01-.35-.01.08-.01.19.01.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M645.21,15.66c-.04-.08-.16-.3-.27-.36l.21.38h.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M645.16,15.68h0c-.06,0-.11,0-.12.01.02,0,.06,0,.13-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M645.22,15.65h-.01s.03.05.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M645.98,15.91c0,.25-.06.55.23.83-.05-.29-.22-.45-.23-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M645.49,16.12l.18.04c-.04-.1-.13-.25-.14-.37l-.04.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "645.47 16.28 645.49 16.12 645.42 16.11 645.47 16.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.48,15.79c.01.2-.05.24-.11.3.11.04.21.05.29.01-.04-.13-.1-.37-.18-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.82,15.77v.03s.03.04,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.63,16.41s.03.04.04.07l-.03-.07h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.7,16.17c.09.05.09-.06.07-.2-.03.06-.06.11-.11.13.02.06.03.1.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.95,15.8c.07.07.13.12.2.17-.08-.11-.23-.28-.2-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.75,15.7v-.02c-.05-.08-.03-.04,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.75,15.7c0,.07,0,.18.02.28.02-.05.04-.1.05-.18-.02-.03-.04-.06-.07-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.55,19.01c-.16-.36-.16-.76.15-.43,0-.33-.61-1.48-1.02-2.09.07.16.13.3.09.58.14.18.51.33.54.71-.09.26-.2-.06-.38-.22.28.42.07.75.42,1.39l.04-.3c.05.1.07.29.15.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.95,16.4l.04-.07c-.09-.04-.2-.16-.42-.4-.02.22.02.36.07.48l.3-.07v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.24,16.22c.13.42.07.64.34,1.03.15-.1-.03-.38,0-.6-.22.22-.02-.25-.31-.39.02-.09.06-.13.1-.17-.07-.03-.14-.07-.22-.12l.02.02h0s0,0,0,0c.03.04.05.07.02.05,0,0,0,.01,0,.01.02.06.04.11.05.15-.11-.05-.06-.1-.05-.15l-.02-.06h0s-.18.33-.18.33c.08.03.15-.01.25-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.4,17.66s-.03-.06-.04-.09c0,.06,0,.09.04.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.2,17.46c0-.06-.05-.23.03-.21.1.1.08.19.13.32,0-.12.02-.34-.18-.49v.06c-.16-.1-.5-.54-.5-.6.18.35.31.59.52.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M645.26,16.92l-.14.29.26.29-.09-.2c.16.03.02-.22-.03-.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "643.52 16.23 643.36 15.8 643.49 16.44 643.52 16.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "643.25 16.41 643.09 16.04 643.11 16.3 643.25 16.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.75,29.28v.13s0-.09,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.2,29.05l-.09-.17c.03.1.07.18.09.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M636.5,20.09c-.28-.27-.67-.7-.43-.32l.25.36c.02-.1.09-.09.18-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.5,24.96l.09.1c-.06-.14-.11-.27-.16-.39.02.09.04.19.07.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.38,26.53l-.26-.17c.08.07.16.12.26.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M628.54,31.05l.14.43c.11-.06-.04-.23-.14-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M640.43,18c-.16-.11-.25-.14-.32-.13.21.17.46.46.32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M628.59,25.21c0,.09.03.17.08.26,0-.09-.02-.17-.08-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M639.88,17.99s.06.04.09.07c.02-.09.05-.18.14-.19-.16-.13-.29-.18-.23.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M619,34.6s-.02-.02-.04-.04c.02.06.03.06.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.59,31.82s.06-.07.1-.1c-.04-.01-.07.01-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.01,16.79c.05-.06-.01-.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.05,18.19s.03.11.07.2c-.04-.1-.06-.16-.07-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M640.6,20.67h0c.06.07.05.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.19,16.92s-.09-.06-.13-.08c.03.02.07.05.13.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.09,16.75s.05,0,.07.01c-.02-.07-.05-.11-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M641.94,16.85s.07-.02.12,0c-.02-.02-.04-.04-.04-.05-.01.01-.04.04-.07.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M623.61,31.74s-.02-.02-.03-.03c0,.19.02.15.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M637.4,24.81s0-.02,0-.02h-.02s.02.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M637.37,25.2c-.2-.51-.12-.48,0-.43l-.72-1.03.71,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.76,29.99l.34.26c.14.66-.1.54.31.94-.65-1.19.5-.44-.16-1.63l.24.19s0,.08-.03.08c.51.46-.35-.93-.02-.9.14.04.29.18.32.35v-.4c.08,0,.18.2.12.21l.22-.26.02.04c-.07-.21-.15-.54-.18-.69.17.13.04.14.14.28l-.02-.37c.24.27.29.63.16.65.83,1.08-.05-.37.67.13l-.06.23c.49.61.46.3.87.61-.17-.19-.95-.84-.96-1.23.1.06.19.06.14-.22.25.41.28.26.37.17l.32.55c.02-.23-.15-.5-.23-.79.16-.02.45.38.7.72.26-.04-.56-.59-.37-.85.3.1.29-.19.29-.65.24.11.18.35.32.48l-.16-.5s.11.13.14.2c-.01-.22-.33-.55-.27-.79-.33-.62.83.7.59-.09.14.13.18.35.33.55-.03-.59,0-.45-.17-1.17l.39.25c-.37-.33-.52-.91-.62-1.4-.17-.17-.31-.32-.38-.39l.04-.43c.08.07.17.27.28.52-.01-.05-.03-.11-.04-.16.2.15.36.49.49.83-.09-.09-.19-.19-.29-.29.15.36.33.76.53,1.07-.02-.07-.03-.14-.02-.19.04.1.08.18.12.23.04.05,0-.08-.06-.24l.42.58-.14-.25.52.2c-.17-.74-.55-1.75-.38-2.2.19.49.43.74.75,1.27-.43-.5-.11.39-.34.38.12,0,.26.27.29.37v-.69c.25.44.25.28.44.41-.59-.82-.13-.71-.17-1.04.18.28.34.59.14.62.56.54-.41-1.13.09-.69-.03.03-.08,0,0,.15-.07-.31.26-.23.36.05l-.03.03c.3-.05.74-.44.33-1.19.06.09.5.89.58,1.05l-1.06-2.71c.34.65,1.39,2.04,1.41,2.52.11.05.25.11.23-.18-.09-.06-.65-.84-.63-.93.57.6.33.31.87.79-.14-.1-.67-1.12-.56-1.14.07.16.59.96.62,1.09l-.35-1.1c.05.21.48.82.7,1.06-.14-.17.21-.1.21-.23l-.23-.17c.35,0-.55-1.51-.26-1.62.09.22.65,1.28.86,1.32-.23-.53-1.14-2.54-1.13-3.07l.21.26v-.43c.31.81.93,2.57,1.13,3.28.23.17.22.32.36.21.21.23.16.45.13.49l.44-.03c-.36-.57-.08-.73-.38-1.21l-.02.82c-.36-.57-.75-1.77-.45-1.81.2.2.56,1.06.67,1.25-.09-.22,0-.51.11-.38l.08.37c.26.14-.23-.9.26-.43.08,0,.6.66.41.31-.47-.61-1.67-2.66-1.89-3.2.05.03.67.46.92.76.39.47.57,1.33.9,1.73-.09-.16-.15-.39-.16-.46.14.1.26.51.34.36-.31-.61.29-.1-.22-.54.03-.24.2.05.33-.06-.26-.36-.6-1.38-.56-1.62.08.16.21.34.28.42.29-.09.58.11.83-.02.1.13.31.25.4.53-.02-.12-.1-.35-.03-.4.42.44-.12.17.32.74-.18-.35-.06-.59-.07-.86-.32-.52-.3.03-.29.31-.4-.74-.63-1.62-.55-2.11.11-.3.34.43.32.31.45-.08-.34-1.48.27-1.11.38.41.49.95.69,1.28-.08.27-.42-.17-.52-.1l.26.16c.03.19-.02.36-.16.26.33.37.71-.25,1.2,0-.03-.19-.02-.4-.16-.57l-.06.11c-.28-.34-.08-.63-.29-.75,0-.34-.06-.84.23-.71l.3.54c-.08-.16-.28-.27-.25-.08-.04-.28.64.61.38-.16l-.31-.32c0-.34-.11-1.02.14-.92-.33-.51,0,.08-.43-.51.48.75-.45.18.12.93-.48-.68-.36-.21-.83-.76.09.18.23.32.04.3.02.06.04.13.05.18h-.02s.02,0,.02,0c0,.03,0,.04,0,0,.07.06.15.15.21.24.13.45-.09.55-.06.8-.12-.05-.07-.22-.21-.4l.05.38c-.21-.4-.55-.56-.48-.89l-.19.07c-.22-.17-.41-.19-.41.02-.13-.04.02.55-.07.2l-.14.39-.05-.1c-.29.09-.2.95-.88.4-.04.15-.06.32-.27.29l-.22-.33c-.05.18-.54-.15-.39.23-.64-.85-.66.11-.95.06l.24.45c-.15.05-.21.25-.28.53l.23.38c.04.4-.53-.06-.74.11-.07-.16.01-.15.1-.09-.79-.72-.2.97-.82.48.02.18-.05.16-.15.08,0,0,0-.01,0-.03,0,0-.02,0-.03.01-.07-.05-.14-.11-.21-.15.08.08.15.14.19.16-.04.04-.08.13-.1.26l-.28-.4s0,.01,0,.02c-.16-.11.06.23.28.52,0,.09.02.19.06.3-.46-.63-.05.33-.55-.33.16.37-.19.47.21,1.22-.06-.09-.11-.13-.07-.15-.13-.04-.26-.07-.2.17l-.35-.5.26.81c-.3-.26-.45-.42-.59-.88.13.77-.06.35.11,1.09l-.2-.34c-.07.06.09.58-.12.33-.56-.54-.88.41-1.66.08.69.94-.47-.32-.01.46-.17-.22-.31-.32-.37-.56-.07.36-.55-.17-.3.57-.17-.22-.17-.37-.27-.5.01.06.06.25-.05.12-.11-.13-.09-.22-.12-.34-.2.18.23.91.63,1.6-.31-.25-.34-.17-.14.32-.18-.2-.38-.39-.3-.55-.1.02-.67-.04-.34.51-.11-.12-.13.02-.11.1-.19.07-.24.03-.37.19l.1.06c.34.7-.05.23-.14.4l-.04-.07c-.6-.28,0,.31-.63-.04l.27.4c.51.9-.59-.35-.56.09l.21.19c.08.36-1-1.04-1.16-1.09-.07-.06-.04-.14-.05-.22-.57-.37.29.56.18.8-.21-.27-.4-.77-.56-.74-.2-.2.19,1.17-.31.71.17.2.34.4.35.62-.09.16-.87-.63-.57.15-.05-.05-.09-.11-.13-.16,0,.25-.16.5,0,.92-.92-1.38-.25,1.07-1.01-.26l-.28.25-.07-.14c-.25.03-.15.39-.04.75-.1-.06-.13-.21-.17-.28-.45-.1-.45-.04-.34.77l-.26-.42c.07.29-.8-.45-.83.21-.02-.05-.06-.14-.07-.21-.07.7-1.41-.81-.73.86l-.03.51c.35-.02.3.72.56.93-.07.15-.54-.34-.44-.5l.06.07c-.36-.87-.51-.12-.78-.71-.55.33-1.32.09-1.86.28l.35.65-.2.04c-.12-.14-.29-.5-.14-.53-.23-.35-.09.42-.03.56-.37-.16-.22-.83-.31-.81l-.09.1.06.07c.03.31.14.61-.04.65-.16-.09-.22-.4-.27-.41-.02-.05-.04-.07-.07,0l-.26.03.3.51c0,.3-.24.05.11.62-.52-.88-1.03-.02-1.23-.28-.01.45-.16.5-.37.52.08.1.31.71.12.69-.35-1.3-.48-.46-.91-1.33.32.57-.43.3.03,1.11-.17-.06-.16-.48-.36-.74-.18.6-.85-.08-1.24.24.05.17.21.4.2.68l-.52-.75c-.06.11.26.98-.1.47.07.13.18.33.14.4-.57-.25-.95.09-1.36.36-.41.27-.83.46-1.68.02.29.23.23.3.14.37.1.04.22.38.35.58-.23-.12-.46-.24-.7-.35.29.59-.36.29-.04.84l.04-.17c.29.71,1.11,1.25,1.6,2.08-.31-.81.97.88.57-.29.14.15.11.29.24.47-.15-.39-.12-.5.09-.4l.03.1c.3-.26.63.03,1.13.11l-.21-.42c.11.02.19.15.27.24-.17-.71-.26.07-.48-.7.48.84.66-.25,1.13.75.14-.05-.23-.5-.09-.55l.14.27-.09-.37c.12.02.29.36.38.59-.03-.02-.04.09-.06.12.23.29.3-.23.38-.14l-.2-.12c.3-.4.93-.19,1.15-.9l-.1-.2c.19-.49.33.15.62-.14v.05c0-.23.07-.37.17-.38-.01.28.33.43.3.74.22-.55.07-.4.04-1.27l.17.33c-.03-.35-.08-.52.06-.67-.04.35.3.49.27.95.66.63.28-.97.87.08-.19-1.02-.53-.42-.51-.66-.19-.29-.12-.77.03-.71.12-.02.67,1.16.97,1.02-.03,0,0,.08-.04.09.21.2.09-.42.38-.09-.16-.61.19-.04-.09-.78l-.2.28c.08-.26-.14-1.17.28-.86.04.16.05.38.04.51.16.18.08-.2.25-.01.29.74-.26.3-.2.93.21.27.1-.66.34.16-.3-1.06.35,0,.22-.85l.18.44c0-.08-.02-.32.04-.33l.14.61c-.05-.55.5.28.55-.05-.33.16-.31-.49-.59-.75.14-.75.75,1.04,1.1.62-.03.09-.35-.15-.34-.39.12.05.31.16.47.36.25-.23-.25-.42-.25-.74.35.48.04-.28.09-.51l.21.44c.47.12-.35-.95.11-.75l.17.66.08-.23.21.51c0-.45.09-.38.33-.32-.19-.29-.37-.79-.23-.88.23.21.15.44.33.27.09.29.21.66-.08.3.06.15.09.29.15.44.26.24.31-.06.38-.11-.04,0-.08,0-.13-.06v-.75c.12.14.15.29.18.43.04-.08-.03-.3.04-.38.16.36.35.72.31.95l.08-.54c.1.14.36.34.39.49.27.12.03-.88.38-.72-.03-.07-.04-.15-.02-.22.23-.03.64.31.61-.29l.47.54c.1-.24-.6-.68-.44-1.07.1-.31.37.48.54.61-.07-.37-.25-1.1.22-.71,0,.15-.1.09-.13.17ZM631.73,28.48c.01.11.09.43-.09.2-.24-.5-.07-.3.09-.2ZM634.28,25.56c.05.15-.03.12-.18,0,.02-.06.07-.07.18,0ZM641.53,17.47s0,.01,0,.02c-.18-.12-.11-.07,0-.02ZM641.82,17.56c0-.07-.04-.13-.08-.19.04.12,0,.15-.07.14.07.11.14.17.15.04ZM621.76,29l.08.1c-.03.16-.06.04-.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.28,26.34c-.05-.06-.1-.14-.15-.21.03.08.08.16.15.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "628.52 30.97 628.51 30.97 628.54 31.05 628.52 30.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M640.79,22.75c-.07-.04-.14-.1-.2-.17.06.1.12.18.2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.54,16.29l-.08.18c.05-.05.12.03.19.08-.05-.1-.15-.24-.11-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.92,18.49c0-.06.04-.02.03-.09l-.1-.2c-.07.05-.06.24.06.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.35,17.68c.18.36.2.2.26.09,0,0,0,0-.02,0-.21-.53-.23-.31-.25-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.63,17.74s.04-.05.08-.05c-.09-.21-.05-.03-.08.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M641.96,17.19c.09.07-.2-.48-.11-.34-.18-.49-.01.7.11.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "643.99 18.85 643.75 18.41 643.87 18.8 643.99 18.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.14,18.86l.2.06c-.04-.07-.04-.13-.04-.17-.09.03-.23-.01-.16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.31,18.74s.09-.04.08-.13c-.02.02-.07.06-.08.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "643.87 19.08 643.78 19.01 643.67 19.02 643.87 19.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M641.6,19.53l-.08.21c.07.16.15.23.18.14-.02-.12,0-.21-.1-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.68,20.51c-.09-.07-.14-.17-.24-.31l.28.55-.04-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.32,20.87c.07.16.02.55.19.42-.06-.16.02-.36-.19-.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "639.72 21.4 639.76 21.37 639.25 20.49 639.72 21.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M639.03,24.63c.29.11-.28-.56.03-.39-.08-.23-.25-.14-.32-.34.03.28-.1.19.29.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M638.74,23.89s-.01-.1-.03-.16c0,.07.01.12.03.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "613.81 31.67 613.55 31.59 613.83 31.81 613.81 31.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M613.98,32.46l-.41-.51.26.53s.04-.13.14-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.72,29.41l-.07-.14c-.1-.13-.14-.13-.2-.12l.28.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "630.93 29.91 630.96 29.91 630.61 29.43 630.93 29.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.97,31.32c.07,0,.07-.16.13-.17-.07.16-.51-.46-.13.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M618.66,42.94s.07.38.09.45c.03-.1-.12-.55-.09-.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "619 41.87 619.03 42.04 619.01 41.61 619 41.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M619.54,41.74c-.23-.68-.17.16-.33-.06l-.06-.15.1.57c.09-.12.15-.53.28-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.21,43.16c-.09-.27,0-.25-.09-.07.01.03.02.04.03.07.01,0,.03-.01.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.15,43.16c-.05.03.09.22,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.37,42.94v.26c.04.16.12.17.12.3.04-.15-.01-.31-.12-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.31,42.42v.11c.01.06.03.09,0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.27,42.76l.03-.23c-.04-.11-.1-.33-.02.09-.04-.21-.01,0,0,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.2,42.67c-.08-.14-.16-.22-.14-.48-.12.13.02.61.14.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M619.39,41.01l-.11-.19v.24c0-.12.17.16.11-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.92,43.18c-.03-.15-.12-.39-.18-.57v.18c.04.09.12.17.18.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.75,42.61l.02-.27c-.08-.01-.06.11-.02.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "620.13 41.64 620.13 42.21 620.16 41.63 620.13 41.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "621.24 43.12 621.28 43.48 621.23 42.94 621.24 43.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.43,43.01c.04.29.16.47.17.65.04-.06.03-.32.02-.55-.02.13-.07.11-.19-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.62,42.78c0,.07,0,.2,0,.34,0-.07,0-.17,0-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.93,42.37c.03.09.1.32.17.4l-.14-.41h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.96,42.36h0s.06.02.08.02c0,0-.03,0-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.92,42.37h0s-.02-.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.44,41.96c0-.24.03-.52-.16-.85.04.29.14.48.16.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.75,41.86l-.11-.07c.03.11.08.26.09.39l.02-.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "620.76 41.72 620.75 41.86 620.79 41.89 620.76 41.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.38,42.42c0-.19.03-.22.07-.26-.07-.07-.13-.1-.18-.09.03.13.06.37.11.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.16,42.36v-.03s-.02-.04,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.91,42.06s-.02-.05-.03-.07l.02.07h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.24,42.01c-.06-.07-.06.04-.05.17.02-.05.04-.08.07-.09-.01-.06-.02-.1-.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.7,42.55c-.04-.08-.08-.15-.12-.21.05.13.14.32.12.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.21,42.44s0,.02,0,.02c.03.09.02.04,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.21,42.44c0-.06,0-.17-.01-.27-.01.04-.03.09-.03.15.01.03.03.07.04.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.41,39.36c.09.39.07.77-.11.37-.02.31.35,1.56.59,2.25-.04-.17-.08-.32-.04-.57-.08-.2-.31-.45-.32-.81.07-.23.13.11.23.3-.16-.47-.02-.73-.22-1.43l-.04.27c-.03-.11-.03-.29-.09-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.71,41.99l-.02.06c.06.06.12.2.25.49.01-.2,0-.35-.04-.48h-.19s0-.07,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.53,42.08c-.07-.43-.03-.62-.2-1.06-.1.05.01.37,0,.56.14-.15,0,.24.19.45-.02.08-.04.11-.06.13.04.04.09.1.13.17v-.03s-.01,0-.01,0h0c-.02-.06-.03-.09-.01-.06,0,0,0,0,0,0-.01-.06-.02-.11-.03-.16.07.07.03.11.03.16v.06s.02,0,.02,0l.11-.27s-.09-.03-.16.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.16,40.2s.02.07.03.1c0-.05,0-.09-.03-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.29,40.43c0,.06.03.23-.02.2-.07-.12-.05-.2-.09-.34,0,.12-.01.32.12.51v-.06c.1.13.32.63.32.69-.11-.37-.2-.64-.34-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.89,41.15l.09-.24-.16-.34.06.22c-.1-.06-.02.2.01.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "621.98 42.26 622.07 42.71 622 42.07 621.98 42.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "622.15 42.17 622.23 42.55 622.23 42.31 622.15 42.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.64,35.11l.02-.12s-.02.08-.02.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.32,35.14l.03.19c0-.11-.01-.19-.03-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M626.65,41.09c.14.35.33.89.23.46l-.11-.42c-.03.09-.07.04-.12-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.24,37.9s-.03-.08-.04-.13c.01.15.03.29.04.42,0-.09,0-.19,0-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M628.93,36.13l.14.26c-.04-.09-.08-.18-.14-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.25,34.34l-.03-.44c-.08.02,0,.23.03.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M623.99,41.57c.09.15.15.21.19.22-.12-.23-.25-.58-.19-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.37,39.66c.01-.08,0-.17-.01-.27-.01.08-.01.16.01.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M624.33,41.76s-.03-.06-.05-.09c-.02.08-.05.15-.1.13.09.17.17.27.15-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M639.49,33.68s.01.03.02.05c0-.06-.01-.06-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M641.91,37.76s-.04.03-.07.04c.02.03.04.02.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.93,42.17s0,.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.34,40.55s-.01-.11-.03-.21c.02.1.03.17.03.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M624.12,39.03h0c-.03-.08-.03-.06,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.83,42s.05.09.08.11c-.02-.03-.04-.07-.08-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.88,42.19s-.03-.02-.04-.03c.01.07.03.11.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.98,42.14s-.05,0-.07-.03c.01.03.02.05.02.06,0,0,.02-.02.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M636.37,35.35s0,.02.02.04c.01-.18,0-.15-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M626.73,36.46v.02s0,0,0,.01v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M626.81,36.11c.05.54,0,.48-.07.38l.31,1.21-.24-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.36,34.85l-.17-.36c0-.65.14-.45-.06-.97.23,1.34-.37.21-.14,1.55l-.12-.27s.01-.07.03-.06c-.25-.62.08.98-.12.82-.08-.09-.15-.28-.14-.44l-.07.35s-.08-.25-.03-.23l-.18.14v-.04c0,.21,0,.55,0,.69-.09-.18,0-.15-.05-.31l-.05.34c-.11-.34-.08-.69,0-.65-.36-1.31-.03.35-.4-.38l.07-.19c-.21-.74-.24-.45-.45-.9.08.24.46,1.14.41,1.5-.05-.09-.11-.13-.12.15-.09-.47-.13-.35-.21-.3l-.12-.63c-.05.2.02.52.02.81-.11-.04-.22-.53-.32-.93-.17-.07.26.76.1.91-.17-.22-.21.06-.29.46-.13-.2-.06-.39-.13-.56l.02.52s-.05-.16-.06-.24c-.03.21.12.63.05.82.11.7-.41-.97-.38-.16-.07-.17-.06-.39-.12-.63-.07.55-.08.4-.08,1.13l-.21-.39c.18.45.18,1.03.17,1.51.08.22.15.41.18.51l-.09.37c-.04-.1-.07-.32-.09-.58,0,.05,0,.11,0,.16-.1-.22-.15-.59-.18-.95.04.12.09.25.14.38-.04-.39-.09-.82-.17-1.18,0,.07,0,.14-.02.18-.01-.11-.02-.2-.04-.26-.02-.06,0,.08,0,.24l-.18-.69.05.28-.3-.4c0,.73.07,1.79-.1,2.13-.05-.52-.16-.84-.28-1.45.2.63.13-.31.28-.21-.08-.05-.12-.35-.13-.45l-.1.63c-.1-.5-.12-.36-.22-.56.25.97-.03.69-.06,1.01-.07-.33-.12-.67,0-.61-.27-.71.08,1.18-.17.58.02-.01.05.03.03-.14,0,.31-.2.11-.23-.19h.03c-.2-.09-.54.09-.39.93-.02-.11-.18-1.01-.21-1.18l.28,2.87c-.12-.72-.59-2.4-.53-2.83-.06-.09-.14-.2-.18.07.05.1.29,1.02.27,1.09-.28-.77-.17-.41-.44-1.06.08.14.27,1.27.19,1.25-.03-.17-.24-1.1-.24-1.23l.07,1.14c0-.21-.19-.93-.3-1.24.06.21-.15.01-.17.13l.13.24c-.23-.12.15,1.59-.05,1.57-.03-.23-.25-1.41-.38-1.53.08.57.4,2.75.33,3.22l-.1-.31-.05.39c-.11-.86-.28-2.69-.31-3.41-.13-.24-.1-.38-.2-.32-.1-.29-.04-.47-.01-.49l-.29-.14c.16.65-.05.7.08,1.25l.12-.74c.15.65.25,1.9.05,1.82-.1-.25-.23-1.18-.28-1.39.03.23-.07.47-.12.31v-.37c-.16-.22.03.91-.23.31-.05-.03-.31-.82-.23-.43.23.73.77,3.05.85,3.62-.03-.05-.37-.67-.5-1.03-.2-.57-.21-1.42-.39-1.91.04.18.05.41.05.48-.08-.14-.11-.56-.18-.46.13.67-.2-.01.08.57-.05.21-.13-.11-.23-.06.13.42.24,1.48.19,1.69-.03-.17-.1-.39-.14-.48-.2-.02-.37-.3-.54-.26-.05-.16-.18-.33-.21-.63,0,.12.03.35-.02.38-.24-.55.1-.12-.14-.79.08.39-.02.56-.04.82.16.59.2.07.22-.19.19.82.26,1.71.17,2.14-.09.24-.19-.52-.18-.39-.3-.08.11,1.49-.25.95-.21-.5-.25-1.04-.36-1.41.07-.23.26.29.33.25l-.16-.23c0-.18.04-.33.12-.19-.18-.45-.48.01-.79-.37,0,.18-.02.38.06.58l.05-.09c.16.41.02.61.15.79-.02.32,0,.81-.18.6l-.17-.59c.04.17.17.34.16.15.01.28-.38-.76-.25.03l.19.39c-.02.32.03.98-.13.82.19.58,0-.07.25.6-.27-.84.29-.03-.04-.91.27.78.22.31.48.96-.05-.2-.13-.37-.01-.29,0-.06-.02-.13-.02-.18h0s-.01,0-.01,0c0-.03,0-.04,0,0-.04-.08-.08-.18-.12-.29-.06-.46.09-.48.08-.73.08.08.03.23.11.43v-.37c.1.44.31.69.24.98h.12c.13.22.24.3.25.1.08.08.02-.52.06-.16l.12-.31.03.11c.19.01.2-.81.58-.07.03-.12.07-.27.19-.17l.11.37c.05-.15.32.33.26-.08.31,1,.42.14.6.29l-.11-.5c.1,0,.16-.15.23-.38l-.1-.44c.02-.38.33.25.47.17.03.17-.02.14-.07.04.41.95.24-.81.57-.12,0-.17.05-.12.1-.02,0,0,0,.01,0,.03,0,0,.01,0,.02,0,.04.07.08.15.11.22-.04-.1-.08-.19-.1-.22.03-.02.07-.08.09-.2l.12.47s0,0,0-.02c.09.16,0-.23-.11-.58,0-.08.01-.18,0-.3.2.75.07-.28.3.51-.05-.4.18-.35.03-1.19.02.11.05.16.03.17.08.08.15.17.15-.08l.15.59-.05-.83c.15.35.23.56.25,1.03.02-.75.08-.3.08-1.03l.07.39s.03-.56.12-.25c.27.71.61-.02,1.05.6-.29-1.13.25.48.08-.4.07.27.15.41.15.65.1-.3.32.38.27-.39.07.27.05.4.1.56,0-.06,0-.24.05-.09.05.16.02.23.02.35.15-.08,0-.91-.15-1.7.16.35.18.29.14-.23.08.25.18.51.1.62.06.03.41.31.29-.32.05.16.09.03.09-.04.13.01.15.07.26-.02l-.05-.1c-.1-.77.07-.19.15-.3v.08c.35.5.06-.28.41.3l-.1-.47c-.18-1.02.32.56.37.15l-.1-.26c0-.36.47,1.34.56,1.45.03.08,0,.15,0,.22.3.56-.1-.62.02-.79.09.33.13.85.24.9.1.26.06-1.13.31-.52-.08-.25-.15-.5-.13-.71.08-.11.45.92.39.09.03.07.04.13.06.2.04-.22.18-.39.14-.84.37,1.62.32-.88.6.62l.22-.12.02.15c.17.07.15-.3.14-.67.05.1.05.24.06.32.27.26.28.2.33-.58l.11.48c0-.29.45.71.56.1,0,.06.02.15.02.22.14-.62.81,1.25.59-.54l.08-.47c-.23-.1-.1-.78-.24-1.06.06-.12.3.5.22.61l-.03-.09c.12.93.31.28.42.92.4-.11.88.33,1.26.31l-.16-.71.14.02c.06.16.14.56.04.54.12.4.1-.37.08-.53.23.26.07.85.13.86l.07-.07-.03-.08c.01-.31-.03-.62.09-.6.1.13.11.44.14.46,0,.05.02.07.05.01l.18.03-.16-.56c.03-.29.16,0-.02-.63.27.98.68.26.8.56.04-.43.14-.44.28-.41-.05-.11-.17-.75-.05-.69.17,1.33.29.54.53,1.48-.18-.62.29-.2.02-1.08.11.09.08.49.2.8.14-.55.53.26.77.05-.02-.17-.11-.43-.09-.7l.27.85c.04-.09-.1-1.01.09-.42-.04-.14-.09-.36-.06-.42.65.77.97-.85,1.73.67-.12-.33-.08-.37-.02-.39-.05-.08-.06-.43-.1-.67l.32.62c-.05-.66.23-.08.17-.71l-.06.12c0-.75-.36-1.62-.48-2.58.01.86-.46-1.2-.46.02-.07-.19-.01-.31-.06-.53.01.41-.03.5-.15.34v-.1c-.27.14-.45-.25-.8-.47l.09.47c-.08-.05-.11-.2-.16-.31.03.72.2.01.24.81-.23-.94-.48.06-.7-1.02-.1,0,.11.54,0,.55l-.07-.29.03.38c-.08-.05-.17-.41-.21-.66.02.03.04-.08.05-.1-.14-.33-.23.15-.28.05l.13.17c-.24.32-.65-.02-.83.62l.05.22c-.15.44-.2-.22-.4,0v-.05c-.01.23-.05.35-.12.33.02-.27-.19-.49-.16-.78-.16.47-.06.36-.08,1.21l-.09-.36c0,.34.03.51-.07.63.04-.33-.16-.55-.12-.98-.37-.76-.23.87-.53-.29.05,1.03.3.53.27.76.1.32.03.77-.06.68-.08-.01-.34-1.27-.53-1.22.02,0,0-.08.03-.07-.11-.25-.08.37-.24-.03.05.62-.12-.02,0,.77l.15-.21c-.07.22,0,1.15-.25.73-.01-.16,0-.38.02-.5-.09-.22-.07.17-.16-.06-.12-.78.19-.21.2-.82-.11-.32-.11.6-.2-.26.1,1.09-.21-.1-.21.74l-.07-.47c0,.08-.01.31-.05.3l-.03-.62c-.02.54-.28-.42-.33-.12.21-.05.14.56.29.88-.16.67-.36-1.2-.61-.92.03-.07.2.26.17.48-.07-.09-.18-.25-.25-.49-.18.13.11.48.08.78-.16-.56-.06.25-.11.45l-.08-.48c-.27-.27.11,1-.15.67l-.03-.67-.07.19-.07-.54c-.04.42-.1.32-.23.19.08.33.14.86.04.9-.12-.27-.04-.46-.17-.37-.02-.3-.05-.68.09-.25-.01-.16-.03-.3-.04-.46-.13-.31-.19-.04-.24-.03.02.01.05.04.07.1l-.09.69c-.06-.17-.06-.32-.06-.47-.03.06-.02.28-.07.33-.05-.39-.13-.79-.07-.98l-.12.46c-.04-.17-.18-.44-.18-.59-.15-.21-.13.8-.32.52,0,.08,0,.15-.02.21-.15-.06-.35-.52-.41.04l-.22-.68c-.09.18.28.85.12,1.15-.1.25-.16-.58-.25-.76,0,.36,0,1.09-.24.56.02-.14.07-.04.11-.1ZM630.9,35.44c.01-.1,0-.42.08-.15.07.55,0,.29-.08.15ZM628.84,37.03c-.01-.16.04-.09.11.08-.02.04-.05.03-.11-.08ZM623.27,41.69s0-.01,0-.02c.11.17.07.1,0,.02ZM623.09,41.52c0,.07.02.13.04.2-.02-.12,0-.14.05-.11-.04-.12-.08-.2-.09-.09ZM637.32,38.48l-.05-.12c.04-.15.04-.02.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M628.96,36.33c.02.08.04.17.06.25,0-.08-.02-.17-.06-.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "633.26 34.43 633.27 34.43 633.25 34.34 633.26 34.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M624.23,37.06c.04.06.08.14.11.23-.02-.12-.06-.21-.11-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.58,42.48l.05-.14s-.07-.07-.11-.14c.03.11.08.26.06.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.14,39.76c0,.06-.02.01-.02.07l.06.22s.04-.21-.03-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.13,40.94c-.1-.39-.12-.25-.16-.16,0,0,0,0,.01,0,.12.56.13.36.15.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.95,40.8s-.03.04-.05.02c.05.22.03.04.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.98,41.82c-.05-.1.1.51.05.35.09.51.04-.65-.05-.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "621.77 39.65 621.9 40.14 621.84 39.74 621.77 39.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.32,39.9l-.13-.11c.02.08.02.13.01.17.06,0,.15.08.11-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.21,39.96s-.06.02-.06.1c.02,0,.05-.03.06-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "621.86 39.48 621.91 39.57 621.99 39.59 621.86 39.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M623.37,39.75l.07-.16c-.03-.17-.08-.27-.1-.19,0,.12-.02.2.03.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.74,38.49c.05.09.08.2.13.36l-.14-.61v.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M623.01,38.28c-.03-.17.04-.52-.08-.45.03.17-.04.33.08.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "624.77 38.68 624.74 38.7 624.97 39.69 624.77 38.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M625.64,35.99c-.18-.21.1.62-.07.35.02.24.15.22.16.43.02-.26.09-.13-.09-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M625.73,36.77s0,.09,0,.16c0-.07,0-.12,0-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "642.28 38.26 642.39 38.45 642.29 38.12 642.28 38.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.33,37.49l.11.64-.03-.59s-.04.09-.08-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.43,34.2l.02.15c.04.16.07.17.11.19l-.13-.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "631.62 34.47 631.6 34.46 631.75 35.03 631.62 34.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.42,33.56s-.06.12-.11.1c.06-.12.25.62.11-.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635.5,44.86s.05-.38.06-.45c-.05.09-.07.56-.06.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "635.04 45.78 635.06 45.61 634.97 46.02 635.04 45.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.69,45.74c-.03.71.14-.1.18.15v.16s.07-.57.07-.57c-.08.08-.22.46-.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.63,44.18c-.01.28-.06.23.04.09,0-.03,0-.05,0-.07,0,0-.02,0-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.67,44.2s0-.23,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.48,44.35l.07-.24c0-.16-.04-.21,0-.32-.06.13-.07.29-.06.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.39,44.86l.03-.1c0-.07,0-.09-.03.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.5,44.54l-.07.22c0,.12-.02.35.03-.08-.02.21,0,0,.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.52,44.65c.01.16.04.26-.03.5.1-.09.13-.59.03-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.6,46.47l.02.21.05-.24c-.03.12-.05-.2-.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.21,43.95c-.02.15-.02.4-.03.6l.05-.17c0-.11-.04-.2-.02-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.17,44.55l-.08.25s.07-.09.08-.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "634.31 45.65 634.45 45.11 634.29 45.65 634.31 45.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "634 43.91 634.06 43.57 633.96 44.09 634 43.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.86,43.96c.05-.29.01-.49.05-.67-.04.05-.1.29-.14.52.04-.12.07-.09.09.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.69,44.13c.02-.07.05-.19.08-.32-.02.07-.05.16-.08.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.01,44.72c0-.09.02-.33,0-.44l-.02.43s.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.99,44.73h0s-.04-.04-.04-.04c0,0,.02.02.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.02,44.72s0,0,0,0c0,.04,0,.06,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.2,45.25c-.05.24-.14.48-.11.85.05-.29.03-.5.11-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634,45.26l.05.1c0-.11.01-.28.04-.39l-.09.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "633.96 45.39 634 45.26 633.98 45.22 633.96 45.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.75,44.54c-.04.18-.07.2-.1.22.03.09.06.13.09.14.02-.13.05-.37.01-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.87,44.67s0,.01,0,.02c0,.04,0,.05,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.35,44.73s0,.05,0,.08c0-.02,0-.05,0-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.74,44.98c.02.08.04-.02.07-.15-.02.04-.04.07-.07.07,0,.06-.01.1,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.59,44.32c0,.09.01.17.02.24,0-.14,0-.35-.02-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.86,44.57s0-.01,0-.02c0-.09,0-.05,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.86,44.57c-.02.06-.04.16-.06.26.02-.03.04-.08.05-.14,0-.03,0-.08,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.02,47.46c.04-.39.14-.75.15-.33.08-.29.16-1.59.17-2.32-.02.17-.03.33-.11.56,0,.22.08.52,0,.87-.09.2-.05-.14-.07-.36-.01.49-.16.71-.2,1.43l.09-.25c0,.11-.05.29-.04.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.45,44.86l.03-.05c-.02-.07-.03-.23-.03-.54-.06.19-.08.33-.09.47l.11.06v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.58,44.82c-.06.43-.13.61-.13,1.07.07-.02.08-.35.14-.54-.12.1.05-.24,0-.49.03-.07.05-.09.07-.11-.02-.05-.03-.12-.04-.2,0,0,0,.02,0,.03h0s0,0,0,0c0,.05,0,.09,0,.06,0,0,0,0,0,0,0,.06-.01.11-.02.16-.02-.09,0-.11.02-.16,0-.02,0-.04,0-.06,0,0,0,0,0,0l-.13.23c.02.06.05.05.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.95,47.02s0-.07,0-.1c-.01.05-.02.09,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.93,46.76c.01-.06.03-.23.06-.18.01.13-.02.21-.03.35.03-.11.08-.3.05-.52v.06c-.04-.15-.06-.69-.04-.75-.02.39-.03.66-.04,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.74,45.9l-.11.2v.38s.03-.22.03-.22c.05.09.06-.18.08-.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "633.36 44.52 633.41 44.07 633.3 44.7 633.36 44.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "633.23 44.56 633.27 44.17 633.22 44.4 633.23 44.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M626.02,48.86l-.04.11s.03-.07.04-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M626.21,48.91l.02-.19c-.02.11-.03.18-.02.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.27,44.35c0-.37,0-.95-.04-.5l-.03.43c.03-.08.05-.02.06.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M628.02,46.75s0,.09,0,.13c.02-.15.04-.28.06-.41-.02.09-.04.18-.06.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M627.84,48.54l-.03-.28c0,.1.01.19.03.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M624.9,49.23l-.07.44s.05-.22.07-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.98,44.61c-.02-.17-.04-.25-.06-.27.02.25.02.63.06.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M626.49,44.28c-.02.08-.04.16-.05.26.02-.07.04-.15.05-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.82,44.34s0,.07,0,.1c.03-.07.06-.13.09-.1-.01-.19-.04-.3-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M621.03,48.53s0-.03,0-.05c0,.06,0,.06,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M620.27,44.07s.03-.02.05-.03c0-.03-.02-.03-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.76,44.33s0-.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.74,46.05s-.02.11-.03.21c.01-.1.02-.17.03-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.33,47.01s0,0,0,0c0,.09,0,.07,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.78,44.53c0-.05-.01-.1-.02-.13,0,.03,0,.08.02.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.8,44.33s.01.03.02.04c0-.07.01-.12-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.73,44.35s.03.02.04.05c0-.03,0-.05,0-.07,0,0-.02.01-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M623.22,47.56s0-.02,0-.04c-.04.18-.03.15,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.22,48.78s0-.02,0-.02c0,0,0-.01,0-.02v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.1,49.09c.09-.53.1-.47.12-.35l.08-1.25-.2,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M625.53,48.95l.03.39c-.13.63-.17.41-.16.96.13-1.35.26-.12.39-1.47l.02.29s-.02.06-.03.05c.03.66.15-.97.24-.77.03.11.04.31,0,.46l.11-.33s0,.26-.03.23l.14-.1v.04c.03-.21.1-.54.13-.67.02.2-.03.14-.04.31l.1-.32c0,.35-.09.69-.13.63-.05,1.36.09-.34.16.47l-.08.17c-.02.77.05.5.08.98,0-.25-.04-1.22.06-1.55.01.1.04.16.1-.11-.04.48,0,.37.06.34l-.06.64c.07-.18.09-.5.15-.79.05.07.02.56,0,.98.09.11,0-.8.13-.91.06.25.14,0,.27-.38.04.22-.04.39-.04.57l.09-.5s0,.17-.02.25c.06-.19.06-.64.14-.8.08-.7.05,1.04.2.25,0,.18-.04.39-.06.64.16-.51.13-.37.28-1.07l.04.42c-.02-.48.11-1.04.21-1.5,0-.23,0-.44,0-.53l.13-.33c0,.11-.03.32-.07.59.01-.05.02-.1.03-.15.02.24-.03.6-.09.96,0-.13,0-.26,0-.4-.06.39-.12.81-.15,1.19.01-.07.03-.13.05-.17-.02.1-.03.2-.03.26,0,.07.02-.07.05-.23l-.04.71.03-.28.1.46c.16-.71.33-1.75.51-2.03-.08.52-.08.85-.14,1.47.02-.66-.14.27-.21.13.04.07,0,.37-.02.47l.19-.58c-.05.5,0,.38.02.59.06-1,.16-.66.25-.96-.03.34-.07.68-.13.59.01.76.2-1.16.22-.52-.02,0-.02-.05-.04.12.07-.29.14-.05.09.24h-.02c.1.13.34.04.43-.8,0,.11-.1,1.02-.13,1.19l.45-2.83c-.08.73-.16,2.47-.29,2.87.02.11.04.23.12-.02,0-.1.05-1.06.08-1.12,0,.82.01.44.04,1.14-.01-.16.12-1.3.16-1.26-.02.17-.09,1.13-.12,1.24l.21-1.11c-.04.2-.09.95-.09,1.27,0-.22.09.03.13-.08l-.02-.26c.11.18.26-1.56.37-1.5-.03.23-.16,1.42-.11,1.57.08-.57.37-2.75.51-3.18v.33s.11-.37.11-.37c-.13.86-.43,2.66-.57,3.36.02.26-.02.39.05.36,0,.31-.08.46-.1.48l.14.21c.05-.67.18-.66.22-1.22l-.23.68c.05-.67.27-1.89.37-1.76,0,.27-.13,1.19-.14,1.41.03-.23.15-.43.14-.27l-.08.35c.04.26.18-.88.2-.23.02.05,0,.87.04.47.02-.77.22-3.13.3-3.7,0,.05.07.74.07,1.12,0,.6-.19,1.42-.2,1.94.02-.18.06-.41.08-.48.01.16-.06.57,0,.49.07-.68.12.07.08-.57.08-.19.05.15.12.12.02-.44.19-1.49.27-1.68-.02.17-.02.4-.03.5.11.07.15.39.26.4,0,.17.03.37-.02.66.03-.12.06-.35.1-.36.02.59-.08.08-.1.79.04-.39.14-.54.21-.78.04-.61-.1-.13-.17.12.07-.84.23-1.71.39-2.09.11-.2,0,.55.02.43.16.16.28-1.46.37-.84.01.54-.09,1.07-.11,1.45-.09.2-.09-.35-.14-.33l.04.26c-.04.18-.1.31-.12.15,0,.49.29.12.38.57.04-.18.1-.36.1-.58l-.05.07c0-.44.13-.59.1-.8.08-.3.19-.77.25-.52l-.04.61c.01-.18-.02-.37-.06-.18.06-.27.05.84.16.04l-.02-.43c.08-.3.21-.94.27-.75.02-.61-.02.07-.01-.64-.03.88-.18-.05-.19.88.02-.82-.06-.35-.07-1.06-.02.2,0,.39-.06.28,0,.06-.02.13-.03.18,0,0,0,0,0-.02,0,0,0,.02,0,.02,0,.03,0,.04,0,0,0,.09,0,.2,0,.31-.07.46-.16.44-.22.67-.03-.1.03-.23.03-.45l-.08.35c.03-.45-.03-.75.08-1.01l-.07-.03c-.02-.25-.07-.36-.13-.17-.03-.1-.13.49-.07.14l-.14.27v-.11c-.1-.07-.3.72-.36-.1-.05.11-.1.24-.16.11l.02-.39c-.06.13-.12-.4-.17,0,.04-1.05-.22-.25-.3-.44l-.05.5c-.06-.03-.13.1-.22.3l-.03.45c-.1.36-.14-.33-.25-.3.02-.17.04-.12.05-.02-.04-1.02-.32.71-.37-.03-.04.16-.06.1-.07-.01,0,0,0,0,0-.02,0,0,0,0-.01,0,0-.08-.01-.17-.02-.24,0,.11,0,.2.01.24-.02,0-.06.06-.1.17l.03-.48s0,0,0,.01c-.02-.18-.04.22-.06.59-.02.08-.05.17-.07.29.04-.78-.11.25-.07-.58-.06.4-.19.29-.28,1.13,0-.11,0-.16.02-.17-.03-.1-.05-.2-.11.04l.04-.61-.15.81c-.01-.38-.02-.59.07-1.06-.18.71-.12.26-.27.97l.04-.39s-.14.54-.13.21c-.01-.76-.37-.14-.51-.85-.06,1.16-.05-.53-.13.37.01-.28,0-.43.05-.67-.12.26-.11-.45-.25.3.01-.28.06-.4.06-.56-.01.06-.05.24-.05.07,0-.16.03-.23.06-.35-.11.04-.19.88-.27,1.68-.02-.38-.05-.33-.13.19,0-.26,0-.54.07-.62-.03-.04-.19-.4-.25.24,0-.16-.05-.05-.06.02-.08-.04-.08-.1-.16-.05v.11c-.09.77-.07.17-.14.25v-.08c-.09-.57-.08.26-.17-.39l-.03.48c-.1,1.03-.08-.62-.19-.23v.28c-.07.35,0-1.41-.03-1.54,0-.09.03-.14.05-.21-.07-.62-.07.62-.17.76.01-.34.1-.86.04-.92,0-.28-.27,1.08-.3.43,0,.26,0,.52-.07.72-.07.09-.09-1-.22-.18,0-.07,0-.14,0-.21-.07.21-.19.34-.26.78.1-1.65-.37.78-.24-.75l-.16.07.02-.16c-.09-.11-.15.25-.22.62-.01-.11.02-.25.02-.33-.11-.32-.13-.26-.32.49l.03-.49c-.06.28-.14-.79-.32-.23,0-.06.02-.15.03-.22-.21.57-.25-1.4-.46.39l-.14.43c.12.15-.09.78-.06,1.08-.06.1-.09-.55-.02-.64v.09c.11-.94-.13-.35-.07-.98-.26.02-.47-.52-.71-.58l-.04.73-.08-.05c0-.17.02-.57.08-.54,0-.42-.13.34-.15.5-.09-.31.12-.85.09-.87l-.05.05v.09c-.06.29-.09.61-.16.57-.03-.15.02-.45,0-.48,0-.05,0-.08-.03-.02l-.1-.07v.58c-.08.28-.11-.04-.11.62.01-1.01-.37-.4-.39-.71-.1.41-.17.4-.24.34,0,.12-.03.77-.1.68.14-1.33-.08-.59-.05-1.56,0,.64-.21.14-.21,1.05-.05-.11.04-.5.02-.82-.18.5-.28-.36-.46-.2-.02.17-.01.45-.07.7v-.88c-.06.08-.13,1.01-.14.4,0,.15-.01.37-.04.43-.26-.88-.75.64-.95-.99.02.34-.02.37-.05.38.02.08-.04.43-.05.67l-.09-.67c-.08.66-.16.03-.23.66l.06-.11c-.13.74-.06,1.66-.15,2.61.14-.84.07,1.27.29.07,0,.2-.05.31-.05.53.06-.41.1-.49.15-.3l-.02.1c.19-.08.23.33.4.61l.03-.47c.04.07.03.22.04.34.11-.71-.12-.05,0-.84-.03.97.3.04.24,1.14.07.01.03-.55.09-.54v.3s.04-.38.04-.38c.04.07.03.44,0,.69,0-.03-.04.07-.05.09.03.35.17-.1.18,0l-.05-.19c.2-.26.39.15.61-.44v-.22c.17-.4.09.25.25.08v.05c.04-.22.09-.33.12-.3-.06.26.02.51-.05.8.18-.43.1-.34.27-1.16v.37c.05-.33.07-.51.15-.6-.09.31,0,.57-.11.98.08.82.3-.8.26.39.16-1.02-.08-.58-.02-.79,0-.34.12-.76.16-.65.05.03-.03,1.31.09,1.31-.01,0-.02.07-.03.07.02.26.12-.35.14.08.09-.62.07.04.15-.75l-.13.17c.08-.2.22-1.12.29-.66-.02.16-.07.37-.1.48.01.24.07-.15.08.09-.08.79-.15.16-.27.76,0,.34.18-.56.07.29.14-1.08.11.15.26-.68l-.05.47c.02-.07.07-.29.09-.28l-.1.61c.11-.52.09.47.18.19-.14,0,.02-.57,0-.92.22-.62-.01,1.25.19,1.03-.03.06-.07-.29-.01-.51.03.1.06.29.06.54.13-.09.02-.49.1-.77,0,.58.08-.23.15-.41l-.04.48c.11.32.12-1,.22-.61l-.11.66.08-.17-.06.55c.11-.4.12-.29.18-.13.01-.34.08-.87.15-.88.02.29-.06.45.03.39-.05.3-.1.67-.1.23-.02.16-.05.3-.06.45.02.33.11.08.14.08-.01-.02-.02-.05-.02-.12l.19-.66c0,.18-.02.33-.05.47.03-.05.07-.27.11-.31-.04.39-.08.79-.15.97l.16-.42c0,.17.02.47,0,.61.05.24.23-.74.29-.43.01-.08.03-.15.05-.2.08.1.11.58.26.05v.71c.09-.15,0-.89.15-1.14.11-.22-.02.6,0,.8.08-.35.22-1.06.25-.48-.04.13-.05.02-.08.07ZM626.52,48.72c-.03.1-.09.41-.08.12.07-.55.06-.28.08-.12ZM628.09,47.69c-.03.16-.04.08-.05-.11.02-.04.04-.02.05.11ZM632.45,44.7s0,.01,0,.02c-.03-.19-.02-.12,0-.02ZM632.52,44.91c.01-.07.02-.13.02-.2-.02.12-.04.13-.06.09,0,.13,0,.21.03.11ZM623.23,44.3v.13c-.04.13-.02.01,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M627.86,48.33c0-.08,0-.17.01-.26-.01.08-.02.17-.01.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M624.91,49.15s0,0,0,0c0,.03,0,.06-.01.09v-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.83,48.87c-.01-.07-.01-.16-.01-.25-.01.12-.01.22.01.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.05,44.14l-.07.12s.03.08.04.16c0-.11.01-.28.03-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.27,47.15c.01-.06.02,0,.03-.06l.02-.22s-.08.19-.05.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.96,45.74c-.03.4.02.27.06.2,0,0,0,0,0,0,.06-.56,0-.38-.05-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.03,45.92s.03-.03.04,0c.02-.23-.01-.05-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.65,44.66c0,.11.06-.52.05-.35.07-.51-.18.61-.05.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "632.87 47.07 632.9 46.57 632.85 46.97 632.87 47.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.6,46.68l.05.14c0-.08.02-.13.03-.17-.04-.02-.07-.12-.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.68,46.65s.04,0,.06-.08c-.01,0-.04.02-.06.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "632.78 47.22 632.77 47.11 632.73 47.07 632.78 47.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.94,46.53l-.08.14c-.02.17-.01.28.02.21.03-.12.06-.18.06-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.03,47.91c0-.1,0-.22,0-.38l-.06.62.05-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.82,48.04c-.02.17-.14.48-.05.45.02-.17.1-.31.05-.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "630.87 47.17 630.89 47.16 630.97 46.15 630.87 47.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.76,49.52c.06.25.07-.62.12-.31.04-.24-.04-.25,0-.46-.07.25-.08.1-.12.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.88,48.74s.02-.09.04-.15c-.02.06-.03.11-.04.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "620.13 43.51 620.1 43.29 620.1 43.64 620.13 43.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M619.97,44.25l.04-.65-.08.58s.04-.08.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M626.55,50.04l.02-.16c0-.17,0-.18-.03-.21v.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "625.9 49.49 625.91 49.51 625.94 48.92 625.9 49.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M625.25,50.19s.06-.1.08-.07c-.06.1-.03-.66-.08.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M613.01,29.56s.22.31.27.37c-.02-.11-.34-.46-.27-.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "612.82 28.49 612.92 28.63 612.71 28.26 612.82 28.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M613.19,28.19c-.49-.53-.06.2-.29.06l-.11-.12.33.47c.02-.14-.11-.52.07-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.37,29.23c-.19-.21-.11-.22-.1-.03.02.02.04.03.05.05,0-.01.02-.02.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.32,29.25s.17.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.4,28.98l.1.23c.11.12.18.11.24.22-.03-.15-.15-.27-.35-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.12,28.53l.04.1s.07.06-.04-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.24,28.86l-.08-.22c-.08-.08-.23-.26.02.08-.13-.17-.01,0,.06.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.14,28.8c-.13-.1-.23-.14-.33-.38-.04.16.29.53.33.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M612.75,27.61l-.17-.13.12.21c-.06-.11.2.09.05-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.96,29c-.09-.12-.27-.3-.4-.45l.07.17c.09.06.18.11.33.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.56,28.55l-.11-.25c-.07.02,0,.12.11.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "613.63 27.91 613.88 28.41 613.64 27.89 613.63 27.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "615.19 28.83 615.38 29.13 615.1 28.67 615.19 28.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.3,28.66c.16.24.35.35.44.51,0-.07-.12-.29-.23-.49.05.12,0,.13-.2-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.34,28.39c.03.07.09.18.16.29-.03-.07-.07-.15-.16-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.6,28.28c.06.07.22.25.32.3l-.29-.31h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.61,28.26h0s.05,0,.06-.01c0,0-.03,0-.07.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.59,28.28h0s-.04-.04,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.02,28.09c-.12-.21-.21-.47-.51-.69.16.25.33.37.51.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.22,27.89l-.12-.03c.07.09.19.2.25.31l-.12-.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "614.16 27.76 614.22 27.89 614.27 27.9 614.16 27.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.98,28.17c-.09-.17-.07-.2-.06-.25-.09-.04-.15-.04-.19-.01.08.11.22.31.25.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.78,28.18v-.02s-.05-.03,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.24,27.65s-.04-.04-.05-.06l.05.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.68,27.85c-.08-.04-.03.05.04.17,0-.05,0-.09.02-.11-.04-.05-.06-.08-.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.31,28.16c-.07-.06-.13-.1-.2-.14.1.09.26.23.2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.85,28.24s0,.02,0,.02c.07.06.04.03,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.85,28.24c-.03-.06-.08-.15-.13-.23,0,.04.02.09.05.15.02.02.05.05.08.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M613.58,25.47c.25.31.42.65.09.37.13.28,1,1.25,1.52,1.76-.11-.13-.21-.26-.3-.49-.16-.15-.46-.28-.63-.6-.05-.22.15.05.33.18-.35-.35-.36-.63-.84-1.18l.1.25c-.07-.09-.16-.24-.25-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.05,27.66v.06c.08.03.2.13.44.34-.08-.18-.17-.3-.25-.41l-.16.06-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.95,27.81c-.26-.35-.31-.54-.65-.87-.05.08.18.32.26.5.05-.18.12.21.36.33.02.08.02.11,0,.14.05.02.12.06.19.1l-.02-.02h0s0,0,0,0c-.04-.04-.06-.06-.04-.04,0,0,0,0,0,0-.04-.05-.07-.09-.1-.13.09.04.08.08.1.13l.04.05h0s-.03-.27-.03-.27c-.06-.03-.09,0-.11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M612.99,26.63s.05.05.07.07c-.03-.05-.05-.08-.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M613.2,26.79c.03.05.13.19.08.18-.11-.08-.13-.16-.22-.27.06.1.14.29.32.41l-.03-.05c.14.08.54.44.57.49-.26-.29-.45-.49-.72-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.01,27.22l-.04-.24-.29-.25.15.17c-.11-.02.08.18.18.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "615.39 27.81 615.67 28.17 615.32 27.63 615.39 27.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "615.48 27.66 615.73 27.97 615.61 27.76 615.48 27.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M619.05,17.94l-.05-.11s.03.07.05.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M618.84,18.09l.13.15c-.06-.09-.12-.15-.13-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M618.52,25c.28.24.71.63.41.3l-.3-.31c.02.08-.03.07-.11.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M618.83,21.24l-.1-.09c.09.12.17.23.25.33-.05-.08-.1-.16-.15-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M617.64,19.89l.24.16c-.08-.06-.16-.12-.24-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M619.76,16.62l-.28-.35s.13.19.28.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M616.67,26.46c.15.1.22.13.26.12-.2-.15-.48-.41-.26-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.13,21.36c-.04-.07-.09-.14-.16-.21.03.07.08.14.16.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M617.03,26.49s-.05-.04-.09-.06c.02.08.03.14-.02.15.15.11.26.17.1-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M623.66,13.25s.03.02.05.03c-.04-.04-.05-.04-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M627.88,15.18s0,.05-.02.07c.03.01.04,0,.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M616.11,27.38s.03.04,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.88,26.18s-.06-.09-.13-.17c.07.08.1.14.13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.53,24.22h0c-.06-.06-.05-.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.94,27.27s.08.06.12.07c-.03-.02-.06-.04-.12-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M616.08,27.42s-.04,0-.05-.01c.04.06.08.09.05.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M616.13,27.33s-.04.01-.07,0c.02.02.04.03.05.05,0-.01,0-.03.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.54,16.03s.02.01.03.02c-.1-.15-.09-.12-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M616.2,21.04s0,.01.01.02c0,0,0,0,.01,0l-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M616.07,20.72c.32.44.25.41.15.35l.86.91-1.01-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M619.42,17.42l-.33-.22c-.37-.54-.16-.43-.6-.77.93.99-.14.33.78,1.32l-.24-.17s-.03-.06-.01-.06c-.53-.4.62.77.38.73-.11-.04-.27-.16-.35-.3l.15.32s-.2-.17-.16-.18l-.05.19-.03-.03c.13.17.31.45.39.57-.16-.11-.08-.12-.21-.24l.16.3c-.27-.23-.45-.53-.37-.54-.99-.93.18.3-.5-.15l-.05-.18c-.57-.52-.43-.27-.83-.56.19.17.97.75,1.13,1.07-.09-.06-.15-.07,0,.17-.33-.35-.29-.23-.32-.17l-.43-.47c.07.18.3.42.47.66-.1,0-.45-.34-.75-.64-.16.01.6.52.58.71-.24-.11-.12.13.05.5-.2-.11-.26-.3-.4-.41l.3.42s-.12-.12-.17-.18c.09.18.43.47.48.66.46.53-.83-.64-.37.03-.14-.12-.26-.3-.43-.47.25.49.16.37.55.97l-.36-.24c.38.3.69.79.94,1.19.18.15.33.28.41.35l.13.35c-.08-.07-.22-.24-.38-.45.03.04.06.09.08.13-.2-.14-.43-.43-.64-.72.1.08.2.17.3.26-.24-.31-.5-.65-.76-.92.04.06.07.12.08.16-.06-.08-.12-.16-.17-.2-.05-.05.04.07.13.2l-.5-.51.19.21-.43-.21c.39.62,1.02,1.47,1.06,1.83-.31-.42-.56-.64-.98-1.1.48.45-.07-.31.1-.28-.09-.01-.28-.24-.34-.33l.26.57c-.34-.38-.28-.25-.46-.38.7.72.34.59.49.87-.23-.25-.45-.51-.32-.52-.58-.49.69.96.19.55.01-.02.06,0-.05-.12.16.26-.09.17-.27-.07v-.02c-.18.01-.33.3.22.95-.07-.08-.66-.78-.78-.91l1.7,2.32c-.47-.56-1.69-1.8-1.87-2.19-.1-.05-.21-.11-.09.13.09.06.75.75.77.82-.61-.55-.34-.28-.88-.73.13.09.86.98.79.99-.11-.13-.75-.84-.82-.95l.64.94c-.11-.18-.63-.72-.86-.93.16.16-.11.07-.06.18l.22.16c-.23-.02.93,1.29.76,1.36-.14-.19-.91-1.11-1.06-1.16.35.46,1.7,2.19,1.89,2.62l-.24-.23.16.36c-.52-.7-1.57-2.2-1.96-2.8-.22-.16-.27-.28-.32-.2-.23-.21-.27-.38-.26-.42h-.29c.45.49.32.6.7,1.02l-.29-.68c.45.5,1.16,1.52.96,1.53-.2-.18-.77-.92-.92-1.09.14.19.18.43.06.31l-.19-.31c-.23-.14.48.76-.02.34-.05,0-.65-.59-.39-.28.55.54,2.11,2.33,2.46,2.79-.04-.03-.62-.43-.9-.69-.44-.42-.87-1.14-1.25-1.5.12.14.24.33.28.4-.13-.09-.36-.44-.37-.33.44.52-.16.06.35.46.07.2-.15-.05-.2.03.31.31.92,1.19.98,1.39-.11-.13-.27-.29-.34-.37-.16.06-.43-.12-.55-.03-.12-.12-.3-.22-.47-.46.06.11.2.29.17.34-.45-.39.02-.14-.49-.63.25.3.26.49.38.72.41.45.19,0,.08-.24.55.64,1.04,1.39,1.17,1.79.04.24-.39-.38-.33-.27-.27.04.8,1.25.26.92-.41-.36-.69-.81-.96-1.1-.05-.22.34.16.38.1l-.23-.14c-.09-.16-.13-.3,0-.21-.36-.33-.36.19-.79-.04.09.16.17.34.33.49v-.09c.32.3.3.53.49.64.14.28.38.7.14.59l-.41-.46c.12.14.29.23.19.07.14.24-.66-.53-.18.12l.33.28c.14.29.48.85.28.76.42.44-.03-.07.48.43-.61-.64.21-.13-.45-.78.58.58.32.19.84.67-.13-.15-.27-.27-.15-.25-.03-.05-.08-.11-.1-.15h.01s-.02,0-.02,0c-.02-.03-.02-.03,0,0-.07-.06-.15-.13-.23-.21-.27-.38-.16-.45-.28-.66.1.04.13.19.29.34l-.18-.32c.29.34.58.49.66.76l.09-.05c.21.15.34.18.25,0,.1.04-.23-.46-.03-.16l-.06-.32.07.08c.16-.06-.23-.78.43-.28-.03-.12-.08-.26.07-.22l.27.28c-.04-.15.41.16.17-.17.74.74.4-.05.61.01l-.33-.39c.08-.03.05-.19,0-.42l-.3-.33c-.17-.34.38.09.46-.04.11.14.05.12-.04.06.79.65-.22-.79.38-.33-.08-.15-.02-.12.07-.06,0,0,0,.01,0,.02,0,0,.01,0,.02,0,.06.05.14.1.2.14-.08-.07-.15-.13-.19-.15.02-.03.01-.1-.03-.21l.33.35s0,0,0-.02c.15.1-.13-.19-.38-.45-.04-.07-.08-.16-.15-.26.54.56-.09-.27.5.32-.25-.32-.04-.37-.59-1.02.07.08.12.11.11.13.1.04.2.08.07-.13l.42.44-.47-.68c.3.24.46.38.73.77-.37-.64-.09-.29-.47-.91l.26.3s-.27-.49-.03-.26c.58.49.45-.27,1.12.07-.82-.83.44.3-.16-.37.2.19.33.28.46.49-.08-.29.45.18,0-.44.2.19.25.32.37.43-.03-.05-.13-.21,0-.09.12.11.14.19.21.29.07-.13-.49-.77-1.02-1.36.31.23.3.17-.02-.25.19.18.41.35.41.48.06,0,.48.08.05-.39.12.11.08-.01.04-.07.11-.05.15,0,.19-.13l-.09-.06c-.49-.6-.05-.19-.05-.31l.05.06c.52.27-.12-.25.46.08l-.33-.34c-.69-.77.54.33.36-.04l-.22-.17c-.2-.3,1.08.91,1.22.96.07.06.08.12.11.18.54.33-.41-.47-.42-.66.25.23.57.65.67.64.22.17-.58-.97-.05-.57-.2-.17-.39-.35-.49-.53,0-.13.85.56.34-.1.06.04.11.09.15.14-.1-.2-.09-.41-.36-.76,1.18,1.16-.26-.87.8.24l.09-.2.1.12c.16-.02-.06-.31-.28-.61.09.05.18.17.23.23.35.09.32.03-.09-.63l.36.35c-.17-.24.74.37.47-.18.04.04.1.11.14.17-.25-.56,1.32.64.12-.71l-.21-.42c-.23.02-.53-.58-.79-.74-.02-.12.51.26.51.39l-.07-.06c.63.7.39.08.84.54.22-.28.83-.15,1.1-.36l-.54-.49.11-.05c.14.1.43.38.35.41.32.26-.15-.34-.26-.46.32.1.56.65.6.63v-.09s-.06-.05-.06-.05c-.17-.25-.39-.48-.3-.52.15.06.34.3.38.3.04.04.06.05.04-.01l.15-.06-.45-.37c-.16-.25.12-.07-.39-.49.78.64.64-.13.9.05-.24-.36-.17-.42-.05-.46-.1-.06-.58-.51-.45-.52.93.97.54.29,1.28.91-.5-.4.08-.3-.65-.86.13.02.36.35.63.53-.24-.5.53-.06.57-.35-.12-.12-.34-.28-.5-.5l.72.52c-.03-.09-.7-.74-.2-.37-.11-.09-.29-.24-.31-.3.94.27.14-1.16,1.63-.38-.29-.19-.29-.24-.26-.29-.08-.03-.31-.3-.49-.46l.61.32c-.46-.48.11-.18-.33-.63l.04.12c-.49-.57-1.28-1.06-1.97-1.73.55.65-1.07-.69-.3.25-.16-.11-.2-.23-.38-.37.27.31.3.4.11.34l-.07-.08c-.09.24-.45.03-.83.03l.35.31c-.09,0-.2-.1-.3-.16.47.55.14-.09.67.51-.75-.61-.29.28-1.11-.45-.06.06.41.36.35.42l-.23-.19.26.28c-.09,0-.37-.24-.55-.41.03.01-.02-.08-.03-.1-.3-.19-.06.23-.16.17l.19.07c.03.36-.45.3-.18.88l.17.14c.17.42-.27-.07-.27.2l-.03-.04c.13.18.18.3.12.32-.15-.22-.43-.29-.59-.54.18.45.18.31.68.99l-.28-.24c.21.27.33.39.33.53-.17-.28-.44-.35-.68-.71-.72-.43.37.79-.54.02.66.79.53.28.65.47.27.21.49.6.37.57-.06.03-1.01-.85-1.11-.72.01,0-.04-.06-.02-.07-.23-.14.17.33-.19.09.41.47-.09.04.46.61l-.02-.23c.09.21.68.92.27.7-.1-.12-.22-.3-.29-.4-.19-.14.05.17-.15.02-.55-.57,0-.25-.35-.74-.27-.21.28.53-.29-.11.72.82-.21.01.3.68l-.33-.34c.04.07.17.25.14.26l-.39-.48c.31.44-.44-.21-.3.06.12-.13.43.38.73.57.29.61-.96-.79-.98-.46-.02-.07.29.12.41.31-.1-.04-.27-.12-.47-.28-.05.18.36.33.51.59-.44-.37.11.22.19.41l-.34-.34c-.35-.09.67.75.29.6l-.42-.53.06.19-.37-.41c.22.36.12.3-.05.26.25.23.6.64.55.7-.24-.17-.3-.35-.33-.22-.19-.23-.43-.53-.09-.24-.1-.12-.2-.23-.3-.35-.27-.19-.16.05-.19.08.02,0,.06,0,.11.05l.34.6c-.15-.11-.23-.23-.32-.35.01.06.15.24.14.3-.26-.29-.55-.58-.62-.76l.19.42c-.13-.11-.38-.28-.47-.4-.22-.1.37.7.07.56.05.06.09.12.11.18-.14.01-.54-.27-.27.21l-.54-.46c.04.19.68.57.74.88.07.25-.45-.4-.61-.52.2.3.62.89.15.56-.06-.12.03-.07.02-.13ZM618.7,18.52c-.05-.09-.23-.35-.02-.16.36.42.16.24.02.16ZM618.06,20.69c-.09-.13-.02-.09.13.02,0,.05-.02.05-.13-.02ZM616.15,26.84v-.02c.15.11.09.06,0,.02ZM615.93,26.75c.03.06.08.11.13.16-.07-.1-.06-.12-.01-.12-.09-.09-.16-.15-.11-.04ZM625.09,18.08l-.11-.07c-.06-.13.02-.04.11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M617.78,20.05c.06.06.12.12.18.19-.05-.07-.11-.14-.18-.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "619.81 16.69 619.82 16.69 619.76 16.62 619.81 16.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.63,22.48c.06.04.13.1.2.16-.08-.09-.15-.16-.2-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.98,27.78l-.02-.14s-.09-.03-.15-.08c.07.09.19.2.18.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M613.56,25.91c.03.05-.01.02.02.07l.15.17s-.06-.2-.16-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.89,26.6c-.27-.31-.21-.17-.2-.08,0,0,0,0,0,0,.35.45.27.27.2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.69,26.54s0,.04-.03.04c.14.18.05.02.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.99,27.05c-.09-.06.32.41.2.29.31.41-.27-.58-.2-.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "614 25.6 614.34 25.97 614.1 25.64 614 25.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.55,25.62l-.15-.05c.06.06.08.11.09.15.05-.02.16.02.06-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.49,25.71s-.04.03,0,.11c0-.01.02-.05,0-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "613.99 25.41 614.08 25.48 614.15 25.47 613.99 25.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.3,25.11l-.02-.17c-.1-.14-.19-.2-.17-.13.06.1.08.18.2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.2,24.24c.09.06.16.15.28.26l-.4-.48.12.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.31,23.96c-.1-.14-.22-.46-.28-.36.1.14.13.3.28.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "615.85 23.67 615.84 23.69 616.51 24.46 615.85 23.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.15,21.05c-.24-.11.4.49.12.32.14.2.22.13.34.31-.12-.23,0-.15-.46-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.61,21.68s.04.08.08.14c-.03-.06-.05-.1-.08-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "628.45 15.37 628.65 15.47 628.37 15.26 628.45 15.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M627.99,14.75l.48.43-.4-.43s.03.09-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M617.67,17.69l.1.12c.12.12.14.11.18.11l-.29-.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "618.68 17.41 618.65 17.42 619.08 17.82 618.68 17.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M618.72,16.34s.02.12-.02.13c-.02-.12.53.4.02-.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M609.3,20.44s.31.23.37.27c-.05-.09-.46-.33-.37-.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "608.79 19.5 608.92 19.6 608.62 19.31 608.79 19.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M609.05,19.11c-.62-.36,0,.21-.26.13l-.14-.08.46.35c-.02-.13-.27-.46-.06-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.48,19.75c-.24-.14-.17-.18-.1,0,.03.01.04.02.06.03,0-.01.01-.02.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.44,19.79c-.01.05.21.1,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.43,19.51l.17.19c.14.08.21.05.29.13-.08-.13-.22-.21-.47-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.03,19.17l.07.09c.06.03.09.04-.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.24,19.44l-.15-.18c-.1-.06-.29-.18.05.07-.17-.12-.01,0,.1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.13,19.41c-.15-.06-.26-.07-.43-.26.01.16.44.42.43.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M608.45,18.68l-.2-.07.18.17c-.09-.08.21.03.02-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.96,19.37c-.12-.09-.35-.21-.51-.31l.12.14c.1.04.21.05.4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.45,19.07l-.18-.2c-.06.04.04.11.18.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "609.37 18.72 609.77 19.12 609.38 18.7 609.37 18.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "611.13 19.15 611.4 19.38 611 19.03 611.13 19.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.18,18.97c.23.19.43.24.57.36-.02-.07-.2-.24-.37-.4.08.1.03.12-.2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.14,18.7c.05.06.14.14.24.23-.04-.05-.11-.13-.24-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.4,18.8c.08.05.29.17.39.19l-.37-.21s-.01.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.41,18.77h.01s.04-.03.05-.03c0,0-.03.01-.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.39,18.81s0,0,0,0c-.04-.02-.05-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M609.8,18.78c-.18-.17-.34-.38-.69-.51.23.19.43.26.69.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M609.93,18.54h-.12c.09.07.24.15.33.23l-.2-.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "609.84 18.43 609.93 18.54 609.97 18.54 609.84 18.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.73,18.59c-.14-.13-.13-.17-.13-.22-.09-.01-.16,0-.18.04.11.08.3.23.31.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.54,18.66s0-.01-.02-.02c-.03-.02-.04-.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.82,18.04s-.05-.03-.07-.04c.02.01.04.03.06.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.35,18.37c-.09-.02-.01.06.09.14-.02-.04-.03-.08-.02-.11-.05-.04-.08-.06-.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.03,18.5c-.08-.04-.16-.06-.23-.08.12.06.32.15.23.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.63,18.69s.01.01.01.01c.08.04.04.02-.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.63,18.69s-.12-.12-.19-.18c.02.04.05.08.09.12.03.01.07.04.1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M608.6,16.42c.33.22.58.5.19.33.21.23,1.32.9,1.96,1.25-.14-.1-.28-.19-.43-.38-.19-.1-.51-.14-.78-.39-.12-.2.16,0,.36.08-.43-.24-.53-.5-1.15-.88l.16.21c-.09-.06-.23-.19-.33-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.64,18.1l.02.05c.08,0,.22.07.51.21-.13-.15-.25-.24-.36-.32l-.13.1-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.59,18.27c-.35-.26-.46-.42-.87-.64-.03.09.26.25.39.4,0-.18.18.17.44.21.05.06.05.1.05.13.06,0,.13.02.21.04,0,0-.02,0-.02-.01h0s0,0,0,0c-.05-.02-.08-.04-.05-.03,0,0,0,0,0,0-.05-.03-.09-.06-.13-.1.1.01.1.06.13.1.02.01.03.02.05.04,0,0,0,0,0,0l-.12-.25c-.07,0-.08.03-.08.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M608.38,17.69s.06.03.09.05c-.04-.04-.07-.06-.09-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M608.63,17.78s.18.14.13.15c-.12-.05-.17-.11-.29-.19.08.08.22.23.43.29l-.04-.04c.16.03.65.27.69.31-.33-.2-.57-.34-.91-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M609.52,17.96l-.11-.22-.35-.15.19.12c-.11,0,.13.15.27.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "611.01 18.14 611.38 18.41 610.88 17.99 611.01 18.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "611.05 17.98 611.38 18.2 611.2 18.04 611.05 17.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.92,7.77l-.07-.09s.04.06.07.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.75,7.97l.16.11c-.08-.07-.15-.12-.16-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M613.17,14.69c.34.16.85.43.47.19l-.37-.23c.04.07-.01.07-.1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M612.49,11.03s-.08-.04-.12-.06c.12.09.22.18.33.26-.07-.06-.14-.13-.21-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.02,10l.27.1c-.09-.04-.18-.07-.27-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M612.32,6.33l-.35-.28c-.03.06.17.15.35.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.82,16.53c.17.06.25.06.28.05-.24-.09-.57-.26-.28-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.7,10.4c-.05-.06-.12-.12-.2-.17.05.06.11.12.2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M612.17,16.47s-.06-.02-.1-.04c.04.07.07.13.03.15.18.07.3.09.07-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M615.47,2.22s.03,0,.05.02c-.05-.03-.05-.03-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M619.95,3.38s0,.05,0,.07c.03,0,.04-.01,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.56,17.55s.04.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.04,16.74s-.09-.07-.17-.13c.09.06.14.1.17.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.1,14.7s0,0,0,0c-.08-.04-.06-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.37,17.48c.05.02.1.03.13.04-.03-.01-.07-.02-.13-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.55,17.59s-.04,0-.05,0c.06.04.1.07.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.57,17.5s-.03.02-.07.02c.03.01.05.02.06.03,0-.01,0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M614.91,5.17s.02,0,.04.02c-.13-.13-.12-.1-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M609.9,11.47s.01.01.02.01c0,0,.01,0,.02,0l-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M609.7,11.19c.42.34.35.33.23.3l1.07.66-1.3-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M612.16,7.18l-.37-.14c-.48-.44-.25-.38-.75-.62,1.13.76-.07.35,1.06,1.11l-.27-.11s-.05-.05-.03-.06c-.6-.27.77.61.54.62-.11-.02-.3-.1-.41-.21l.22.28s-.23-.12-.19-.14v.2s-.03-.02-.03-.02c.16.14.41.36.51.46-.19-.07-.11-.1-.26-.18l.22.26c-.31-.16-.56-.42-.48-.44-1.18-.68.24.25-.52-.03l-.1-.17c-.67-.38-.48-.17-.93-.35.22.12,1.12.5,1.35.77-.1-.03-.16-.03.04.17-.4-.27-.33-.16-.35-.09l-.53-.36c.11.16.39.34.61.53-.1.03-.52-.23-.88-.44-.16.05.71.36.73.56-.26-.05-.09.16.16.48-.22-.06-.32-.23-.49-.31l.39.34s-.15-.08-.21-.13c.13.16.53.36.63.53.57.41-.96-.42-.35.11-.17-.08-.32-.23-.53-.36.36.41.25.32.77.81l-.41-.15c.44.2.86.6,1.21.92.21.11.39.2.48.24l.21.3c-.1-.04-.27-.18-.48-.34.04.04.08.07.11.11-.22-.09-.52-.31-.8-.54.11.06.24.12.36.18-.31-.24-.65-.51-.96-.71.06.05.1.1.12.13-.08-.07-.16-.12-.21-.15-.06-.03.05.06.18.17l-.61-.37.23.16-.47-.1c.53.5,1.35,1.18,1.48,1.51-.41-.33-.71-.48-1.22-.82.58.32-.15-.28.02-.3-.09,0-.33-.17-.41-.23l.39.48c-.42-.28-.34-.18-.54-.25.86.52.48.48.69.72-.28-.18-.56-.39-.44-.42-.69-.33.91.76.32.49,0-.02.06,0-.08-.11.22.21-.05.19-.28,0v-.02c-.18.06-.25.38.45.87-.09-.06-.84-.58-.98-.69l2.24,1.8c-.6-.42-2.1-1.31-2.37-1.64-.11-.03-.23-.06-.06.15.1.04.91.53.95.6-.73-.37-.4-.19-1.04-.48.15.06,1.08.72,1.02.75-.14-.1-.95-.62-1.03-.7l.86.74c-.15-.14-.79-.53-1.07-.68.19.11-.09.09-.01.19l.25.09c-.23.04,1.23,1.01,1.09,1.11-.18-.14-1.17-.83-1.33-.84.46.35,2.22,1.67,2.51,2.03l-.29-.16.25.3c-.69-.53-2.1-1.7-2.64-2.18-.25-.09-.33-.2-.36-.11-.28-.14-.36-.3-.36-.33l-.28.07c.57.36.47.51.94.81l-.45-.58c.56.36,1.52,1.16,1.34,1.22-.24-.12-.98-.68-1.17-.81.18.14.29.36.15.28l-.26-.25c-.26-.07.67.61.08.34-.05,0-.78-.39-.45-.17.67.38,2.66,1.68,3.12,2.03-.05-.02-.71-.25-1.05-.43-.53-.28-1.15-.86-1.61-1.11.15.1.32.25.38.31-.15-.06-.47-.33-.44-.21.56.39-.14.1.46.35.12.17-.16,0-.19.08.38.22,1.21.9,1.32,1.07-.14-.1-.34-.21-.43-.26-.14.1-.44,0-.53.12-.15-.08-.35-.13-.58-.32.09.08.27.23.26.28-.54-.25-.02-.14-.65-.47.33.22.39.4.56.59.52.32.18-.06.01-.25.7.47,1.38,1.05,1.62,1.39.11.22-.48-.26-.4-.17-.25.11,1.12.98.51.8-.49-.23-.89-.59-1.23-.79-.11-.2.37.06.39,0l-.26-.07c-.13-.12-.21-.26-.06-.2-.44-.21-.29.27-.76.18.13.13.26.27.45.37l-.03-.09c.39.2.44.42.65.47.21.23.57.57.3.52l-.52-.32c.15.1.34.14.2.02.2.19-.78-.32-.14.16l.4.17c.22.23.71.67.49.64.53.3-.05-.06.58.28-.77-.44.16-.18-.66-.61.72.4.36.09.99.41-.17-.11-.34-.19-.21-.2-.05-.04-.11-.08-.14-.11,0,0,0,0,.02,0,0,0-.02,0-.02,0-.02-.02-.03-.02,0,0-.08-.03-.18-.08-.28-.14-.37-.29-.28-.39-.46-.55.11.01.18.14.38.24l-.26-.25c.38.24.69.31.85.54l.07-.07c.24.09.37.08.24-.07.11.01-.35-.37-.08-.15l-.15-.28.09.06c.13-.1-.45-.67.33-.37-.07-.11-.15-.23,0-.23l.33.2c-.08-.13.43.05.11-.2.91.52.37-.14.59-.14l-.42-.28c.07-.05,0-.2-.12-.39l-.38-.24c-.26-.27.39,0,.43-.15.14.1.08.11-.02.07.93.42-.42-.69.27-.41-.12-.12-.05-.11.05-.07,0,0,0,.01.01.02,0,0,.01,0,.01,0,.07.03.16.06.23.09-.1-.05-.18-.08-.22-.1,0-.03-.01-.1-.09-.19l.41.25s0,0,0-.02c.17.06-.17-.15-.49-.33-.05-.06-.12-.13-.21-.21.67.4-.16-.24.56.18-.32-.25-.14-.34-.83-.83.09.06.14.08.14.1.11.01.21.03.04-.14l.52.32-.63-.54c.35.15.54.25.9.56-.52-.52-.16-.25-.69-.75l.33.22s-.39-.4-.1-.24c.68.33.36-.36,1.09-.19-1-.6.5.19-.24-.32.24.14.39.19.56.36-.15-.26.48.07-.11-.42.24.14.32.25.47.33-.04-.04-.18-.17-.03-.09.14.08.18.14.27.23.04-.14-.66-.62-1.32-1.07.35.15.33.09-.08-.24.23.12.48.24.51.36.06-.02.48-.03-.05-.39.14.08.08-.03.02-.08.09-.07.14-.04.15-.17l-.1-.03c-.62-.46-.1-.17-.13-.29l.06.05c.57.15-.18-.22.46-.03l-.41-.26c-.85-.58.6.19.33-.12l-.25-.12c-.26-.25,1.26.63,1.4.65.08.04.11.1.15.15.6.2-.51-.36-.57-.54.29.17.7.5.8.47.25.12-.79-.8-.19-.53-.23-.12-.46-.25-.59-.4-.03-.12.95.35.31-.16.07.03.12.06.18.1-.14-.17-.18-.37-.53-.65,1.41.86-.45-.78.82.06l.04-.21.13.09c.15-.05-.13-.29-.41-.53.1.03.21.13.28.18.36.02.32-.04-.23-.59l.42.26c-.22-.19.8.2.41-.27.05.03.12.09.17.14-.37-.49,1.42.35-.05-.71l-.3-.36c-.21.07-.64-.45-.93-.56-.05-.12.55.15.58.27l-.08-.04c.77.55.4,0,.93.36.15-.31.77-.31.98-.55l-.63-.37.1-.07c.16.07.5.28.43.33.37.19-.22-.3-.35-.39.33.03.68.52.72.49v-.08s-.09-.04-.09-.04c-.22-.21-.48-.39-.4-.45.16.03.39.22.43.22.04.03.07.04.04-.02l.13-.08-.51-.27c-.2-.21.1-.09-.48-.4.89.48.59-.24.89-.12-.3-.31-.25-.37-.15-.44-.11-.04-.67-.39-.55-.42,1.1.77.58.18,1.42.65-.57-.3.01-.31-.8-.72.13,0,.42.27.72.4-.33-.44.51-.15.49-.44-.14-.1-.39-.22-.58-.4l.8.38c-.05-.08-.82-.59-.27-.33-.13-.07-.33-.18-.36-.24.96.1-.08-1.15,1.51-.64-.32-.14-.32-.19-.31-.24-.08-.02-.36-.24-.56-.37l.66.21c-.53-.39.07-.19-.44-.56l.06.11c-.58-.48-1.45-.82-2.24-1.36.66.54-1.18-.5-.25.3-.18-.08-.24-.19-.44-.3.32.26.37.34.17.31l-.08-.06c-.05.25-.44.11-.81.18l.41.25c-.08.01-.21-.06-.33-.1.56.45.12-.11.75.38-.85-.47-.23.32-1.17-.24-.05.07.47.28.42.35l-.26-.14.31.23c-.08.01-.41-.17-.62-.3.03,0-.04-.07-.05-.1-.33-.13-.02.24-.12.2l.2.03c.1.35-.38.38,0,.9l.2.11c.25.37-.28-.02-.23.25l-.04-.04c.16.15.23.26.18.29-.19-.19-.47-.2-.68-.42.27.4.24.27.86.83l-.33-.18c.26.22.4.32.43.45-.22-.24-.51-.26-.81-.57-.79-.28.52.7-.52.12.8.64.57.17.73.33.3.15.6.49.48.48-.05.04-1.16-.63-1.23-.49.01-.01-.05-.05-.04-.07-.25-.09.23.29-.17.12.49.38-.08.06.57.51l-.07-.23c.13.18.86.76.4.63-.13-.1-.28-.25-.36-.34-.22-.1.09.15-.14.05-.65-.45-.04-.25-.5-.65-.3-.15.38.46-.31-.05.87.66-.2.06.43.61l-.39-.27c.05.06.22.21.19.23l-.48-.39c.39.36-.48-.11-.29.12.09-.16.5.28.83.41.41.53-1.1-.58-1.05-.25-.04-.06.31.05.46.22-.11-.01-.29-.06-.52-.18,0,.19.42.25.63.47-.51-.27.15.2.27.36l-.4-.27c-.36-.02.81.6.41.53l-.52-.43.1.17-.45-.32c.29.3.18.27,0,.26.3.17.72.49.69.57-.27-.11-.37-.28-.37-.14-.24-.19-.54-.42-.14-.22-.13-.09-.24-.19-.36-.28-.31-.13-.15.08-.17.12.02,0,.06,0,.12.02l.46.51c-.17-.08-.28-.18-.38-.27.02.06.2.2.2.26-.32-.23-.66-.45-.77-.61l.27.37c-.15-.08-.44-.19-.55-.29-.24-.05.51.6.19.53.06.05.11.1.15.15-.14.04-.59-.14-.22.27l-.63-.33c.08.17.79.4.92.69.12.23-.53-.29-.71-.37.26.25.81.73.27.51-.09-.1.01-.07-.01-.13ZM611.72,8.41c-.07-.08-.3-.29-.06-.15.45.33.21.2.06.15ZM611.62,10.67c-.12-.1-.04-.08.13,0,.02.04,0,.05-.13,0ZM611.44,17.02s-.01,0-.02-.02c.19.06.11.03.02.02ZM611.2,17s.11.08.16.12c-.1-.07-.09-.1-.05-.11-.11-.06-.19-.1-.12-.01ZM617.82,6.66l-.12-.05c-.09-.12,0-.04.12.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.19,10.12c.07.04.15.09.22.14-.06-.05-.14-.1-.22-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M612.38,6.38s0,0,0,0c-.02-.02-.05-.03-.07-.05l.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M608.77,13.27c.07.02.15.06.23.1-.1-.07-.19-.11-.23-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.55,17.96l-.06-.13s-.09,0-.17-.03c.09.06.24.14.23.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M608.71,16.84s0,.02.04.06l.19.12s-.12-.17-.23-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.18,17.13c-.34-.22-.25-.1-.22-.02,0,0,0,0,0,0,.47.33.34.18.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M609.97,17.13s0,.04-.02.04c.19.13.05.01.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.35,17.27c-.1-.04.42.3.28.22.42.31-.43-.48-.28-.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "609.04 16.43 609.47 16.69 609.15 16.44 609.04 16.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M609.57,16.29h-.16c.07.04.11.07.13.1.04-.03.16-.02.03-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M609.54,16.4s-.03.04.03.1c0-.01,0-.05-.03-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "608.98 16.25 609.08 16.29 609.14 16.26 608.98 16.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.14,15.61l-.07-.15c-.14-.1-.24-.14-.2-.07.09.08.13.15.27.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M608.84,15.08c.1.04.19.1.34.18l-.52-.34.18.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M608.87,14.78c-.14-.1-.34-.38-.37-.27.14.1.21.26.37.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "610.27 14.09 610.26 14.12 611.11 14.68 610.27 14.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M608.89,11.76c-.26-.05.51.37.2.28.19.15.25.07.41.21-.18-.19-.04-.14-.61-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M609.5,12.25s.06.07.11.11c-.04-.05-.08-.08-.11-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "620.55 3.47 620.76 3.53 620.45 3.38 620.55 3.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M619.99,2.94l.55.34-.47-.36s.05.08-.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M610.52,7.85l.13.09c.15.08.17.08.21.07l-.33-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "611.44 7.35 611.42 7.35 611.92 7.65 611.44 7.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M611.24,6.29s.05.12.01.13c-.05-.12.6.27-.01-.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.59,53.91s.14-.35.17-.42c-.05.08-.21.53-.17.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "631.06 54.73 631.13 54.57 630.95 54.95 631.06 54.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.89,54.66c-.23.67.1-.08.05.17l-.05.15.22-.53c-.07.07-.25.41-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.34,53.18c-.09.26-.1.22,0,.09,0-.03.01-.05.02-.07,0,0-.01,0-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.35,53.2s.07-.22,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.21,53.32l.11-.22c.05-.16.04-.2.09-.31-.07.12-.12.27-.2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631,53.79l.05-.09c.02-.07.03-.09-.05.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.16,53.5l-.1.2c-.04.11-.12.33.04-.07-.08.2,0,0,.06-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.13,53.61c-.04.15-.06.25-.17.47.08-.07.25-.55.17-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.62,55.34l-.05.2.1-.22c-.05.11.03-.19-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.18,52.91c-.05.14-.13.38-.2.56l.08-.16c.03-.1.04-.2.12-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.98,53.48l-.12.23s.06-.08.12-.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "630.72 54.53 630.96 54.04 630.71 54.54 630.72 54.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "631.09 52.86 631.23 52.53 631.01 53.02 631.09 52.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631,52.89c.11-.27.16-.47.23-.63-.04.04-.14.27-.23.48.06-.11.06-.08,0,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.86,53.03c.03-.06.08-.18.14-.3-.03.06-.07.15-.14.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.85,53.62c.03-.09.11-.31.13-.41l-.14.4s0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.83,53.63h0s-.01-.04-.01-.04c0,0,0,.02.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.85,53.63s0,0,0,0c-.01.04-.02.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.78,54.15c-.1.22-.22.45-.32.8.11-.27.17-.47.32-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.67,54.13v.1c.03-.11.09-.26.14-.37l-.14.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "630.61 54.25 630.67 54.13 630.68 54.09 630.61 54.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.77,53.42c-.08.17-.1.18-.12.2-.01.08-.01.13,0,.14.05-.12.14-.35.12-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.79,53.56s0,.01-.01.02c-.01.03-.01.05.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.49,53.56s-.02.05-.02.07c0-.02.02-.05.03-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.62,53.84c-.02.08.03-.01.08-.13-.02.04-.04.06-.06.06-.02.06-.04.09-.03.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.75,53.2c-.02.09-.04.16-.06.23.04-.13.1-.33.06-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.81,53.47s0-.01,0-.02c.03-.09.01-.05,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.81,53.47c-.03.06-.07.15-.11.24.02-.03.04-.07.07-.13,0-.03.02-.07.04-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.49,56.12c.14-.37.3-.7.18-.29.13-.27.57-1.49.8-2.19-.06.16-.12.31-.23.52-.07.21-.11.5-.26.82-.11.18.02-.14.07-.35-.16.47-.3.66-.55,1.34l.12-.23c-.04.11-.11.27-.14.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.51,53.7l.03-.04c.01-.07.06-.22.15-.52-.09.17-.14.31-.19.43l.04.07-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.59,53.67c-.16.4-.25.56-.4,1,.04-.02.15-.33.24-.5-.09.08.1-.22.15-.46.04-.06.05-.08.07-.1,0-.05.02-.12.04-.2,0,0,0,.02,0,.03h0s0,0,0,0c-.02.05-.03.08-.02.05,0,0,0,0,0,0-.02.06-.04.1-.06.15.02-.09.04-.11.06-.15,0-.02.02-.04.02-.06,0,0,0,0,0,0l-.14.2c0,.06,0,.05.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.11,55.8s.02-.06.03-.09c-.02.05-.04.08-.03.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.18,55.55c.03-.06.09-.22.09-.17-.03.13-.07.19-.12.33.05-.1.14-.28.18-.48l-.02.05c.03-.15.19-.66.21-.72-.13.37-.22.63-.34.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.35,54.71l-.12.18-.11.36.08-.21c0,.09.09-.17.15-.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "630.56 53.36 630.73 52.94 630.48 53.53 630.56 53.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "630.49 53.39 630.63 53.02 630.53 53.24 630.49 53.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M625.38,56.72l-.05.1s.04-.06.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M625.47,56.79l.07-.18c-.04.1-.07.17-.07.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629,52.88c.11-.35.29-.9.13-.48l-.15.41c.04-.07.03-.02.01.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M627.08,54.93s-.03.08-.04.13c.06-.14.11-.26.16-.38-.04.08-.08.17-.12.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M626.44,56.61l.07-.27c-.03.09-.05.18-.07.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M624.68,56.95l-.17.41s.09-.21.17-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.82,53.31c.04-.17.05-.24.05-.26-.07.24-.18.6-.05.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M627.03,52.43c-.04.07-.07.15-.1.24.03-.07.07-.14.1-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.81,53.03s-.02.06-.03.1c.04-.06.07-.11.08-.08.05-.18.07-.29-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M622.87,55.89s0-.03.01-.05c-.02.05-.02.06-.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M623.83,51.58s.02-.02.03-.02c0-.03,0-.03-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.31,53.12s.02-.04,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.77,54.75s-.04.1-.08.2c.04-.1.06-.16.08-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M628.74,55.51s0,0,0,0c-.03.08-.02.07,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.26,53.32c.01-.05.02-.1.03-.13,0,.03-.02.07-.03.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.33,53.12s0,.03,0,.04c.03-.07.04-.11,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.28,53.14s0,.02,0,.05c0-.03.02-.05.02-.06,0,0-.01.01-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M624.31,55.19s0-.02.01-.04c-.08.16-.06.14-.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M627.09,56.98s0-.01,0-.02c0,0,0-.01,0-.02v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M626.93,57.26c.21-.5.2-.43.17-.32l.42-1.18-.59,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M625.1,56.75l-.1.38c-.26.59-.21.37-.38.89.48-1.27.17-.08.65-1.35l-.08.28s-.03.06-.03.05c-.19.62.37-.91.36-.71-.02.1-.07.29-.14.44l.16-.3s-.08.25-.09.22l.1-.08v.04c.07-.2.2-.5.26-.62-.05.19-.06.13-.11.29l.15-.3c-.11.33-.26.64-.26.59-.44,1.28.15-.31-.06.46l-.09.15c-.25.73-.13.48-.26.94.08-.24.35-1.16.51-1.46-.03.1-.03.15.09-.1-.17.45-.11.35-.07.33l-.23.6c.09-.16.2-.47.32-.73,0,.07-.16.54-.3.93.01.11.25-.76.34-.85-.05.24.07,0,.26-.33-.05.22-.14.36-.2.54l.2-.47s-.06.16-.08.23c.09-.18.23-.6.32-.75.26-.66-.29.99.03.26-.05.17-.14.37-.23.6.24-.47.18-.34.47-.98l-.11.41c.14-.46.38-.98.57-1.4.07-.22.13-.41.16-.51l.17-.3c-.03.1-.11.3-.21.55.02-.05.04-.1.06-.14-.06.23-.2.57-.34.9.04-.12.08-.25.12-.38-.15.36-.31.76-.44,1.11.03-.07.06-.12.08-.16-.04.1-.08.19-.1.25-.02.06.03-.07.1-.22l-.24.67.1-.26-.09.44c.3-.65.71-1.63.89-1.88-.2.48-.3.8-.52,1.38.21-.62-.16.24-.15.1,0,.07-.11.35-.15.44l.28-.53c-.18.47-.12.36-.17.56.34-.94.29-.6.42-.88-.12.32-.24.63-.25.55-.23.72.46-1.08.28-.47-.01,0,0-.05-.06.11.12-.27.09-.03-.02.24h-.01c.01.14.17.07.48-.72-.04.1-.37.96-.43,1.12l1.1-2.64c-.26.68-.84,2.32-1.03,2.69-.02.1-.05.22.07,0,.03-.1.35-1,.38-1.06-.25.77-.13.42-.33,1.08.04-.15.46-1.22.47-1.18-.06.16-.39,1.06-.44,1.17l.45-1.03c-.08.18-.34.89-.44,1.19.07-.21.04.04.09-.06l.07-.25c0,.18.61-1.46.65-1.38-.09.22-.52,1.33-.54,1.48.22-.53,1.03-2.57,1.24-2.97l-.11.31.17-.34c-.33.8-1.04,2.48-1.33,3.13-.07.25-.13.37-.09.35-.1.29-.18.43-.2.44v.22c.24-.63.31-.61.5-1.13l-.33.62c.23-.63.72-1.77.73-1.64-.08.26-.43,1.12-.51,1.33.09-.21.21-.39.16-.24l-.15.33c-.06.25.36-.82.18-.2,0,.04-.26.83-.12.45.25-.73,1.08-2.95,1.29-3.48-.01.05-.19.71-.31,1.07-.19.57-.53,1.33-.7,1.82.07-.17.16-.38.19-.45-.04.15-.21.53-.15.46.24-.64.04.08.22-.53.1-.17-.02.14.03.13.14-.42.56-1.39.65-1.56-.06.16-.13.38-.17.47.04.08-.04.38.02.41-.05.16-.1.35-.21.62.05-.11.14-.32.16-.33-.17.56-.07.07-.29.74.14-.37.24-.5.35-.72.21-.58-.02-.13-.13.09.3-.79.65-1.6.84-1.95.12-.18-.17.52-.12.41.04.17.59-1.35.45-.76-.16.51-.37,1-.5,1.37-.11.18.06-.34.03-.33l-.06.25c-.07.16-.15.28-.11.13-.15.46.11.14.02.58.08-.16.16-.33.23-.54l-.05.06c.13-.41.25-.55.29-.75.14-.27.33-.71.29-.47l-.21.58c.06-.17.1-.35.03-.18.11-.25-.23.8.07.06l.12-.41c.14-.28.4-.87.37-.68.2-.57-.03.06.19-.61-.29.83-.08-.07-.37.81.26-.78.08-.34.29-1.01-.07.19-.12.37-.12.26-.02.05-.05.12-.07.16,0,0,0,0,0-.01,0,0,0,.02,0,.02-.01.03-.01.03,0,0-.02.09-.06.19-.09.29-.18.43-.22.4-.32.62.02-.1.09-.21.15-.42l-.15.33c.16-.42.21-.72.35-.95l-.03-.03c.07-.24.07-.35-.01-.18.02-.1-.22.45-.08.12l-.16.24.04-.11c-.04-.07-.38.65-.16-.13-.06.1-.13.22-.12.09l.13-.37c-.07.12.06-.39-.09-.02.34-.99-.04-.26-.02-.45l-.18.47s-.1.09-.21.26l-.15.42c-.16.33.03-.33-.04-.31.06-.16.06-.11.03-.01.29-.97-.39.64-.18-.07-.07.15-.06.09-.03-.02,0,0,0,0,.01-.02,0,0,0,0,0,0,.02-.07.05-.16.06-.23-.03.1-.06.19-.07.23-.01,0-.05.05-.1.15l.16-.45s0,0,0,.01c.05-.17-.09.21-.21.55-.04.07-.08.16-.12.26.26-.73-.13.23.14-.55-.15.37-.19.25-.49,1.05.04-.1.05-.16.06-.16.02-.1.03-.19-.07.02l.21-.58-.33.76c.11-.36.17-.56.36-1-.31.66-.14.24-.44.89l.14-.37s-.24.49-.13.18c.23-.72-.15-.17,0-.86-.39,1.1.14-.51-.18.34.09-.26.13-.41.23-.63-.15.23.08-.44-.22.26.09-.26.15-.37.2-.53-.02.05-.1.22-.05.06.05-.16.09-.21.14-.32-.07.02-.37.82-.65,1.56.11-.36.07-.32-.13.16.08-.25.16-.51.23-.58,0-.04.02-.4-.2.2.05-.15,0-.05-.04.01-.03-.05-.01-.11-.07-.06l-.03.1c-.29.72-.09.15-.16.22l.03-.07c.12-.55-.12.24.03-.38l-.16.45c-.37.96.15-.59-.03-.24l-.08.26c-.15.32.43-1.34.45-1.47.03-.09.06-.13.09-.19.15-.59-.23.59-.32.71.11-.32.31-.8.3-.87.08-.26-.47,1-.29.37-.08.25-.16.5-.25.67-.06.08.26-.96-.06-.2.02-.07.04-.13.07-.19-.1.19-.2.3-.37.71.56-1.56-.43.7.1-.73l-.1.05.06-.15c-.01-.11-.16.22-.3.56.03-.1.08-.23.11-.31.04-.31,0-.26-.32.43l.17-.47c-.12.26.17-.77-.1-.25.02-.05.06-.14.09-.21-.28.52.3-1.36-.36.32l-.21.4c.02.16-.28.73-.36,1.02-.06.09.12-.53.19-.61l-.03.09c.34-.88.04-.34.26-.94-.15,0-.09-.54-.2-.62l-.24.69-.03-.06c.05-.16.19-.54.21-.5.13-.39-.17.31-.23.46.04-.3.32-.79.31-.81l-.04.04-.02.08c-.12.27-.24.57-.26.52.03-.15.15-.43.15-.46.02-.05.02-.07,0-.02l-.03-.08-.18.55c-.12.26-.04-.05-.24.57.32-.96-.07-.41.02-.72-.18.38-.21.36-.23.3-.03.12-.25.73-.26.64.48-1.25.14-.57.45-1.48-.2.61-.15.11-.43.98,0-.11.17-.47.26-.77-.25.46-.03-.37-.18-.24-.06.16-.14.42-.25.66l.26-.84c-.05.07-.37.95-.19.36-.05.14-.12.35-.15.4.13-.87-.59.53-.2-1.04-.1.33-.12.35-.15.36-.02.08-.15.41-.23.63l.16-.65c-.24.61-.09.01-.32.6l.06-.1c-.29.69-.54,1.57-.88,2.46.33-.78-.35,1.21.13.09-.06.19-.12.29-.19.5.16-.38.2-.45.17-.27l-.04.09c.12-.06.02.33.02.62l.16-.45c0,.07-.05.21-.08.32.28-.66-.05-.06.25-.79-.31.91.14.07-.22,1.1.03.02.18-.52.21-.5l-.1.28.14-.35c0,.07-.12.42-.21.65,0-.03-.04.06-.05.08-.09.34.12-.08.09.03l.03-.18c.19-.23.16.18.46-.35l.07-.21c.21-.36-.03.25.11.1l-.02.05c.09-.2.15-.3.16-.27-.11.24-.14.49-.27.75.23-.39.16-.31.5-1.07l-.12.35c.13-.31.2-.47.27-.55-.14.29-.18.54-.36.92-.21.79.4-.72.02.4.39-.95.13-.56.23-.76.1-.32.3-.71.29-.6.02.03-.42,1.25-.35,1.25,0,0-.03.07-.04.06-.07.25.17-.32.05.09.23-.58.02.05.31-.69l-.12.15c.1-.18.46-1.04.35-.6-.06.15-.15.34-.2.44-.07.22.08-.13.02.1-.28.74-.13.14-.37.69-.1.32.27-.51-.05.28.41-1.01.01.15.34-.61l-.17.44c.03-.07.12-.27.13-.26l-.24.57c.22-.48-.1.45.04.2-.07-.01.19-.54.28-.88.31-.56-.39,1.18-.22,1-.04.06.05-.28.15-.48-.02.1-.06.28-.13.51.1-.07.16-.46.29-.72-.18.55.11-.21.2-.37l-.17.45c-.04.32.37-.93.3-.56l-.26.62.09-.15-.2.51c.18-.37.15-.27.13-.11.11-.32.31-.82.35-.82-.08.28-.17.43-.1.38-.12.28-.26.63-.12.21-.06.15-.12.28-.17.42-.09.32.03.09.05.09,0-.02,0-.05.02-.11l.3-.6c-.05.17-.11.31-.17.44.03-.04.12-.25.15-.28-.14.37-.28.75-.37.91l.21-.38c-.06.16-.13.45-.19.58-.05.23.35-.68.29-.38.03-.07.06-.14.09-.19.01.1-.12.56.12.08l-.22.67c.09-.13.27-.84.43-1.07.12-.19-.19.57-.25.76.15-.32.44-.98.28-.43-.06.12-.03.02-.07.06ZM625.69,56.64c-.04.09-.17.38-.08.11.2-.51.12-.26.08-.11ZM626.83,55.82c-.06.15-.05.07,0-.11.02-.03.03-.01,0,.11ZM630.03,53.44s0,.01,0,.02c.05-.18.03-.11,0-.02ZM630,53.65c.03-.06.05-.12.07-.19-.05.11-.06.12-.06.08-.04.12-.07.2-.02.11ZM625.32,52.1l-.04.12c-.07.12-.02,0,.04-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M626.51,56.41c.03-.08.06-.16.09-.25-.03.07-.06.16-.09.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M624.72,56.88s0,0,0,0c-.01.03-.02.05-.03.08l.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M627.9,57.23c.02-.07.04-.15.07-.24-.04.11-.07.21-.07.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.52,52.97l-.07.11s-.01.08-.03.16c.04-.11.09-.26.1-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.71,55.85c.02-.05.01,0,.04-.06l.08-.21s-.1.17-.11.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.98,54.48c-.14.38-.07.26-.03.2,0,0,0,0,0,0,.2-.53.12-.36.03-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.96,54.66s.02-.02.02,0c.08-.21,0-.05-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M630.15,53.42c-.03.1.19-.48.13-.33.19-.48-.28.56-.13.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "629.53 55.74 629.7 55.27 629.55 55.64 629.53 55.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.51,55.34l-.02.14c.03-.08.05-.12.07-.16-.01-.02,0-.12-.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.56,55.32s.02,0,.05-.07c0,0-.02.01-.05.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "629.43 55.86 629.46 55.76 629.45 55.72 629.43 55.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M629.21,55.12l-.08.12c-.06.16-.09.26-.05.2.05-.11.09-.17.14-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M628.83,56.44c.03-.1.07-.21.12-.36l-.22.58.1-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M628.68,56.54c-.06.16-.22.44-.17.42.06-.16.15-.28.17-.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "628.45 55.62 628.46 55.61 628.82 54.66 628.45 55.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M627.15,57.73c-.05.24.23-.58.16-.29.09-.22.06-.24.14-.44-.11.23-.08.09-.3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M627.45,57.01s.04-.08.07-.14c-.03.06-.05.1-.07.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "623.93 51.03 623.98 50.82 623.88 51.15 623.93 51.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M623.62,51.72l.22-.61-.22.54s.05-.07,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M625.3,57.89l.06-.15c.06-.16.05-.17.05-.2l-.11.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "625.13 57.31 625.13 57.32 625.32 56.77 625.13 57.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M624.57,57.9s.06-.09.07-.06c-.06.09.19-.62-.07.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.34,11.67s.38-.01.46-.01c-.09-.01-.57.02-.46.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "605.38 11.52 605.55 11.52 605.13 11.5 605.38 11.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M605.38,11.33c-.71.04.12.06-.13.11h-.16s.57,0,.57,0c-.09-.04-.48-.07-.28-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.92,11.18c-.28.02-.24-.01-.09.02.03,0,.05,0,.07,0,0,0,0,0,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.9,11.2s.23-.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.74,11.12l.25.02c.16-.01.2-.03.32-.03-.14-.02-.3-.01-.57.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.22,11.11h.11c.07,0,.09,0-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.54,11.14l-.22-.02c-.12,0-.35.02.08.01-.21,0,0,0,.14.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.44,11.16c-.15.02-.25.04-.5.02.1.04.6.02.5-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M604.64,11.35l-.21.03h.24c-.12,0,.19-.04-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M607.1,10.96c-.15,0-.4.02-.6.03h.17c.1,0,.2-.02.42-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.51,10.98l-.26-.02s.09.03.26.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "605.42 11.13 605.97 11.16 605.42 11.13 605.42 11.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "607.12 10.86 607.47 10.86 606.94 10.85 607.12 10.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M607.06,10.79c.29,0,.49-.03.67-.02-.05-.02-.3-.03-.53-.04.13.01.09.03-.14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.87,10.72c.07,0,.2.01.33.02-.07,0-.16,0-.33-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.32,10.92c.09,0,.33-.01.43-.03l-.43.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.31,10.9h.01s.02-.02.02-.02c0,0-.01,0-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.32,10.92h0s-.06,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M605.81,11.05c-.24,0-.5-.04-.86,0,.29,0,.5-.02.86,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M605.78,10.94l-.1.03c.11,0,.28-.01.4,0l-.3-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "605.65 10.93 605.78 10.94 605.82 10.93 605.65 10.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.47,10.77c-.19,0-.2-.02-.23-.04-.08.02-.13.04-.13.05.13,0,.38,0,.36-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.36,10.84h-.02s-.05,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.24,10.58s-.05,0-.08,0h.07s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.03,10.79c-.08.01.02.02.15.02-.04,0-.07-.02-.08-.03-.06,0-.1,0-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.67,10.68c-.09,0-.16.02-.23.03.14,0,.35-.03.23-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.45,10.83s.02,0,.02,0c.09,0,.05,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.45,10.83c-.06,0-.17,0-.26-.01.03,0,.08.01.14.02.03,0,.08,0,.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M603.5,10.57c.4,0,.76.03.34.06.3.03,1.6-.01,2.33-.05-.17,0-.33,0-.57-.02-.22.01-.51.07-.86.05-.2-.04.14-.03.35-.06-.49.02-.72-.04-1.44-.03l.26.03c-.11,0-.29,0-.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.12,10.64h.05c.07,0,.23-.02.54-.04-.19-.02-.34-.02-.47-.02l-.05.06h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.18,10.71c-.43,0-.61-.03-1.08,0,.03.04.36.02.55.04-.11-.06.24.01.48-.03.07,0,.1.02.11.03.05,0,.12-.02.2-.03h-.03s0,0,0,0h0c-.05,0-.09,0-.06,0,0,0,0,0,0,0h-.16c.09-.02.11,0,.16,0h.06s0,0,0,0l-.24-.05c-.06.01-.05.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M604.02,11.05s.07,0,.1,0c-.05,0-.09,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M604.28,11.02c.06,0,.23,0,.19.02-.13.02-.21,0-.35,0,.11,0,.31.02.52-.01h-.06c.15-.03.68-.07.74-.07-.39.02-.66.04-1.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M605.12,10.86l-.21-.04-.37.03h.22c-.09.02.19.01.36.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "606.46 10.57 606.91 10.57 606.27 10.56 606.46 10.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "606.4 10.51 606.8 10.51 606.56 10.5 606.4 10.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M601.68,6.58l-.11-.03s.07.02.11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M601.64,6.7l.19.02c-.11-.02-.18-.03-.19-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.38,9.02c.37,0,.94,0,.5-.02h-.43c.08,0,.03.01-.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M603.85,7.81s-.09,0-.13,0c.15.02.28.03.41.04-.09-.01-.18-.03-.28-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M602.06,7.66h.28c-.1,0-.19,0-.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M601.29,5.9l-.44-.07s.22.04.44.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.24,9.89c.17-.02.24-.03.26-.04-.25.02-.62.03-.26.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.25,7.1c-.08-.02-.16-.03-.26-.04.07.02.15.03.26.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.5,9.8s-.07,0-.1,0c.07.01.13.03.1.04.19-.01.3-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M602,3.67s.03,0,.05,0c-.06-.01-.06,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.42,3.91s.02.02.03.03c.03,0,.03,0-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.59,10.27s.05,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M604.87,10.34s-.11,0-.21,0c.1,0,.17,0,.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M603.8,9.63h0c-.09,0-.07,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.39,10.29c.05,0,.1-.01.13-.02-.03,0-.08,0-.13.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.6,10.29s-.03,0-.04.01c.07,0,.12,0,.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.57,10.25s-.01.01-.04.02c.03,0,.05,0,.07,0,0,0-.02,0-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M602.94,5.06s.02,0,.04,0c-.18-.04-.15-.03-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M601.89,8.46s.02,0,.02,0h.02s-.04,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M601.57,8.39c.54.05.47.06.36.07l1.25.05-1.61-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M601.58,6.29h-.39c-.63-.12-.41-.13-.96-.16,1.35.16.12.17,1.47.32h-.29s-.07-.02-.05-.03c-.65-.02.97.14.77.18-.11.01-.3,0-.46-.03l.33.08s-.26-.02-.23-.03l.1.08h-.04c.21.03.54.09.67.11-.2,0-.14-.02-.31-.04l.32.07c-.35-.02-.69-.08-.64-.11-1.35-.1.34.07-.46.07l-.17-.06c-.77-.05-.49,0-.98,0,.25.01,1.21.03,1.55.1-.1,0-.15.01.12.06-.48-.04-.36-.01-.34.02l-.64-.06c.18.05.51.08.79.12-.07.03-.56,0-.98-.04-.11.05.79.03.91.11-.25.03,0,.08.39.17-.22.01-.39-.04-.57-.04l.51.07s-.17,0-.25-.02c.19.04.64.06.81.11.7.07-1.03,0-.24.1-.18,0-.39-.04-.64-.05.52.11.38.09,1.08.19h-.42c.48.02,1.05.1,1.51.17.23,0,.44.01.53.01l.34.08c-.11,0-.32-.02-.59-.05.05,0,.1.01.15.02-.24,0-.6-.03-.96-.07.13,0,.26,0,.4,0-.39-.04-.81-.09-1.19-.11.07,0,.14.02.17.03-.11,0-.2-.02-.26-.02-.07,0,.07.01.24.04l-.71-.04.28.02-.45.05c.71.11,1.76.22,2.05.33-.52-.05-.85-.06-1.47-.1.66.02-.27-.09-.14-.12-.07.02-.36,0-.47-.02l.59.12c-.51-.03-.38,0-.59,0,1,.05.66.1.97.15-.34-.02-.68-.05-.59-.08-.76,0,1.17.13.53.13,0,0,.04-.01-.13-.03.3.04.06.08-.23.05h0c-.12.05-.02.19.83.24-.11,0-1.02-.06-1.19-.08l2.85.26c-.73-.05-2.47-.09-2.88-.17-.1.01-.23.02.03.07.1,0,1.06.03,1.12.04-.81,0-.44,0-1.13.02.16,0,1.3.06,1.26.08-.17,0-1.13-.06-1.25-.06l1.12.11c-.2-.02-.95-.04-1.27-.04.22,0-.02.05.09.08l.26-.02c-.17.06,1.58.13,1.52.2-.23-.02-1.43-.08-1.57-.05.57.04,2.77.17,3.21.24h-.33l.37.06c-.87-.05-2.68-.2-3.39-.27-.26.02-.39,0-.36.03-.31,0-.47-.04-.48-.05l-.2.09c.67.02.67.09,1.23.11l-.69-.12c.67.02,1.9.12,1.78.18-.27,0-1.2-.05-1.42-.06.23.02.44.08.28.08l-.36-.04c-.25.03.89.09.25.11-.04.01-.87.02-.47.04.77,0,3.14.05,3.72.08-.05,0-.73.05-1.11.06-.6.01-1.43-.07-1.95-.06.18,0,.41.02.48.03-.16.01-.57-.02-.49.02.68.02-.06.07.58.03.19.04-.14.03-.11.07.44,0,1.5.06,1.69.1h-.5c-.06.06-.37.1-.38.16-.17,0-.37.03-.66.02.12.01.35.02.37.04-.59.03-.09-.04-.8-.02.4,0,.55.06.79.09.61,0,.12-.06-.13-.09.84,0,1.73.07,2.12.13.21.05-.55.02-.43.03-.15.09,1.47.09.86.16-.54.03-1.07,0-1.46,0-.2-.04.34-.06.32-.09l-.25.03c-.18-.01-.31-.04-.16-.06-.48.02-.09.16-.54.23.18.01.37.03.58.02l-.08-.02c.43-.02.6.04.8.01.3.03.78.06.54.1h-.61c.18,0,.37-.02.18-.03.27.02-.83.07-.03.08l.42-.03c.31.03.96.06.77.1.61-.02-.07,0,.64-.04-.88.03.04-.09-.89-.05.82-.03.35-.05,1.05-.09-.2,0-.39.01-.29-.02-.06,0-.13,0-.18,0h.02s-.02,0-.02,0c-.03,0-.04,0,0,0-.09,0-.19.01-.31.02-.46-.01-.45-.06-.69-.08.1-.02.23,0,.45,0l-.36-.02c.45,0,.75-.05,1.01,0l.02-.04c.25-.02.35-.05.16-.07.1-.02-.5-.05-.15-.03l-.28-.06h.11c.06-.06-.74-.13.07-.19-.11-.02-.25-.04-.12-.08h.39c-.14-.03.39-.07-.01-.09,1.05,0,.23-.12.42-.16h-.51s-.11-.08-.32-.12h-.45c-.37-.05.32-.09.28-.14.17,0,.13.02.02.03,1.01-.03-.73-.16,0-.19-.16-.02-.11-.03,0-.03,0,0,0,0,.02,0,0,0,0,0,0,0,.08,0,.17,0,.24-.01-.11,0-.2,0-.24,0,0-.01-.06-.03-.18-.05h.48s0,.01-.01,0c.18,0-.23-.02-.59-.03-.08,0-.17-.02-.29-.03.78.02-.26-.05.57-.04-.4-.03-.3-.1-1.15-.14.11,0,.16,0,.17.01.1-.01.2-.03-.04-.06l.61.02-.82-.08c.37,0,.59,0,1.06.04-.72-.1-.27-.06-.98-.15l.4.02s-.54-.08-.21-.07c.75,0,.12-.19.82-.25-1.16-.06.52-.01-.38-.08.28.01.43,0,.67.04-.27-.07.44-.05-.32-.13.28.02.4.03.57.05-.06,0-.24-.03-.07-.03.16,0,.23.02.35.04-.04-.05-.89-.12-1.68-.18.38,0,.33-.02-.19-.08.26,0,.53.01.63.05.04-.02.39-.08-.25-.14.16,0,.05-.02-.02-.03.04-.04.1-.04.04-.08h-.1c-.77-.08-.17-.05-.26-.09h.08c.56-.02-.26-.05.38-.07l-.48-.04c-1.03-.1.61-.01.22-.09h-.27c-.35-.07,1.4.05,1.53.04.09,0,.14.02.21.03.61,0-.63-.07-.77-.13.34.02.86.09.92.07.27.01-1.09-.19-.44-.17-.26-.02-.52-.03-.71-.07-.09-.04.99.01.18-.1.07,0,.14.01.2.02-.21-.05-.34-.12-.78-.18,1.65.15-.78-.25.73-.08l-.07-.09.15.02c.11-.04-.26-.1-.62-.16.1,0,.25.03.32.04.31-.04.25-.05-.5-.2l.49.05c-.28-.05.78,0,.22-.15.06,0,.15.02.22.04-.57-.16,1.39,0-.4-.27l-.43-.11c-.15.05-.77-.12-1.08-.13-.1-.04.55,0,.64.05h-.09c.93.13.34-.05.98.04-.03-.14.51-.2.57-.31l-.73-.1.05-.04c.17.01.57.07.53.1.41.05-.33-.1-.49-.13.3-.02.84.15.86.14l-.05-.03h-.09c-.29-.07-.6-.12-.56-.16.15,0,.45.06.48.05.05,0,.08,0,.02-.01l.07-.04-.57-.07c-.28-.07.04-.05-.61-.13,1,.12.39-.15.7-.12-.41-.1-.4-.14-.34-.17-.12-.01-.76-.11-.68-.14,1.32.24.58.03,1.54.17-.63-.09-.14-.13-1.04-.25.11-.01.49.09.81.12-.5-.16.36-.1.2-.21-.17-.03-.44-.07-.69-.14l.87.12c-.08-.03-.99-.21-.39-.12-.15-.02-.37-.06-.42-.08.87,0-.62-.5,1-.34-.34-.05-.37-.07-.38-.09-.08,0-.43-.09-.66-.14l.66.06c-.64-.15-.03-.09-.64-.23l.11.05c-.72-.19-1.63-.3-2.57-.51.82.21-1.25-.16-.07.15-.19-.03-.3-.07-.52-.11.4.1.48.14.29.13l-.1-.02c.08.12-.33.08-.62.14l.47.08c-.07.01-.21-.01-.33-.02.7.17.05-.06.82.12-.95-.15-.05.17-1.13-.02-.01.04.54.09.53.13l-.29-.05.37.08c-.07.01-.43-.04-.68-.09.03,0-.07-.03-.09-.04-.35-.03.1.11-.01.1h.19c.25.15-.15.21.42.41l.22.03c.39.15-.25.02-.08.13h-.05c.22.04.32.08.29.1-.25-.07-.51-.05-.79-.12.42.16.34.1,1.15.29l-.37-.05c.33.07.5.1.59.16-.31-.09-.56-.07-.97-.17-.82-.05.79.26-.39.11,1.01.2.57.02.79.07.33.04.75.16.65.17-.03.02-1.3-.16-1.3-.09,0,0-.07-.02-.07-.03-.26-.01.34.11-.08.07.61.11-.04.04.74.16l-.17-.09c.2.07,1.11.24.66.23-.16-.03-.36-.08-.48-.11-.23-.02.15.06-.09.04-.78-.12-.16-.1-.75-.23-.33-.03.56.16-.29.01,1.07.19-.15.05.67.22l-.47-.07c.07.02.29.07.28.08l-.6-.12c.51.12-.47,0-.19.09,0-.08.57.07.92.08.61.19-1.24-.13-1.03.02-.06-.02.29-.02.5.04-.1,0-.28,0-.53-.01.09.09.48.06.77.13-.58-.06.23.07.41.12l-.48-.07c-.32.04.99.16.61.18l-.66-.12.17.06-.54-.08c.4.1.29.1.13.12.34.04.87.12.88.16-.29-.01-.45-.07-.39-.01-.3-.05-.67-.11-.23-.08-.16-.03-.3-.05-.45-.07-.33-.02-.08.06-.08.08.02,0,.05-.01.11,0l.65.16c-.18-.01-.32-.04-.46-.07.05.02.27.06.31.09-.39-.06-.79-.11-.97-.16l.42.13c-.17-.02-.47-.02-.61-.05-.23.01.74.19.43.21.08.01.15.03.2.04-.09.04-.58.03-.05.15l-.7-.05c.15.06.89.06,1.14.16.22.08-.6-.05-.79-.05.35.07,1.06.19.49.18-.13-.03-.03-.03-.08-.05ZM601.83,6.89c-.1-.02-.41-.07-.12-.05.55.07.28.05.12.05ZM602.92,7.82c-.16-.02-.08-.03.1-.03.04.01.02.02-.1.03ZM606.2,10.13s-.01,0-.02,0c.19-.02.11-.01.02,0ZM605.99,10.17c.07,0,.13,0,.2,0-.12,0-.13-.01-.1-.02-.13,0-.21,0-.11.02ZM606.17,5.42h-.13c-.13-.05-.01-.03.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M602.27,7.68c.08,0,.17,0,.26.01-.08-.01-.17-.02-.26-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "601.37 5.91 601.38 5.91 601.29 5.9 601.37 5.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M601.91,9.39c.07,0,.16-.01.25-.01-.12,0-.22,0-.25.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.81,10.4l-.13-.03s-.08.02-.16.03c.11,0,.28,0,.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M603.82,10.69c.06,0,0,0,.07.01h.22s-.2-.03-.29-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M605.21,10.44c-.41,0-.27.02-.19.04,0,0,0,0,0,0,.57,0,.38-.02.19-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M605.03,10.49s.03.01.01.02c.23,0,.05,0-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.26,10.23c-.1,0,.52,0,.35.01.52,0-.63-.06-.35-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "603.87 10.47 604.37 10.46 603.97 10.45 603.87 10.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M604.23,10.3l-.14.03c.08,0,.13,0,.17,0,.02-.02.12-.04-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M604.27,10.34s0,.02.08.03c0,0-.02-.02-.08-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "603.72 10.42 603.82 10.41 603.86 10.39 603.72 10.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M604.33,9.94l-.14-.04c-.17,0-.28,0-.21.02.12,0,.19.02.35.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M602.96,10.04c.1,0,.22,0,.38-.02h-.62s.24.02.24.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M602.82,9.93c-.17,0-.49-.06-.46-.01.17,0,.31.04.46.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "603.61 9.38 603.62 9.38 604.64 9.41 603.61 9.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M601.19,8.78c-.25.04.63.04.32.07.24.02.25-.02.46,0-.25-.04-.11-.05-.78-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M601.97,8.84s.09.01.15.02c-.06,0-.11-.01-.15-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "606.97 3.93 607.19 3.95 606.85 3.9 606.97 3.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M606.25,3.73l.64.13-.57-.14s.08.04-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M600.52,6.85l.16.02c.17.01.18,0,.21,0h-.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "601.05 6.48 601.04 6.48 601.62 6.53 601.05 6.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M600.34,6.04s.1.04.08.06c-.1-.04.65.02-.08-.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.62,4.08s-.27-.27-.32-.33c.05.08.4.4.32.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "635.15 4.9 635.03 4.78 635.31 5.1 635.15 4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635,5.05c.53.48-.03-.13.18.02l.12.11-.4-.41c.03.1.27.4.1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.82,4.05c.2.19.16.18.08.04-.02-.02-.04-.03-.05-.05,0,0,0,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.84,4.05s-.18-.15,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.89,4.23l-.16-.19c-.12-.11-.17-.12-.24-.21.08.12.2.23.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.24,4.61l-.06-.08c-.05-.05-.07-.06.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.04,4.35l.14.18c.09.08.25.24-.05-.07.15.15,0,0-.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.13,4.41c.12.1.21.15.36.34-.03-.11-.4-.45-.36-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635.52,5.57l.17.13-.16-.18c.08.09-.17-.1,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.51,4.09c.11.1.29.28.43.41l-.11-.14c-.08-.07-.16-.12-.32-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.94,4.5l.16.2s-.04-.09-.16-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "634.81 5.17 634.45 4.75 634.81 5.18 634.81 5.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "633.41 4.16 633.18 3.9 633.53 4.29 633.41 4.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.41,4.25c-.2-.21-.36-.34-.48-.47.02.05.19.24.34.41-.08-.1-.04-.09.14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.48,4.44c-.05-.05-.13-.15-.21-.25.04.05.1.13.21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.02,4.69c-.07-.06-.24-.23-.33-.29l.31.29h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.01,4.7h-.01s-.03,0-.04,0c0,0,.02,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.02,4.69h0s.04.04,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.47,4.96c.16.18.31.39.6.62-.2-.21-.36-.35-.6-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.41,5.05l.09.05c-.08-.08-.2-.19-.28-.28l.19.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "634.5 5.16 634.41 5.05 634.38 5.04 634.5 5.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.8,4.68c.12.14.12.16.13.2.07.05.12.07.13.05-.09-.1-.26-.27-.26-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.93,4.72l.02.02s.04.03-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.81,5s.04.04.06.05l-.05-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.12,4.99c.07.05,0-.03-.09-.13.02.04.04.06.03.08.04.04.07.07.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.59,4.61c.07.06.13.11.18.15-.1-.09-.26-.23-.18-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.86,4.66s-.01-.02-.01-.02c-.07-.06-.04-.03.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.86,4.66s.11.13.17.2c-.02-.03-.05-.07-.09-.12-.02-.02-.06-.05-.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635.7,6.98c-.28-.28-.51-.57-.18-.29-.19-.23-1.12-1.14-1.65-1.64.12.12.23.24.37.43.16.15.41.31.64.58.11.18-.12-.07-.29-.21.36.34.46.55.98,1.06l-.15-.21c.08.08.2.22.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.94,5.04l-.03-.04c-.06-.04-.18-.14-.41-.35.12.15.22.26.31.35h.08s.04.04.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.95,4.95c.3.31.4.46.75.78,0-.05-.23-.27-.35-.42.03.12-.16-.18-.36-.32-.04-.06-.05-.08-.06-.1-.04-.03-.1-.07-.16-.12l.02.02h0s0,0,0,0c.04.04.06.06.04.04,0,0,0,0,0,0,.04.04.08.08.11.12-.08-.05-.08-.08-.11-.12l-.04-.05h0s.12.21.12.21c.05.03.05.01.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635.71,6.25s-.05-.05-.07-.07c.03.04.06.07.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635.51,6.08s-.16-.17-.12-.15c.1.08.15.15.25.24-.07-.09-.2-.24-.37-.37l.04.04c-.12-.08-.53-.44-.57-.48.28.26.49.45.77.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.8,5.6l.11.19.28.24-.16-.16c.08.04-.12-.15-.24-.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "633.65 4.85 633.34 4.52 633.77 5 633.65 4.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "633.65 4.93 633.37 4.65 633.53 4.83 633.65 4.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.49,11.17l.05.1s-.03-.07-.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.59,11.14l-.1-.17c.05.09.09.16.1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.58,5.95c-.24-.28-.61-.72-.34-.37l.27.34c-.04-.07,0-.04.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.19,8.68l.08.11c-.07-.13-.14-.25-.21-.36.04.08.09.16.13.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.14,10.21l-.18-.22c.06.08.12.15.18.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.31,11.84l.24.37s-.12-.19-.24-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.29,5.49c-.13-.11-.19-.16-.21-.16.18.17.45.43.21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.08,7.25c.03.07.08.15.13.23-.03-.07-.07-.14-.13-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.05,5.36s.05.04.08.07c-.04-.06-.07-.11-.04-.1-.14-.13-.23-.2-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M632.23,12.39s-.03-.01-.05-.02c.05.03.05.03.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M628.02,11.13s-.02-.03-.02-.05c-.03,0-.03,0,.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.33,4.97s-.03-.04,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.57,6.16s.07.08.14.16c-.07-.08-.12-.13-.14-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.74,7.47h0c.06.06.05.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.48,5.1s-.08-.06-.1-.08c.03.02.06.05.1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.34,4.96s.03.02.04.02c-.05-.05-.08-.08-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.33,5s.02,0,.05.02c-.02-.02-.04-.04-.05-.05,0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M631.76,11.14s-.02-.02-.03-.03c.12.14.1.11.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.99,9.77s0-.01-.01-.02h-.01s.02.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635.13,10.07c-.29-.45-.24-.41-.16-.33l-.75-1,.91,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.35,11.41l.24.31c.32.56.18.39.5.83-.74-1.14.02-.18-.71-1.32l.17.23s.03.06.02.05c.38.53-.5-.84-.35-.71.07.08.19.24.26.38l-.14-.31s.15.22.12.2v-.13s.02.03.02.03c-.1-.19-.26-.48-.32-.6.12.16.07.13.16.27l-.14-.3c.2.29.35.6.3.57.75,1.13-.15-.31.33.32l.06.17c.43.64.3.39.59.78-.14-.21-.71-.99-.85-1.3.06.08.1.11-.02-.13.25.41.21.3.22.26l.33.55c-.07-.17-.24-.45-.38-.7.06.04.33.45.56.8.1.06-.45-.66-.46-.79.17.18.06-.06-.09-.41.14.17.2.34.31.49l-.24-.45s.09.14.13.21c-.08-.18-.33-.54-.39-.71-.36-.6.61.83.23.12.11.15.2.34.34.54-.22-.48-.15-.36-.48-.98l.27.33c-.29-.39-.55-.89-.77-1.31-.13-.19-.25-.35-.31-.43l-.13-.32c.06.08.18.27.31.5-.03-.05-.05-.09-.07-.14.15.19.33.5.51.81-.07-.1-.15-.21-.23-.32.2.34.41.71.62,1.02-.04-.06-.06-.12-.07-.16.05.09.1.17.14.23.04.06-.03-.07-.11-.21l.4.59-.15-.24.31.33c-.33-.64-.87-1.55-.95-1.85.27.45.47.72.81,1.23-.38-.53.09.27-.03.19.06.04.22.29.27.38l-.25-.55c.28.42.23.31.36.47-.57-.82-.31-.59-.45-.87.19.28.37.57.29.53.47.6-.6-1.01-.2-.51,0,.01-.04-.03.05.12-.15-.26.04-.1.19.15h0c.13.07.2-.12-.29-.82.06.09.59.84.69.98-.52-.8-1.04-1.6-1.58-2.39.42.6,1.49,1.97,1.68,2.34.08.07.17.16.05-.07-.07-.08-.65-.83-.68-.89.52.63.28.33.75.85-.11-.11-.78-1.04-.74-1.03.1.14.67.91.75,1l-.62-.94c.11.17.57.76.78,1-.14-.17.07-.02.01-.12l-.18-.19c.17.08-.91-1.3-.81-1.3.14.19.87,1.14.99,1.22-.34-.47-1.66-2.22-1.9-2.59l.22.25-.2-.32c.53.68,1.62,2.16,2.01,2.75.19.18.25.3.27.24.21.23.27.38.27.4l.22.08c-.43-.52-.36-.58-.72-1.01l.35.62c-.42-.52-1.15-1.52-1.02-1.48.18.19.75.93.9,1.1-.14-.19-.23-.39-.12-.27l.2.3c.2.17-.52-.73-.07-.27.04.02.6.62.35.32-.52-.56-2.06-2.37-2.42-2.82.04.04.53.51.79.78.41.44.9,1.11,1.26,1.49-.12-.14-.25-.32-.3-.38.12.11.37.44.34.35-.44-.52.1,0-.36-.45-.1-.17.12.08.14.03-.3-.32-.96-1.15-1.06-1.32.12.13.27.29.34.37.09,0,.33.2.38.16.12.12.27.24.46.47-.07-.1-.22-.27-.22-.3.43.41.03.1.53.6-.26-.29-.33-.44-.47-.64-.42-.44-.13-.04.01.16-.57-.62-1.13-1.31-1.34-1.64-.1-.19.39.38.31.29.17.04-.95-1.13-.47-.74.39.37.74.78,1.01,1.05.11.18-.28-.2-.29-.17l.2.16c.11.14.18.26.06.16.35.33.19-.05.56.22-.11-.14-.23-.29-.38-.44l.03.07c-.32-.3-.38-.46-.54-.59-.19-.24-.49-.61-.29-.47l.43.43c-.13-.13-.28-.24-.15-.1-.18-.21.63.55.08-.04l-.32-.28c-.19-.24-.62-.74-.46-.62-.44-.42.04.06-.47-.43.63.61-.1.04.58.68-.59-.57-.28-.22-.79-.7.14.14.28.27.19.22.04.04.09.1.12.13h-.01s.02,0,.02,0c.02.02.02.03,0,0,.06.06.14.13.22.21.31.35.26.37.42.56-.08-.06-.15-.17-.31-.32l.23.28c-.31-.32-.55-.51-.7-.73h-.04c-.19-.15-.28-.21-.17-.06-.08-.06.31.39.08.13l.15.24-.08-.08c-.08,0,.41.63-.18.08.06.1.14.21.03.14l-.26-.29c.07.12-.31-.24-.05.07-.71-.77-.24-.1-.39-.21l.33.39s.03.12.14.3l.29.34c.21.3-.27-.19-.28-.12-.11-.13-.07-.11,0-.03-.69-.75.37.65-.14.11.09.14.05.1-.03.02,0,0,0,0-.01-.02,0,0,0,0,0,0-.05-.06-.11-.12-.16-.18.07.08.13.15.16.18,0,.01.02.07.08.17l-.3-.38s0,0,0,.01c-.12-.13.13.19.36.47.04.07.1.15.16.24-.49-.61.13.23-.39-.41.24.33.12.29.63.97-.07-.09-.1-.13-.1-.14-.07-.07-.15-.13-.02.07l-.37-.49.46.69c-.24-.29-.38-.46-.64-.85.38.62.13.25.51.86l-.23-.32s.28.47.08.21c-.46-.59-.22.03-.7-.5.66.96-.33-.41.17.35-.16-.23-.25-.35-.37-.56.1.25-.3-.33.08.33-.15-.23-.22-.34-.3-.48.03.05.12.21.02.08-.09-.14-.12-.2-.18-.3-.02.07.43.79.86,1.46-.23-.3-.21-.25.05.2-.15-.21-.31-.44-.33-.53-.04-.02-.31-.26.03.28-.09-.13-.05-.02-.01.04-.06,0-.09-.05-.1.02l.07.08c.39.66.06.17.08.26l-.04-.07c-.36-.43.11.25-.3-.25l.26.41c.53.88-.38-.48-.22-.12l.16.22c.16.31-.8-1.15-.89-1.25-.05-.07-.07-.13-.1-.19-.38-.48.32.54.35.69-.19-.28-.44-.74-.51-.77-.16-.22.49.99.1.47.15.22.29.43.38.61.02.1-.62-.78-.21-.06-.04-.06-.08-.12-.12-.17.09.2.1.35.33.74-.92-1.38.27.78-.55-.5l-.04.12-.08-.13c-.11-.05.07.27.26.59-.07-.08-.14-.2-.18-.27-.25-.2-.23-.14.14.53l-.29-.4c.15.25-.56-.56-.31-.02-.03-.05-.09-.13-.12-.19.26.53-1.05-.93,0,.53l.21.4c.16.05.47.63.68.84.04.1-.4-.38-.43-.47l.06.07c-.57-.75-.3-.19-.7-.69-.12.16-.61-.11-.78,0l.52.52h-.08c-.13-.1-.41-.38-.36-.4-.31-.28.18.31.29.42-.27-.15-.57-.64-.6-.63v.07s.07.05.07.05c.19.24.41.46.34.48-.13-.08-.33-.3-.36-.31-.04-.04-.06-.05-.03,0l-.11.02.44.37c.18.22-.07.04.42.46-.77-.66-.47-.02-.73-.2.29.31.25.34.17.36.1.06.61.47.52.45-1.04-.85-.51-.29-1.31-.83.54.35.02.23.8.71-.11-.03-.41-.29-.69-.45.36.39-.44.04-.37.27.15.09.39.21.6.37l-.8-.38c.06.07.86.53.31.28.13.07.33.17.37.21-.44-.09-.36.14-.34.3.01.17-.04.28-.85.15.33.08.36.12.36.15.08,0,.41.15.63.23l-.66-.11c.62.23,0,.14.6.35l-.1-.07c.7.27,1.59.46,2.49.77-.79-.31,1.2.36.07-.1.18.06.28.12.49.19-.38-.16-.45-.2-.28-.15l.09.04c-.07-.1.31.04.58.11l-.43-.2c.06.01.2.08.31.13-.64-.34-.05.02-.76-.34.87.41.07-.1,1.03.41.01-.01-.48-.26-.47-.28l.26.14-.33-.19c.06.02.39.2.6.33-.03-.01.06.04.07.05.31.17-.09-.09.01-.04l-.16-.08c-.21-.19.14,0-.32-.4l-.18-.13c-.3-.28.22.12.1-.04l.04.03c-.17-.15-.25-.23-.22-.22.2.17.41.3.63.5-.32-.32-.26-.24-.87-.8l.29.23c-.25-.23-.38-.34-.43-.43.22.23.44.36.74.65.64.5-.55-.62.34.17-.73-.72-.45-.35-.6-.51-.26-.21-.55-.54-.45-.49.04,0,.98.87.99.83,0,0,.05.05.04.05.2.17-.23-.27.09.01-.43-.45.04,0-.51-.56l.09.17c-.13-.16-.75-.85-.4-.56.1.12.24.28.31.37.17.16-.09-.13.09.03.54.58.07.17.48.62.24.23-.36-.44.22.18-.74-.8.12.07-.42-.56l.32.35c-.05-.06-.19-.23-.18-.23l.4.46c-.34-.4.34.31.16.09-.02.04-.39-.42-.63-.67-.37-.52.85.91.74.7.04.06-.21-.2-.34-.37.07.07.2.19.37.38-.03-.1-.32-.37-.49-.61.38.43-.13-.2-.23-.35l.31.37c.24.21-.62-.79-.34-.54l.4.54-.09-.15.34.43c-.23-.34-.16-.26-.04-.15-.21-.27-.53-.7-.51-.73.19.22.27.37.26.29.17.25.4.55.11.21.09.13.18.25.27.37.21.25.08.03.09.02-.01-.01-.03-.03-.08-.08l-.35-.57c.11.14.19.26.27.38-.02-.05-.15-.23-.16-.28.23.32.47.65.56.81l-.22-.38c.1.14.29.36.37.49.15.17-.39-.66-.18-.43-.04-.06-.08-.13-.1-.18.08.05.38.43.12-.04l.41.57c-.06-.15-.52-.72-.62-.97-.09-.21.34.49.47.65-.18-.31-.54-.93-.19-.48.06.12,0,.04.01.09ZM633.62,10.87c.04.09.19.37.03.13-.28-.48-.13-.26-.03-.13ZM633.76,9.42c.08.14.02.08-.09-.07-.01-.04,0-.03.09.07ZM633.5,5.36l.02.02c-.14-.12-.09-.07-.02-.02ZM633.67,5.48c-.04-.05-.09-.1-.14-.15.08.09.08.1.05.09.09.09.15.15.09.06ZM629.36,8.95l.1.08c.08.12,0,.02-.1-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.03,10.03c-.05-.07-.09-.14-.14-.22.04.07.09.15.14.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "633.26 11.78 633.26 11.77 633.31 11.84 633.26 11.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635.83,9.04c-.05-.04-.12-.11-.18-.17.08.09.15.16.18.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.28,4.72l.07.11s.07.05.13.1c-.08-.08-.2-.19-.2-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635.56,6.66s0-.01-.04-.06l-.16-.16s.11.16.2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.42,5.85c.29.29.2.18.17.11,0,0,0,0,0,0-.39-.41-.28-.26-.16-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.58,5.94s-.01-.03,0-.02c-.16-.16-.04-.03,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.53,5.24c.08.07-.35-.38-.24-.26-.35-.38.39.5.24.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "635.36 6.79 635.01 6.44 635.28 6.74 635.36 6.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.98,6.66l.12.07c-.06-.06-.09-.1-.11-.13-.03,0-.11-.05-.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.99,6.6s.02-.02-.04-.08c0,0,0,.03.04.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "635.43 6.94 635.35 6.87 635.31 6.86 635.43 6.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.63,6.85l.07.13c.11.13.19.2.16.14-.07-.09-.11-.15-.23-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635.66,7.77c-.08-.07-.16-.15-.27-.27l.42.45-.15-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635.66,7.96c.11.13.29.41.3.34-.11-.13-.18-.26-.3-.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "634.67 7.79 634.68 7.78 634.01 7.01 634.67 7.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635.75,10.06c.2.16-.38-.5-.15-.3-.14-.2-.19-.17-.3-.34.13.22.03.12.45.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M635.3,9.42s-.05-.08-.08-.13c.03.05.06.1.08.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "627.46 11.12 627.24 11.1 627.57 11.17 627.46 11.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M628.15,11.43l-.62-.18.55.2s-.07-.05.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M634.38,11.94l-.08-.13c-.09-.14-.11-.15-.13-.16l.21.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "633.8 11.73 633.81 11.74 633.49 11.25 633.8 11.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M633.98,12.51s-.04-.1-.02-.09c.04.1-.39-.52.02.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.42,32.59s-.1-.37-.12-.44c.02.08.09.34.12.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "647.58 33.53 647.54 33.37 647.64 33.78 647.58 33.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.5,33.55c.19.69,0-.12.08.12l.04.16-.14-.56c0,.09.08.47.02.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.07,32.06c.07.27.05.23.03.08,0-.03-.01-.05-.02-.07,0,0,0,0-.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.08,32.08s-.06-.22,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.09,32.24l-.05-.24c-.04-.16-.06-.19-.09-.31.02.13.07.29.14.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.21,32.75l-.02-.1c-.02-.07-.03-.09.02.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.14,32.43l.04.22c.03.11.09.34-.01-.08.05.2,0,0-.03-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.18,32.53c.04.15.08.24.13.48,0-.1-.13-.58-.13-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.69,34.26l.06.2-.05-.23c.03.12-.07-.18,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.93,31.9c.04.15.1.39.15.58l-.04-.17c-.03-.1-.06-.19-.12-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.08,32.48l.05.26s-.01-.09-.05-.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "647.41 33.52 647.29 32.98 647.4 33.52 647.41 33.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "646.88 31.89 646.8 31.55 646.92 32.07 646.88 31.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.87,31.96c-.07-.28-.12-.48-.17-.65,0,.05.06.3.11.52-.02-.12,0-.09.06.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.88,32.14c-.01-.07-.04-.19-.07-.32.01.07.03.16.07.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.1,32.67c-.02-.09-.09-.32-.12-.42l.11.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.1,32.68h0s-.01-.03-.02-.03c0,0,0,.01.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.1,32.67h0s.01.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.28,33.15c.05.23.1.49.21.83-.07-.28-.12-.49-.21-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.24,33.19l.04.09c-.03-.11-.07-.27-.1-.38l.06.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "647.27 33.32 647.24 33.19 647.22 33.15 647.27 33.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647,32.53c.04.18.04.2.04.23.03.08.05.12.05.12-.03-.13-.09-.36-.09-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.06,32.64v.02s.02.05,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.97,32.77s.01.05.02.08l-.02-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.11,32.95c.03.08,0-.02-.03-.15,0,.04,0,.07,0,.08.01.06.02.1.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.91,32.34c.03.09.05.16.07.23-.04-.13-.09-.33-.07-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.03,32.55s0-.02,0-.02c-.02-.09-.01-.04,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.03,32.55c.01.06.04.16.06.25,0-.03-.01-.08-.03-.14,0-.03-.02-.07-.03-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.61,35.44c-.09-.39-.17-.74-.05-.34-.06-.29-.38-1.55-.56-2.26.04.17.08.32.12.55.06.21.15.48.22.83.03.2-.05-.13-.11-.33.11.48.16.7.33,1.41l-.04-.25c.03.11.07.28.09.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.03,32.88v-.05c-.03-.07-.07-.22-.15-.52.04.19.07.33.1.46l.04.05v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.04,32.82c.1.42.13.6.25,1.05,0-.03-.08-.35-.11-.54,0,.11-.05-.23-.13-.47-.01-.07-.01-.1-.01-.11-.02-.05-.04-.11-.06-.19v.03s0,0,0,0h0c.01.06.02.09.01.06,0,0,0,0,0,0,.01.06.03.11.04.16-.03-.08-.03-.11-.04-.16l-.02-.06h0s.03.23.03.23c.02.06.02.04.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.7,34.89s-.02-.07-.03-.1c.01.05.02.09.03.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.62,34.64c-.01-.06-.05-.23-.04-.18.03.13.05.2.09.34-.02-.11-.06-.3-.13-.5v.06c-.03-.14-.18-.66-.19-.72.1.37.17.64.27,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.36,33.84l.03.21.1.36-.06-.22c.03.08-.04-.19-.08-.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "646.92 32.56 646.81 32.12 646.96 32.75 646.92 32.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "646.91 32.62 646.82 32.24 646.87 32.47 646.91 32.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.27,37.77v.11s0-.07,0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.32,37.78l-.03-.19c.02.11.03.18.03.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.28,32.81c-.09-.36-.21-.92-.12-.48l.09.42c-.01-.08,0-.03.03.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.33,35.44s.02.09.03.13c-.03-.15-.05-.28-.07-.41.01.09.03.18.04.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.66,37.21l-.07-.27c.02.1.04.19.07.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.05,38.27l.06.44s-.03-.22-.06-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.68,32.84c-.05-.16-.07-.23-.08-.25.06.24.16.6.08.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M645.51,33.22c.01.08.02.17.04.26-.01-.07-.02-.16-.04-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.58,32.6s.02.06.03.1c-.01-.07-.02-.13,0-.1-.05-.18-.08-.29-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.94,38.06s0-.03,0-.05c0,.06,0,.06,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.18,33.74s0-.03,0-.03c0-.03,0-.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.76,32.46s-.01-.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.19,34.12s.02.11.05.21c-.02-.1-.04-.17-.05-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.12,35.24h0c.02.08.02.07,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.81,32.65c-.02-.05-.03-.09-.04-.12,0,.03.02.07.04.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.77,32.45s.01.03.01.04c-.02-.07-.03-.11-.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.76,32.49s0,.01.02.04c0-.03-.01-.05-.02-.07v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M645.34,36.84s0-.02,0-.04c.02.18.02.15,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.04,37.25s0-.02,0-.02h0s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.08,37.58c-.1-.53-.08-.47-.05-.36l-.26-1.22.31,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.16,37.91l.08.38c.08.64.03.42.14.96-.22-1.34.05-.15-.17-1.49l.06.28s0,.07,0,.05c.13.64-.15-.97-.09-.79.03.1.07.29.09.45l-.03-.33s.05.26.04.23l.02-.11v.04c-.02-.21-.07-.54-.09-.68.04.19.02.14.05.31l-.04-.33c.07.35.11.68.09.64.25,1.33-.04-.34.13.43v.17c.16.76.12.48.23.95-.05-.25-.25-1.19-.29-1.52.02.1.04.15,0-.12.08.48.07.36.08.33l.11.63c-.02-.18-.08-.5-.12-.79.03.06.12.55.2.96.04.1-.16-.78-.15-.9.06.24.03-.02,0-.4.05.21.07.39.11.56l-.08-.5s.03.17.05.24c-.02-.2-.11-.63-.13-.8-.12-.69.22,1.01.1.22.03.18.07.39.12.63-.07-.52-.04-.38-.15-1.08l.1.41c-.1-.47-.19-1.03-.26-1.49-.05-.23-.09-.43-.11-.52l-.04-.34c.02.1.06.32.11.58,0-.05-.02-.1-.02-.15.05.23.12.59.18.95-.03-.12-.05-.25-.08-.39.07.38.15.81.21,1.17-.01-.07-.02-.14-.02-.17.02.1.04.2.05.26.01.07-.01-.07-.04-.23l.14.7-.05-.28.12.43c-.11-.71-.29-1.75-.31-2.05.1.51.16.84.28,1.45-.14-.64.02.28-.02.15.02.07.08.36.09.46l-.08-.59c.1.5.08.37.13.57-.2-.98-.1-.66-.15-.96.07.33.13.67.1.59.17.74-.2-1.16-.06-.53,0,0-.02-.04.02.13-.05-.3.02-.07.07.22h0c.05.12.09,0-.07-.84.02.11.2,1.01.23,1.17l-.52-2.81c.14.72.51,2.42.57,2.83.03.1.06.22.02-.04-.02-.1-.22-1.03-.23-1.1.19.79.1.42.26,1.1-.04-.15-.26-1.28-.25-1.24.03.17.23,1.11.25,1.22l-.2-1.11c.04.2.2.93.27,1.24-.05-.22.03.01.01-.1l-.07-.25c.07.16-.3-1.55-.25-1.5.04.23.29,1.4.33,1.54-.11-.57-.53-2.72-.62-3.15l.07.32-.06-.37c.17.85.51,2.64.65,3.34.07.25.08.38.1.35.07.3.09.46.09.48l.09.19c-.14-.66-.11-.67-.23-1.21l.1.69c-.14-.66-.38-1.87-.32-1.76.06.26.25,1.17.3,1.39-.05-.23-.07-.44-.03-.28l.06.35c.07.24-.16-.88,0-.25.02.04.21.84.12.45-.17-.75-.68-3.06-.81-3.63.01.05.18.71.28,1.08.13.59.31,1.4.42,1.91-.04-.18-.08-.4-.1-.47.04.15.12.56.12.47-.15-.67.04.05-.12-.56-.03-.19.05.13.06.1-.1-.43-.31-1.47-.34-1.66.04.17.09.39.11.49.04.05.13.35.16.35.04.16.1.35.16.64-.02-.12-.07-.34-.07-.36.15.57,0,.09.17.78-.09-.39-.1-.54-.14-.78-.14-.6-.05-.11-.01.14-.19-.82-.37-1.69-.43-2.07-.03-.21.13.53.11.41.07.13-.3-1.44-.13-.86.13.52.25,1.04.34,1.42.03.2-.11-.33-.11-.3l.07.24c.04.18.05.31.01.16.12.47.09.07.23.5-.04-.18-.07-.36-.12-.57v.08c-.1-.42-.11-.59-.17-.78-.06-.3-.16-.77-.08-.53l.15.6c-.04-.17-.1-.35-.06-.17-.06-.27.22.8.04.02l-.11-.41c-.06-.3-.2-.94-.14-.75-.16-.58.02.06-.17-.62.22.85-.05-.03.19.87-.2-.8-.1-.33-.28-1.01.05.2.1.37.06.28.01.06.03.13.04.17h0s0,0,0,0c0,.03,0,.04,0,0,.02.09.05.19.08.3.1.45.08.44.13.68-.03-.09-.05-.23-.1-.44l.07.35c-.11-.44-.19-.72-.24-.98l-.02-.02c-.07-.24-.1-.34-.07-.15-.03-.09.09.49.02.14l.04.28-.03-.11s.12.74-.1-.05c.02.11.04.25,0,.13l-.09-.38c.02.13-.12-.37-.03.02-.24-1.02-.1-.21-.16-.39l.11.5s0,.12.03.32l.1.44c.06.36-.11-.3-.12-.25-.03-.17-.02-.12,0-.02-.24-.98.1.73-.08.02.03.16.01.11-.02,0,0,0,0,0,0-.02,0,0,0,0,0,0-.02-.07-.04-.16-.06-.23.03.11.05.19.06.23,0,0,0,.07.02.18l-.1-.47s0,0,0,.01c-.04-.17.04.22.12.58.01.08.03.17.05.29-.17-.76.03.26-.14-.55.08.4.03.31.2,1.14-.02-.11-.04-.16-.03-.17-.03-.09-.06-.19-.01.05l-.13-.6.15.81c-.09-.36-.13-.57-.22-1.04.11.72.04.27.16.98l-.08-.39s.09.54.02.22c-.17-.73-.11-.08-.29-.76.23,1.14-.12-.51.05.38-.05-.27-.08-.42-.13-.66.03.27-.12-.42.01.33-.05-.27-.07-.4-.1-.56,0,.06.04.24,0,.08-.03-.16-.04-.23-.06-.35-.01.05.14.88.29,1.67-.08-.37-.08-.31.01.2-.05-.26-.11-.52-.11-.62-.02-.04-.12-.37,0,.26-.03-.16-.02-.04,0,.03-.03-.03-.04-.09-.04-.03l.02.1c.13.76.02.17.02.27v-.08c-.15-.54.02.26-.13-.35l.09.47c.18,1.02-.14-.59-.09-.2l.06.27c.05.35-.28-1.38-.31-1.5-.02-.09-.02-.14-.03-.21-.13-.59.11.62.11.77-.06-.33-.15-.85-.17-.91-.05-.27.15,1.09.02.45.05.26.1.51.12.71,0,.09-.21-.97-.08-.15-.01-.07-.03-.14-.04-.2.02.21.02.35.09.8-.28-1.63.06.81-.19-.7l-.02.09-.02-.15c-.04-.1.01.27.06.63-.02-.1-.04-.24-.05-.32-.08-.3-.07-.23.02.52l-.08-.49c.04.29-.17-.76-.11-.18,0-.06-.02-.15-.03-.22.05.58-.29-1.35-.03.44l.04.44c.05.13.11.78.17,1.07,0,.11-.11-.53-.11-.63l.02.09c-.13-.93-.09-.32-.18-.96-.05.05-.18-.45-.24-.49l.11.72-.03-.04c-.03-.17-.09-.57-.07-.54-.06-.41.02.35.05.5-.07-.29-.11-.85-.12-.86v.06s.01.08.01.08c.03.3.07.61.05.58-.02-.15-.07-.45-.07-.47,0-.05-.01-.08,0-.02l-.03-.06.09.57c.03.28-.03-.03.07.62-.15-1-.14-.35-.19-.66.04.42.02.41,0,.37.02.12.1.76.08.69-.16-1.33-.1-.57-.24-1.53.09.63-.03.16.1,1.06-.03-.11-.06-.5-.11-.81.03.52-.11-.33-.13-.15.02.17.05.44.08.7l-.12-.87c0,.09.11,1.01.03.4.02.15.05.37.05.42-.17-.84-.08.72-.33-.88.05.34.04.37.04.39,0,.08.05.43.07.67l-.1-.66c.06.66-.03.05.03.68v-.11c.06.74.19,1.65.28,2.6-.07-.85.18,1.25.08.03.02.19.03.31.05.53-.04-.41-.04-.49,0-.31v.1c.04-.1.11.3.19.56l-.06-.47c.02.06.04.21.06.33-.07-.72-.04-.04-.11-.83.12.96.08,0,.21,1.09.02,0-.07-.54-.05-.54l.04.29-.04-.38c.02.06.07.43.1.68,0-.03,0,.07,0,.09.06.35.03-.12.05-.01l-.04-.18c.02-.28.12.1.09-.51l-.03-.22c-.02-.41.06.24.07.05v.05c-.01-.22-.02-.33,0-.31.02.26.08.5.11.79-.02-.44-.02-.35-.11-1.17l.05.37c-.03-.33-.06-.51-.05-.61.04.32.07.56.12.98.15.8-.05-.82.13.35-.12-1.02-.11-.56-.13-.78-.05-.33-.09-.76-.06-.66,0,0,.02.09.04.21.02.12.04.28.07.44.05.32.1.63.12.62,0,0,0,.07,0,.07.05.26-.02-.35.05.06-.08-.62.02.03-.08-.75v.19c-.02-.21-.13-1.13-.04-.69.02.16.04.37.05.48.04.23,0-.16.04.08.11.79-.01.18.05.78.05.33-.04-.57.06.28-.14-1.08.05.13-.04-.7l.06.47c0-.07-.03-.3-.02-.29l.07.61c-.06-.52.1.45.08.16-.03.02-.09-.56-.15-.91-.05-.64.2,1.23.22.99,0,.07-.07-.28-.09-.5.02.1.06.27.1.52.02-.1-.08-.48-.1-.77.09.57-.02-.24-.03-.42l.07.48c.08.3-.14-1-.05-.63l.08.66v-.17s.07.54.07.54c-.04-.41-.02-.3.02-.15-.05-.34-.13-.87-.11-.88.05.28.06.45.08.38.04.3.09.67.01.24.02.16.04.3.06.45.06.32.04.07.05.06,0-.02-.01-.04-.03-.11l-.07-.67c.03.18.05.32.07.46,0-.05-.03-.27-.03-.31.06.39.12.79.13.97l-.03-.44c.03.17.08.46.11.6.05.22-.07-.76,0-.46,0-.08-.02-.15-.02-.2.04.08.13.56.08.02l.13.69c0-.16-.16-.87-.17-1.14-.01-.23.11.59.15.78-.04-.35-.14-1.07-.02-.51.01.13,0,.03,0,.08ZM646.37,37.56c.01.1.06.41,0,.13-.09-.55-.04-.29,0-.13ZM646.54,36.35c.03.16,0,.08-.03-.1,0-.04,0-.02.03.1ZM646.79,32.86s0,.01,0,.02c-.05-.18-.03-.11,0-.02ZM646.86,33.06l-.05-.2c.03.12.02.13.01.1.03.12.05.21.03.1ZM644.84,33.63l.02.12c.01.14,0,.01-.02-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.62,37c-.02-.08-.03-.17-.05-.26.02.08.03.17.05.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "646.04 38.19 646.04 38.18 646.05 38.27 646.04 38.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.45,37.12c-.02-.07-.04-.15-.06-.24.03.12.05.21.06.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.77,32.24l.02.12s.03.08.05.15c-.03-.11-.06-.27-.07-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.59,35.11c0-.06,0,0,0-.07l-.05-.22s.03.19.06.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.16,33.79c.1.39.07.26.06.18h0c-.13-.55-.1-.37-.06-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.22,33.96s0-.03,0-.01c-.05-.22-.01-.04,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.82,32.79c.03.1-.12-.51-.08-.34-.12-.5.12.61.08.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "647.48 35.09 647.36 34.6 647.45 35 647.48 35.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.32,34.75l.05.13c-.02-.08-.03-.13-.04-.17-.01-.01-.05-.11-.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.33,34.71s0,0,0-.08c0,0,0,.02,0,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "647.49 35.24 647.46 35.14 647.45 35.11 647.49 35.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.14,34.69l.02.14c.04.17.07.27.06.2-.02-.12-.03-.18-.07-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.5,36.02c-.03-.1-.05-.21-.09-.37l.14.6-.05-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.49,36.17c.04.17.09.49.1.44-.04-.17-.05-.31-.1-.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "647.06 35.46 647.06 35.45 646.84 34.46 647.06 35.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.34,37.89c.07.23-.13-.62-.04-.32-.06-.23-.06-.24-.11-.44.04.25,0,.11.15.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M647.2,37.13s-.01-.09-.03-.15c.01.06.02.11.03.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "644.08 33.2 644.05 32.99 644.09 33.33 644.08 33.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M644.13,33.95l-.07-.65.05.59s0-.09.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.63,38.84l-.03-.15c-.03-.17-.04-.18-.05-.2l.07.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "646.36 38.4 646.36 38.41 646.26 37.83 646.36 38.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M646.31,39.16s0-.11,0-.08c0,.11-.13-.64,0,.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.7,45.69s.05-.38.05-.45c-.02.09-.07.56-.05.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "643.46 46.62 643.48 46.45 643.42 46.87 643.46 46.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.33,46.6c-.06.71.06-.11.06.15v.16s.06-.57.06-.57c-.04.09-.12.46-.12.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.42,45.06c-.03.28-.04.24,0,.09,0-.03,0-.05,0-.07,0,0,0,0-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.44,45.07s.02-.23,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.36,45.22l.04-.24c.01-.16,0-.2.02-.32-.03.13-.05.3-.07.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.28,45.74l.02-.1c0-.07,0-.09-.02.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.35,45.42l-.04.22c0,.12-.03.35.02-.08-.02.21,0,0,.03-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.35,45.53c0,.16,0,.25-.05.5.05-.09.09-.59.05-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.25,47.33v.21s.03-.24.03-.24c-.02.12,0-.2-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.28,44.84c-.01.15-.04.4-.06.6l.03-.17c0-.1,0-.2.02-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.22,45.44l-.05.26s.03-.09.05-.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "643.19 46.53 643.29 45.99 643.19 46.53 643.19 46.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "643.21 44.81 643.26 44.47 643.18 44.99 643.21 44.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.15,44.87c.03-.29.05-.49.07-.67-.02.05-.06.3-.09.52.02-.12.03-.09.02.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.07,45.04c.01-.07.03-.19.05-.32-.01.07-.03.16-.05.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.15,45.62c0-.09.03-.33.03-.43l-.04.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.14,45.62h0s-.01-.03-.01-.04c0,0,0,.02.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.15,45.62h0s0,.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.18,46.14c-.04.24-.09.49-.11.85.04-.29.05-.5.11-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.1,46.15v.1c.02-.11.04-.28.06-.39l-.06.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "643.08 46.29 643.1 46.15 643.1 46.11 643.08 46.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.07,45.45c-.03.18-.04.2-.06.23,0,.08.01.13.02.13.02-.13.05-.37.03-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.1,45.57v.02s0,.05,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.9,45.66s0,.05,0,.08v-.07s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.03,45.88c0,.08.02-.02.04-.15-.01.04-.02.07-.03.07,0,.06-.01.1,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.02,45.24c0,.09,0,.17,0,.24.01-.14.02-.35,0-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.1,45.48s0-.02,0-.02c0-.09,0-.05,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M643.1,45.48c0,.06-.03.17-.04.26,0-.03.02-.08.03-.14,0-.03,0-.08,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.56,48.38c.05-.39.11-.75.08-.33.05-.29.18-1.59.24-2.32-.02.17-.04.33-.08.56-.02.22,0,.51-.07.86-.05.2,0-.14,0-.35-.04.49-.11.71-.19,1.43l.05-.25c-.01.11-.04.29-.05.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.93,45.78v-.05c.01-.07.02-.23.04-.54-.04.19-.05.34-.07.47l.04.06v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.98,45.73c-.05.43-.09.61-.13,1.07.03-.03.06-.36.09-.54-.05.1.04-.24.03-.48.02-.07.03-.09.03-.11,0-.05,0-.12,0-.2v.03s0,0,0,0h0c0,.06,0,.09,0,.06,0,0,0,0,0,0,0,.06-.01.11-.02.16,0-.09.01-.11.02-.16v-.06s0,0,0,0l-.07.23c0,.06.01.05.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.96,47.91s0-.07,0-.1c0,.05-.01.09,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.97,47.65c0-.06.03-.23.04-.19,0,.13-.02.21-.04.35.02-.11.05-.31.06-.52v.06c-.01-.15.03-.69.04-.74-.03.39-.06.66-.09,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.96,46.8l-.06.21-.02.37.02-.22c.01.09.04-.18.06-.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "642.92 45.44 642.97 44.99 642.88 45.63 642.92 45.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "642.87 45.49 642.91 45.1 642.87 45.33 642.87 45.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M639.73,50.05l-.02.11s.02-.07.02-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M639.8,50.09l.03-.19c-.02.11-.03.18-.03.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M641.76,45.4c.03-.37.08-.94.03-.5l-.05.43c.02-.08.02-.03.02.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M640.7,47.88s0,.09-.01.13c.02-.15.04-.28.06-.41-.02.09-.03.18-.05.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M640.47,49.66v-.28c0,.1,0,.19,0,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M639.26,50.46l-.07.44s.04-.22.07-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.39,45.59c0-.17,0-.24,0-.26-.01.25-.04.62,0,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M640.33,45.49c-.02.08-.03.16-.04.26.02-.07.03-.15.04-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.35,45.33s0,.07,0,.1c.02-.07.03-.13.04-.1,0-.19,0-.3-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M637.81,49.92s0-.03,0-.05c0,.06,0,.06,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M637.97,45.53s.01-.03.02-.03c0-.03,0-.03-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.71,45.28s0-.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.56,46.99s-.01.11-.03.21c.01-.1.02-.17.03-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M641.95,48h0c0,.08,0,.07,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.7,45.48c0-.05,0-.1,0-.13,0,.03,0,.08,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.72,45.27s0,.03,0,.04c0-.07.01-.12,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.69,45.3s0,.02.01.05c0-.03,0-.05,0-.07,0,0,0,.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M638.76,48.87s0-.02,0-.04c-.03.18-.03.15,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M640.98,49.84s0-.02,0-.02v-.02s0,.04,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M640.91,50.16c.08-.53.08-.47.08-.35l.14-1.24-.21,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M639.53,50.16l-.02.39c-.11.63-.1.41-.15.96.17-1.35.11-.13.29-1.47l-.02.29s-.01.07-.02.05c-.05.65.15-.97.16-.77,0,.1-.01.3-.04.46l.07-.33s-.03.26-.03.23l.06-.1v.04c.03-.21.09-.54.11-.67-.01.19-.02.14-.04.31l.07-.32c-.03.35-.1.69-.11.63-.14,1.35.06-.34.02.46l-.05.17c-.08.77-.02.49-.05.97.02-.25.09-1.21.16-1.54,0,.1,0,.15.05-.12-.06.48-.03.36,0,.34l-.08.63c.04-.18.08-.5.13-.79.02.07-.04.56-.09.97.02.1.07-.79.13-.91,0,.25.05,0,.14-.39,0,.22-.05.39-.07.57l.08-.5s-.02.17-.03.25c.04-.19.08-.63.13-.8.09-.7-.07,1.03.05.24-.02.18-.05.39-.08.63.11-.52.08-.37.2-1.07l-.02.42c.04-.48.13-1.04.21-1.5.02-.23.04-.43.05-.53l.08-.34c0,.1-.04.32-.08.59,0-.05.02-.1.03-.15-.01.24-.07.6-.12.96.01-.13.02-.26.03-.39-.05.39-.11.81-.16,1.18.01-.07.02-.14.03-.17-.01.1-.03.2-.03.26,0,.07.01-.07.04-.23l-.08.71.04-.28v.45c.12-.71.28-1.75.37-2.04-.08.52-.1.85-.18,1.46.06-.65-.08.27-.09.14,0,.07-.03.36-.05.46l.12-.59c-.06.5-.03.38-.04.59.11-1,.12-.66.18-.96-.04.33-.08.67-.1.59-.06.75.18-1.16.13-.52,0,0,0-.04-.03.13.05-.29.06-.06.02.23h0c.03.13.13.03.24-.81-.01.11-.13,1.02-.15,1.19l.41-2.83c-.09.72-.27,2.46-.35,2.86,0,.1,0,.23.05-.03,0-.1.11-1.05.12-1.12-.06.81-.03.43-.08,1.13,0-.16.15-1.29.17-1.25-.02.17-.14,1.12-.15,1.24l.17-1.11c-.03.2-.11.95-.14,1.26.02-.22.03.02.06-.08v-.26c.04.17.24-1.57.28-1.5-.03.23-.18,1.42-.17,1.56.08-.57.37-2.75.46-3.18l-.03.33.07-.37c-.13.86-.39,2.66-.5,3.36-.01.26-.04.39-.01.36-.03.31-.07.46-.08.48l.04.21c.07-.67.12-.66.19-1.22l-.15.68c.07-.67.26-1.89.29-1.77-.02.27-.15,1.19-.17,1.41.03-.23.09-.43.08-.27l-.06.35c0,.25.14-.88.1-.24,0,.04-.07.86-.02.47.07-.76.34-3.12.42-3.69,0,.05-.04.73-.06,1.11-.07.6-.17,1.42-.23,1.94.03-.18.06-.41.07-.48,0,.16-.07.56-.04.49.08-.68.04.06.08-.57.04-.19,0,.14.04.12.04-.44.19-1.49.24-1.68-.02.17-.04.4-.05.5.04.07.03.38.07.39-.01.16-.02.37-.06.66.02-.12.05-.35.07-.36-.04.59-.04.09-.1.79.05-.39.1-.54.14-.78.06-.61-.03-.12-.08.12.09-.84.23-1.71.31-2.09.06-.2-.05.54-.03.43.05.15.22-1.46.21-.85-.04.54-.12,1.06-.16,1.45-.05.2,0-.34-.03-.33v.26c-.03.18-.07.31-.06.15-.04.48.1.11.1.56.03-.18.07-.36.08-.58l-.02.07c.03-.43.1-.59.1-.8.06-.3.13-.77.14-.53l-.06.61c.02-.18.02-.37,0-.18.04-.27-.05.83.06.03l.03-.42c.06-.3.15-.95.16-.75.04-.6,0,.07.05-.64-.08.88-.06-.04-.14.88.07-.82,0-.35.06-1.05-.02.2-.03.39-.05.28,0,.06-.02.13-.02.18v-.02s0,.02,0,.02c0,.03,0,.04,0,0,0,.09-.01.19-.02.31-.06.46-.1.44-.13.68,0-.1.03-.23.05-.44l-.06.35c.05-.45.05-.75.11-1l-.03-.02c.01-.25,0-.35-.03-.17,0-.1-.09.49-.04.14l-.07.27v-.11c-.02-.06-.16.73-.12-.08-.03.11-.06.25-.07.12l.04-.39c-.03.13-.01-.39-.07,0,.1-1.04-.06-.24-.08-.43l-.06.5s-.06.11-.11.31l-.05.45c-.07.36-.03-.32-.07-.28.02-.17.03-.12.02-.02.07-1.01-.18.72-.14-.02-.03.16-.03.1-.02,0,0,0,0,0,0-.02,0,0,0,0,0,0,0-.08,0-.17.01-.24,0,.11-.01.2-.02.24,0,0-.03.06-.05.17l.05-.48s0,0,0,.01c0-.18-.04.23-.07.59-.01.08-.03.17-.05.29.08-.77-.06.26.02-.57-.06.4-.1.29-.2,1.14.01-.11.02-.16.02-.17,0-.1,0-.2-.04.04l.07-.61-.13.81c.03-.37.04-.59.12-1.05-.13.71-.07.27-.19.98l.05-.39s-.1.54-.07.21c.06-.75-.13-.12-.12-.82-.12,1.16.03-.52-.08.37.03-.27.04-.43.08-.67-.07.26,0-.44-.12.31.04-.27.05-.4.07-.56-.01.06-.04.24-.02.07.02-.16.03-.23.05-.35-.04.04-.15.88-.25,1.68.03-.38,0-.33-.07.19.02-.26.05-.53.08-.62,0-.04-.04-.39-.11.24.02-.16-.01-.05-.03.02-.03-.04-.02-.1-.06-.04v.1c-.11.76-.05.17-.09.26v-.08c.02-.56-.05.26-.02-.38l-.06.48c-.13,1.02.03-.61-.05-.22l-.02.27c-.06.35.12-1.4.12-1.53,0-.09.02-.14.04-.21.03-.61-.08.62-.13.76.04-.34.11-.85.1-.92.02-.27-.2,1.08-.15.44-.03.26-.05.52-.09.71-.04.09.06-.99-.07-.17,0-.07.01-.14.02-.2-.04.21-.1.34-.17.78.19-1.65-.21.79-.02-.73l-.07.07.02-.15c-.02-.1-.08.26-.14.62,0-.1.03-.24.04-.32-.01-.31-.03-.25-.17.5l.06-.49c-.05.28.02-.78-.1-.21,0-.06.02-.15.03-.22-.13.57.04-1.38-.21.41l-.1.44c.03.15-.11.78-.13,1.08-.03.1.02-.55.05-.64v.09c.12-.93-.03-.34.06-.97-.1.03-.13-.49-.22-.54l-.08.73-.03-.05c.01-.17.06-.57.08-.54.04-.41-.08.34-.1.5,0-.3.13-.84.12-.86l-.03.05v.08c-.06.29-.1.61-.13.57,0-.15.05-.45.05-.48,0-.05,0-.08,0-.02l-.03-.07-.06.57c-.05.28-.03-.03-.1.62.1-1-.1-.38-.08-.69-.08.41-.1.4-.13.35,0,.12-.09.76-.11.68.19-1.33.03-.58.14-1.54-.07.64-.1.15-.19,1.05,0-.11.07-.5.09-.81-.12.51-.07-.35-.16-.18-.02.17-.05.44-.1.7l.08-.88c-.02.08-.15,1-.09.4-.02.15-.04.37-.06.42-.01-.86-.35.66-.26-.95-.03.34-.05.37-.06.38,0,.08-.06.43-.09.67l.04-.66c-.1.65-.06.04-.16.66l.03-.11c-.13.74-.2,1.65-.33,2.6.14-.84-.1,1.25.1.05-.02.19-.05.3-.08.53.07-.41.09-.49.09-.3l-.02.1c.08-.09.05.31.09.59l.06-.47c0,.06,0,.21-.02.33.12-.71-.04-.05.08-.83-.11.96.11.03-.02,1.12.02,0,.07-.54.09-.53l-.03.29.06-.38c0,.06-.03.43-.07.68,0-.03-.02.07-.03.09-.03.35.08-.11.07,0v-.18c.11-.27.14.13.28-.46l.02-.22c.11-.4,0,.25.09.07v.05c.03-.22.06-.33.07-.3-.05.26-.04.51-.1.79.11-.43.07-.34.22-1.16l-.04.37c.06-.33.08-.51.12-.6-.06.31-.06.56-.14.98-.05.81.19-.8.06.38.16-1.01.02-.57.07-.79.03-.33.12-.76.13-.65.02.02-.14,1.31-.09,1.29,0,0-.01.07-.02.07-.02.26.08-.35.05.08.09-.61.02.04.13-.75l-.07.18c.05-.2.19-1.12.18-.67-.03.16-.07.36-.09.48-.02.23.04-.15.02.09-.11.79-.07.16-.18.76-.03.33.12-.56,0,.29.16-1.08.03.14.17-.68l-.06.47c.01-.07.05-.29.06-.28l-.1.61c.09-.52,0,.46.05.18-.05,0,.06-.57.09-.91.15-.62-.12,1.24-.02,1.02-.02.06,0-.29.04-.5,0,.1,0,.28-.03.53.06-.09.06-.48.11-.77-.06.58.05-.23.1-.41l-.06.48c.01.31.14-1,.14-.62l-.11.66.05-.17-.08.54c.08-.4.07-.29.08-.14.04-.34.12-.87.14-.88-.02.29-.07.45-.03.39-.05.3-.1.67-.06.23-.02.16-.04.3-.07.45-.02.33.03.08.05.08,0-.02,0-.04,0-.11l.13-.66c-.02.18-.04.32-.06.46.02-.05.05-.27.07-.31-.05.39-.1.79-.15.97l.1-.43c-.02.17-.04.47-.06.61,0,.23.16-.75.16-.44.01-.08.02-.15.04-.2.02.09-.01.57.09.04l-.07.7c.05-.15.08-.88.16-1.14.06-.22-.06.6-.07.79.06-.35.18-1.06.14-.49-.03.13-.02.03-.04.08ZM639.94,49.89c-.02.1-.07.41-.04.12.08-.55.05-.28.04-.12ZM640.64,48.81c-.02.16-.02.08-.01-.1.01-.04.02-.02.01.1ZM642.56,45.66s0,.01,0,.02c0-.19,0-.11,0-.02ZM642.57,45.87l.02-.2c-.02.12-.02.13-.03.09-.01.13-.02.21,0,.11ZM639.08,45.64v.13c-.04.14-.02.01,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M640.5,49.46c0-.08.02-.17.03-.26-.01.08-.02.17-.03.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "639.27 50.38 639.27 50.37 639.26 50.46 639.27 50.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M641.6,49.87c0-.07,0-.16.02-.25-.01.12-.02.22-.02.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.83,45.08l-.03.12s0,.08,0,.16c.01-.11.03-.27.03-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.68,48.07c0-.06,0,0,.02-.06l.02-.22s-.04.19-.04.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.67,46.67c-.04.4-.01.27,0,.2h0c.07-.56.03-.38,0-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.68,46.85s.01-.03.01,0c.03-.23,0-.05-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.64,45.61c0,.1.06-.52.05-.35.06-.51-.11.62-.05.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "642.54 48 642.59 47.5 642.53 47.9 642.54 48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.46,47.62v.14c.02-.08.03-.13.03-.17-.01-.02-.02-.12-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.49,47.59s.01,0,.03-.08c0,0-.02.02-.03.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "642.49 48.15 642.49 48.04 642.48 48 642.49 48.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.22,47.5l-.04.14c-.02.17-.03.28,0,.21.02-.12.04-.18.05-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.15,48.87c0-.1.02-.22.03-.38l-.07.62.04-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M642.05,49c-.02.17-.09.49-.06.45.02-.17.06-.31.06-.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "641.76 48.18 641.76 48.17 641.88 47.16 641.76 48.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M641.14,50.55c0,.25.08-.62.07-.32.04-.24,0-.25.04-.46-.05.25-.04.11-.11.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M641.25,49.78s.02-.09.03-.15c-.01.06-.02.11-.03.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "637.98 44.98 637.99 44.77 637.95 45.11 637.98 44.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M637.84,45.73l.08-.64-.09.58s.02-.08,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M639.83,51.2l.02-.15c.02-.17.01-.18,0-.21l-.03.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "HearFromYou-4",
    points: "639.63 50.68 639.63 50.7 639.69 50.11 639.63 50.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-4",
    d: "M639.31,51.4s.03-.1.04-.08c-.03.1.05-.65-.04.08Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M164.26,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M164.16,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16.16-.57.32-1.14.48-1.71.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16-.16.57-.32,1.14-.48,1.71l.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M166.94,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M167.04,217.24c.37-2.81.75-5.63,1.12-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.37,2.81-.75,5.63-1.12,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M168.99,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M168.89,201.84c-.22,1.68-.45,3.36-.67,5.05l-.1.72c-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05l.1-.72c.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M175.34,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M175.24,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M180.07,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M179.97,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M178.02,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M178.12,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M186.42,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M186.33,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M189.1,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M189.2,217.24c.37-2.81.75-5.63,1.12-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.37,2.81-.75,5.63-1.12,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M191.16,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M191.06,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M197.5,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M197.41,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16.16-.57.32-1.14.48-1.71.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16-.16.57-.32,1.14-.48,1.71l.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M200.19,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M200.29,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M202.24,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M202.14,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M208.59,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M208.49,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M211.27,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M211.37,217.24c.38-2.81.75-5.63,1.13-8.44l.16-1.2c.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44l-.16,1.2c-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M213.32,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M213.22,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M219.67,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M219.57,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16.16-.57.32-1.14.48-1.71.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16-.16.57-.32,1.14-.48,1.71l.2.03c-.06-4.84,1.76-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M222.35,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M222.45,217.24c.38-2.81.75-5.63,1.13-8.44l.16-1.2c.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44l-.16,1.2c-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M224.4,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M224.3,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M230.75,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M230.65,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16.16-.57.32-1.14.48-1.71.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16-.16.57-.32,1.14-.48,1.71l.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M233.43,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M233.53,217.24c.37-2.81.75-5.63,1.12-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.37,2.81-.75,5.63-1.12,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M235.48,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M235.38,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M241.83,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M241.74,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16.16-.57.32-1.14.48-1.71.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16-.16.57-.32,1.14-.48,1.71l.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M244.51,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M244.61,217.24c.37-2.81.75-5.63,1.12-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.37,2.81-.75,5.63-1.12,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M246.57,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M246.47,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M252.92,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M252.82,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16.16-.57.32-1.14.48-1.71.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16-.16.57-.32,1.14-.48,1.71l.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M255.6,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M255.7,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M257.65,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M257.55,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M264,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M263.9,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16.16-.57.32-1.14.48-1.71.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16-.16.57-.32,1.14-.48,1.71l.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M268.73,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M268.63,201.84c-.22,1.68-.45,3.36-.67,5.05l-.1.72c-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05l.1-.72c.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M266.68,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M266.78,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M275.08,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M274.98,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M277.76,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M277.86,217.24c.37-2.81.75-5.63,1.12-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.37,2.81-.75,5.63-1.12,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M279.81,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M279.71,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M286.16,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M286.07,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M288.84,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M288.94,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M290.9,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M290.8,201.84c-.22,1.68-.45,3.36-.67,5.05l-.1.72c-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05l.1-.72c.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M297.24,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M297.15,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16.16-.57.32-1.14.48-1.71.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16-.16.57-.32,1.14-.48,1.71l.2.03c-.06-4.84,1.76-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M299.92,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M300.02,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M301.98,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M301.88,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M308.33,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M308.23,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.76-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M311.01,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M311.11,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M313.06,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M312.96,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M319.41,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M319.31,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M322.09,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M322.19,217.24c.37-2.81.75-5.63,1.12-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.37,2.81-.75,5.63-1.12,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M324.14,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M324.04,201.84c-.22,1.68-.45,3.36-.67,5.05l-.1.72c-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05l.1-.72c.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M330.49,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M330.39,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M333.17,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M333.27,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M335.22,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M335.12,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M341.57,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M341.48,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16.16-.57.32-1.14.48-1.71.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16-.16.57-.32,1.14-.48,1.71l.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M344.25,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M344.35,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M346.31,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M346.21,201.84c-.22,1.68-.45,3.36-.67,5.05l-.1.72c-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05l.1-.72c.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M352.65,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M352.56,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M357.39,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M357.29,201.84c-.22,1.68-.45,3.36-.67,5.05l-.1.72c-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05l.1-.72c.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M355.34,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M355.44,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M363.74,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M363.64,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.76-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M368.47,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M368.37,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M366.42,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M366.52,217.24c.37-2.81.75-5.63,1.12-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.37,2.81-.75,5.63-1.12,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M374.82,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M374.72,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M379.55,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M379.45,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M377.5,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M377.6,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M385.9,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M385.8,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16.16-.57.32-1.14.48-1.71.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16-.16.57-.32,1.14-.48,1.71l.2.03c-.06-4.84,1.76-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M388.58,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M388.68,217.24c.37-2.81.75-5.63,1.12-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.37,2.81-.75,5.63-1.12,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M390.63,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M390.53,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M396.98,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M396.89,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M399.66,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M399.76,217.24c.37-2.81.75-5.63,1.12-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.37,2.81-.75,5.63-1.12,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M401.72,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M401.62,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M408.07,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M407.97,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M410.75,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M410.85,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M412.8,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M412.7,201.84c-.22,1.68-.45,3.36-.67,5.05l-.1.72c-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05l.1-.72c.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M419.15,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M419.05,201.81c-1.71,4.47-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M421.83,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M421.93,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M423.88,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M423.78,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M430.23,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M430.13,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M432.91,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M433.01,217.24c.38-2.81.75-5.63,1.13-8.44l.16-1.2c.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44l-.16,1.2c-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M434.96,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M434.86,201.84c-.22,1.68-.45,3.36-.67,5.05l-.1.72c-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05l.1-.72c.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M441.31,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M441.22,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M443.99,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M444.09,217.24c.38-2.81.75-5.63,1.13-8.44l.16-1.2c.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44l-.16,1.2c-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M446.05,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M445.95,201.84c-.22,1.68-.45,3.36-.67,5.05l-.1.72c-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05l.1-.72c.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M452.39,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M452.3,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.76-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M455.08,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M455.18,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M457.13,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M457.03,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M463.48,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M463.38,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M466.16,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M466.26,217.24c.38-2.81.75-5.63,1.13-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.38,2.81-.75,5.63-1.13,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M468.21,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M468.11,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.9-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M474.56,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M474.46,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.76-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M477.24,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M477.34,217.24c.37-2.81.75-5.63,1.12-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.37,2.81-.75,5.63-1.12,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M479.29,201.84l-.77,5.76c.78-1.93,1.51-3.87,1.63-5.76h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M479.19,201.84c-.22,1.68-.45,3.36-.67,5.05-.03.24-.06.48-.1.72-.02.12.16.12.2.03.75-1.86,1.49-3.77,1.63-5.79,0-.05-.05-.1-.1-.1h-.86c-.13,0-.13.2,0,.2h.86l-.1-.1c-.14,2-.89,3.89-1.63,5.74l.2.03c.22-1.68.45-3.36.67-5.05.03-.24.06-.48.1-.72.02-.13-.18-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M485.64,201.84c-.08.22-.17.44-.25.66-1.65,4.3-3.31,8.69-3.22,13.22l3.88-13.87h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M485.54,201.81c-1.71,4.46-3.54,9.04-3.48,13.9,0,.11.17.14.2.03,1.13-4.05,2.26-8.11,3.4-12.16l.48-1.71c.02-.06-.03-.13-.1-.13h-.4c-.13,0-.13.2,0,.2h.4l-.1-.13c-1.13,4.05-2.26,8.11-3.4,12.16l-.48,1.71.2.03c-.06-4.84,1.77-9.4,3.47-13.85.05-.12-.15-.17-.19-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M488.32,217.24l1.28-9.64c-1.32,3.3-2.73,6.59-1.28,9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "HearFromYou-1",
    d: "M488.42,217.24c.37-2.81.75-5.63,1.12-8.44.05-.4.11-.8.16-1.2.02-.12-.16-.12-.2-.03-1.22,3.05-2.75,6.49-1.27,9.72.05.12.23.02.17-.1-1.45-3.17.1-6.59,1.29-9.57l-.2-.03c-.37,2.81-.75,5.63-1.12,8.44-.05.4-.11.8-.16,1.2-.02.13.18.13.2,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearFromYou);
export default __webpack_public_path__ + "static/media/HearFromYou.cc84edb3d3d990d17095a1544b001ea8.svg";
export { ForwardRef as ReactComponent };